<!-- eslint-disable vue/html-self-closing -->
<template>
	<div v-if="projectFieldOption" class="animated profile">
		<!-- Personal data -->
		<div v-if="!allMandatoryIsFilled" class="alert alert-warning">
			{{ FormMSG(55055, 'Field with * are mandatory field you must fill. Some field are still empty.') }}
		</div>
		<div class="card-collapsible">
			<div
				class="header-card-collapsible inside d-flex flex-row align-items-center bgc-grey-light cursor-pointer"
				@click="handleClickHeader('personnal-data')"
			>
				<div class="title w-90">
					<b-icon icon="person-check-fill" style="color: rgba(6, 38, 62, 0.84)" /><span class="ml-3">{{ FormMSG(1, 'Personal data') }}</span>
				</div>
				<div class="d-flex justify-content-end w-10">
					<b-button v-if="personalDataMandatoryCount > 0" pill variant="warning" class="mr-2">
						{{ personalDataMandatoryCount + ' ' + FormMSG(2365, 'field(s) left') }}
					</b-button>
					<component :is="getIconLucide('ChevronDown')" v-if="!configAccordion['personnal-data'].isVisible" color="#06263E" :size="22" />
					<component :is="getIconLucide('ChevronUp')" v-if="configAccordion['personnal-data'].isVisible" color="#06263E" :size="22" />
				</div>
			</div>
			<b-collapse :visible="configAccordion['personnal-data'].isVisible">
				<div class="content-card-collapsible">
					<b-row>
						<b-col sm="8" md="8" lg="9" xl="9">
							<b-row>
								<b-col sm="12" md="12" lg="4" xl="4">
									<b-form-group>
										<label for="reference"> {{ FormMSG(2, 'Reference') }} </label>
										<b-form-input
											id="reference"
											v-model="profile.reference"
											type="text"
											:placeholder="FormMSG(3, 'Enter your personal number.')"
											:disabled="isFilmSingleUserFree || isFilmSingleUser"
										/>
									</b-form-group>
								</b-col>
								<b-col sm="12" md="12" lg="4" xl="4">
									<b-form-group>
										<label for="email">
											{{ FormMSG(4, 'Email') }} <span class="required">{{ projectFieldOption.mandatoryEmail ? ' *' : '' }}</span>
										</label>
										<b-input-group>
											<b-form-input
												id="email"
												:value="profile.email"
												type="text"
												:placeholder="FormMSG(5, 'Enter your email')"
												disabled
												:class="{ 'is-invalid': projectFieldOption.mandatoryEmail && profile.email.length === 0 }"
											/>
											<b-input-group-append v-if="isFilmSingleUserFree || isFilmSingleUser">
												<b-input-group-text class="cursor-pointer" @click="showChangeMailModal = true">
													<component :is="getIconLucide('Pencil')" color="#007A77" :size="16" />
												</b-input-group-text>
											</b-input-group-append>
										</b-input-group>
									</b-form-group>
								</b-col>
								<b-col v-if="projectFieldOption.usePhone" sm="12" md="12" lg="4" xl="4">
									<b-form-group>
										<label for="phone">
											{{ FormMSG(276, 'Phone') }} <span class="required">{{ projectFieldOption.mandatoryPhone ? ' *' : '' }}</span>
										</label>
										<b-input-group>
											<b-form-input
												id="phone"
												:value="profile.phone"
												type="text"
												disabled
												:placeholder="FormMSG(7, 'Enter your phone number')"
												:class="{ 'is-invalid': projectFieldOption.mandatoryPhone && profile.phone.length === 0 }"
											/>
											<b-input-group-append v-if="isFilmSingleUserFree || isFilmSingleUser">
												<b-input-group-text class="cursor-pointer" @click="showChangePhoneModal = true">
													<component :is="getIconLucide('Pencil')" color="#007A77" :size="16" />
												</b-input-group-text>
											</b-input-group-append>
										</b-input-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col v-if="projectFieldOption.useFirstName" sm="12" md="12" lg="3" xl="3">
									<b-form-group>
										<label for="firstname">
											{{ FormMSG(8, 'First Name') }}
											<span class="required">{{ projectFieldOption.mandatoryFirstName ? ' *' : '' }}</span>
										</label>
										<b-form-input
											id="firstname"
											v-model="profile.firstName"
											v-mask-name
											type="text"
											:placeholder="FormMSG(9, 'Enter your first name.')"
											:class="{ 'is-invalid': projectFieldOption.mandatoryFirstName && profile.firstName.length === 0 }"
											autocomplete="off"
											@change="handleChangeUser(profile.firstName, 'firstName')"
											@copy.prevent
											@paste.prevent
										/>
									</b-form-group>
								</b-col>
								<b-col v-if="projectFieldOption.useLastName" sm="12" md="12" lg="3" xl="3">
									<b-form-group>
										<label for="name">
											{{ FormMSG(10, 'Last Name') }} <span class="required">{{ projectFieldOption.mandatoryLastName ? ' *' : '' }}</span>
										</label>
										<b-form-input
											id="name"
											v-model="profile.name"
											v-mask-name
											type="text"
											:placeholder="FormMSG(11, 'Enter your name.')"
											:class="{ 'is-invalid': projectFieldOption.mandatoryLastName && profile.name.length === 0 }"
											autocomplete="off"
											@change="handleChangeUser(profile.name, 'name')"
											@copy.prevent
											@paste.prevent
										/>
									</b-form-group>
								</b-col>
								<b-col v-if="projectFieldOption.useMaidenName" sm="12" md="12" lg="3" xl="3">
									<b-form-group>
										<label for="maidenName">
											{{ FormMSG(1239, ' Maiden name (if different)') }}
											<span class="required">{{ projectFieldOption.mandatoryMaidenName ? ' *' : '' }}</span>
										</label>
										<b-form-input
											id="maidenName"
											v-model="profile.maidenName"
											type="text"
											:class="{ 'is-invalid': projectFieldOption.mandatoryMaidenName && profile.maidenName.length === 0 }"
											@change="handleChangeUser(profile.maidenName, 'maidenName')"
										/>
									</b-form-group>
								</b-col>
								<b-col v-if="projectFieldOption.useColor" sm="12" md="12" lg="3" xl="3" class="d-flex justify-content-start">
									<b-form-group>
										<label>
											{{ FormMSG(86, 'Color') }} <span class="required">{{ projectFieldOption.mandatoryColor ? ' *' : '' }}</span>
										</label>
										<div class="w-100 d-flex justify-content-start">
											<verte v-model="profile.color" picker="square" model="hex" menu-position="left" />
										</div>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col v-if="projectFieldOption.useNationality" sm="12" md="12" lg="3" xl="3">
									<b-form-group>
										<label for="nationality">
											{{ FormMSG(12, 'Nationality') }}
											<span class="required">{{ projectFieldOption.mandatoryNationality ? ' *' : '' }}</span>
										</label>
										<b-form-input
											id="nationality"
											v-model="profile.nationality"
											type="text"
											:placeholder="FormMSG(13, 'Enter your nationality')"
											:class="{ 'is-invalid': projectFieldOption.mandatoryNationality && profile.nationality.length === 0 }"
											@change="handleChangeUser(profile.nationality, 'nationality')"
										/>
									</b-form-group>
								</b-col>
								<b-col v-if="projectFieldOption.useLanguage" sm="12" md="12" lg="3" xl="3">
									<b-form-group>
										<label for="optionsForLanguages">
											{{ FormMSG(14, 'Langue') }} <span class="required">{{ projectFieldOption.mandatoryLanguage ? ' *' : '' }}</span>
										</label>
										<b-form-select
											id="optionsForLanguages"
											v-model="profile.language"
											:options="optionsForLanguages"
											:class="{ 'is-invalid': projectFieldOption.mandatoryLanguage && profile.language.length === 0 }"
											@change="handleChangeUser(profile.language, 'language')"
										/>
									</b-form-group>
								</b-col>
								<b-col v-if="projectFieldOption.useGender" sm="12" md="12" lg="3" xl="3">
									<b-form-group>
										<label for="gender">
											{{ FormMSG(20, 'Gender') }}
											<span class="required">{{ projectFieldOption.mandatoryGender || useDpae ? ' *' : '' }}</span>
										</label>

										<b-form-select
											id="gender"
											v-model="profile.gender"
											:class="{ 'is-invalid': projectFieldOption.mandatoryGender && profile.gender === 0 }"
											@change="handleChangeUser(profile.gender, 'gender')"
										>
											<b-form-select-option v-for="(gender, index) in menuGenders" :key="index" :value="gender.value">
												{{ gender.text }}
											</b-form-select-option>
										</b-form-select>
									</b-form-group>
								</b-col>
								<b-col v-if="projectFieldOption.useTitle" sm="12" md="12" lg="3" xl="3">
									<b-form-group>
										<label for="title">
											{{ FormMSG(1240, 'Title') }} <span class="required">{{ projectFieldOption.mandatoryTitle ? ' *' : '' }}</span>
										</label>
										<b-form-select
											id="title"
											v-model="profile.title"
											:class="{ 'is-invalid': projectFieldOption.mandatoryTitle && profile.title === 0 }"
											@change="handleChangeUser(profile.title, 'title')"
										>
											<b-form-select-option v-for="(title, index) in menuTitle" :key="index" :value="title.value">
												{{ title.text }}
											</b-form-select-option>
										</b-form-select>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col v-if="projectFieldOption.useBirthdate" sm="12" md="12" lg="3" xl="3">
									<b-form-group>
										<label for="birthDate">
											{{ FormMSG(15, 'Birthdate') }}
											<span class="required">{{ isMandatory('Birthdate') || useDpae ? ' *' : '' }}</span>
										</label>
										<v-date-picker
											v-model="profile.birthDate"
											:locale="lang"
											:masks="masks"
											:attributes="attrs"
											@dayclick="(payload) => handleInputCalendar(payload, 'birthDate')"
										>
											<template #default="{ inputValue, togglePopover }">
												<b-input-group>
													<b-form-input
														v-mask="'##/##/####'"
														:value="inputValue"
														:placeholder="FormMSG(8960, 'DD/MM/YYYY')"
														readonly
														:class="{
															'is-invalid': isMandatory('Birthdate') && !isDateValid('birthDate')['birthDate']
														}"
														@click="togglePopover()"
														@change="(value) => handleChangeDate(value, 'birthDate')"
														@keydown.enter.prevent
													/>
													<b-input-group-append>
														<b-input-group-text
															class="cursor-pointer bg-color-white input-group-text-bg-white"
															:class="{
																'is-invalid': isMandatory('Birthdate') && !isDateValid('birthDate')['birthDate']
															}"
															@click="togglePopover()"
														>
															<component
																:is="getLucideIcon('Calendar')"
																color="rgba(6, 38, 62, .6)"
																:size="18"
																:stroke-width="2.25"
															/>
														</b-input-group-text>
													</b-input-group-append>
												</b-input-group>
												<!-- <div v-if="isMandatory('Birthdate') && !isDateValid('birthDate')['birthDate']" class="invalid-feedback">
															{{ FormMSG(897, 'Birthdate is required') }}
														</div> -->
											</template>
										</v-date-picker>
									</b-form-group>
								</b-col>
								<b-col v-if="projectFieldOption.usePlaceOfBirth" sm="12" md="12" lg="3" xl="3">
									<b-form-group>
										<label for="placeOfBirth">
											{{ FormMSG(16, 'Place of birth') }}
											<span class="required">{{ projectFieldOption.mandatoryPlaceOfBirth || useDpae ? ' *' : '' }}</span>
										</label>
										<b-form-input
											id="placeOfBirth"
											v-model="profile.placeOfBirth"
											type="text"
											:placeholder="FormMSG(17, 'Place of birth')"
											autocomplete="off"
											:class="{ 'is-invalid': projectFieldOption.mandatoryPlaceOfBirth && profile.placeOfBirth.length <= 0 }"
											@change="handleChangeUser(profile.placeOfBirth, 'placeOfBirth')"
										/>
									</b-form-group>
								</b-col>
								<b-col v-if="projectFieldOption.useCityOfBirthZip" sm="12" md="12" lg="3" xl="3">
									<b-form-group>
										<label for="placeOfBirthZip">
											{{ FormMSG(18, 'Place of birth ZIP') }}
											<span class="required">{{ projectFieldOption.mandatoryCityOfBirthZip ? ' *' : '' }}</span>
										</label>
										<b-form-input
											id="placeOfBirthZip"
											v-model="profile.placeOfBirthZip"
											type="text"
											:placeholder="FormMSG(19, 'Place of birth zip')"
											:class="{ 'is-invalid': projectFieldOption.mandatoryCityOfBirthZip && profile.placeOfBirthZip.length === 0 }"
											@change="handleChangeUser(profile.placeOfBirthZip, 'placeOfBirthZip')"
										/>
									</b-form-group>
								</b-col>
								<b-col v-if="projectFieldOption.useCountryOfBirth" sm="12" md="12" lg="3" xl="3">
									<b-form-group>
										<label for="countryOfBirth">
											{{ FormMSG(1241, 'Country of birth') }}
											<span class="required">{{ projectFieldOption.mandatoryCountryOfBirth ? ' *' : '' }}</span>
										</label>
										<b-form-input
											id="countryOfBirth"
											v-model="profile.birthCountry"
											:placeholder="FormMSG(1315, 'Enter your country of ...')"
											:class="{
												'is-invalid':
													projectFieldOption.mandatoryCountryOfBirth && (!profile.birthCountry || profile.birthCountry.length === 0)
											}"
											@change="handleChangeUser(profile.birthCountry, 'birthCountry')"
										/>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row v-if="isDeterProject === true">
								<b-col sm="12" md="12" lg="3" xl="3">
									<b-form-group :label="FormMSG(12410, 'Custom function name')">
										<b-form-input v-model="profile.customFunctionName" :placeholder="profile.functionName" />
									</b-form-group>
								</b-col>
							</b-row>
						</b-col>
						<b-col class="text-center" sm="4" md="4" lg="3" xl="3">
							<div class="profile-picture-block">
								<b-form-group v-if="projectFieldOption.useProfilePicture" v-model="profile.picture" v-lazy-container="{ selector: 'img' }">
									<img
										:data-src="imageName"
										data-error="img/brand/avatar.jpg"
										data-loading="img/brand/tenor.gif"
										class="profile-picture-preview"
										alt="pict"
									/>
									<label>
										<span class="required">{{ projectFieldOption.mandatoryProfilePicture ? ' *' : '' }}</span>
									</label>
								</b-form-group>
								<b-form-group v-if="isFilmSingleUserFree || isFilmSingleUser">
									<b-button v-if="!$isPwa()" variant="outline-secondary" size="md" @click="startCapture">
										<i class="icon-camera" />
										{{ FormMSG(21, 'Change your picture') }}
									</b-button>
									<MobileProfilePicCaptureBtn
										v-if="$isPwa()"
										:label-button="FormMSG(22, 'Change your picture')"
										parent-type="user"
										:parent-id="profile.id"
										@change="handleImgsTaked"
									/>
								</b-form-group>
							</div>
							<ShareInformation
								v-if="isFilmSingle"
								:btn-label="FormMSG(23, 'Share my Information')"
								:title-modal="FormMSG(24, 'Send your personal informations sheet')"
								:msg-success="FormMSG(25, 'Profile successfully sent')"
								show-check-memo-deal
								send-a-copy
							/>
						</b-col>
					</b-row>
				</div>
			</b-collapse>
		</div>
		<!-- Identification-->
		<div v-if="isIdentificationSectionVisible" class="card-collapsible mt-3">
			<div class="cursor-pointer header-card-collapsible d-flex flex-row align-items-center" @click="handleClickHeader('identification')">
				<div class="title w-90">
					<b-icon icon="person-lines-fill" style="color: rgba(6, 38, 62, 0.84)" /><span class="ml-3">{{ FormMSG(278, 'Identification') }}</span>
				</div>
				<div class="d-flex justify-content-end w-10">
					<b-button v-if="identificationMandatoryCount > 0" pill variant="warning" class="mr-2">
						{{ identificationMandatoryCount + ' ' + FormMSG(2365, 'field(s) left') }}
					</b-button>
					<component :is="getIconLucide('ChevronDown')" v-if="!configAccordion['identification'].isVisible" color="#06263E" :size="22" />
					<component :is="getIconLucide('ChevronUp')" v-if="configAccordion['identification'].isVisible" color="#06263E" :size="22" />
				</div>
			</div>
			<b-collapse :visible="configAccordion['identification'].isVisible">
				<div class="sub-title">
					{{ FormMSG(27, 'Identification Numbers') }}
				</div>
				<div class="content-card-collapsible">
					<b-row>
						<b-col v-if="projectFieldOption.useNationalRegistrationNumber" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="nationalRegistryNumber">
									{{ FormMSG(30, 'National Registration Number') }}
									<span class="required">{{ projectFieldOption.mandatoryNationalRegistrationNumber ? ' *' : '' }}</span>
								</label>
								<InputMask
									id="nationalRegistryNumber"
									v-model="profile.nationalRegistryNumber"
									class="form-control"
									mask="99.99.99-999-99"
									:placeholder="FormMSG(31, 'Enter your National Registration Number ')"
									:class="{
										'is-invalid': projectFieldOption.mandatoryNationalRegistrationNumber && profile.nationalRegistryNumber.length <= 0
									}"
									@change="handleChangeUser(profile.nationalRegistryNumber, 'nationalRegistryNumber')"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useCompanyNumber" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="companyNumber">
									{{ FormMSG(32, 'Company Number') }}
									<span class="required">{{ projectFieldOption.mandatoryCompanyNumber ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="companyNumber"
									v-model="profile.companyNumber"
									type="text"
									:placeholder="FormMSG(33, 'Enter your Company official Number ')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryCompanyNumber && profile.companyNumber.length <= 0 }"
									@change="handleChangeUser(profile.companyNumber, 'companyNumber')"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useCongesSpectacleId" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="conge_spectacles_id">
									{{ FormMSG(1242, '"Congés spectacles" ID') }}
									<span class="required">{{ projectFieldOption.mandatoryCongesSpectacleId ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="conge_spectacles_id"
									v-model="profile.congesSpectacle"
									type="text"
									:placeholder="FormMSG(1243, 'Enter your conges spectacles id')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryCongesSpectacleId && profile.congesSpectacle.length <= 0 }"
									@change="handleChangeUser(profile.congesSpectacle, 'congesSpectacle')"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useSignaturePicture" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="signatureId">
									{{ FormMSG(106, 'Signature') }}
									<span class="required">{{ projectFieldOption.mandatorySignaturePicture ? ' *' : '' }}</span>
								</label>
								<b-row class="ml-0">
									<div
										v-if="checkFile(profile.signatureId)"
										class="d-flex justify-content-center align-items-center cursor-pointer"
										@click="onOpenUrl(getImage(profile.signatureId, 'signatureId'))"
									>
										<b-icon icon="file-earmark-pdf-fill" :font-scale="1.6" />
									</div>
									<b-img
										v-else
										v-bind="imgPropSignatureId"
										rounded="circle"
										alt="Signature"
										class="cursor-pointer"
										:src="getImage(profile.signatureId, 'signatureId')"
										@click="showImage(profile.signatureId)"
									/>
									<div
										v-if="projectFieldOption.mandatorySignaturePicture && profile.signatureId.length === 0"
										class="d-flex align-items-center"
									>
										<b-button
											v-b-tooltip.hover.bottom.html="FormMSG(4901, 'Signature empty')"
											size="sm"
											class="btn bg-transparent border-0"
										>
											<component :is="getIconLucide(ICONS.ALERT_TRIANGLE.name)" color="#ffc107" :size="30" />
										</b-button>
									</div>
								</b-row>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col v-if="projectFieldOption.useIdName" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="idNumber">
									{{ FormMSG(99, 'ID Name') }} <span class="required">{{ projectFieldOption.mandatoryIdName ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="idNumber"
									v-model="profile.idName"
									type="text"
									:placeholder="FormMSG(100, 'Enter your ID Name ...')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryIdName && profile.idName.length <= 0 }"
									@change="handleChangeUser(profile.idName, 'idName')"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useIdNumber" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="idNumber">
									{{ FormMSG(34, 'ID Number') }} <span class="required">{{ projectFieldOption.mandatoryIdNumber ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="idNumber"
									v-model="profile.idNumber"
									type="text"
									:placeholder="FormMSG(35, 'Enter your ID Number ...')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryIdNumber && profile.idNumber.length <= 0 }"
									@change="handleChangeUser(profile.idNumber, 'idNumber')"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useIdPictureFront" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="pictureId">
									{{ FormMSG(101, 'ID picture - Front') }}
									<span class="required">{{ projectFieldOption.mandatoryIdPictureFront ? ' *' : '' }}</span>
								</label>
								<b-row class="ml-0">
									<div
										v-if="checkFile(profile.pictureId)"
										class="d-flex justify-content-center align-items-center cursor-pointer"
										@click="onOpenUrl(getImage(profile.pictureId, 'pictureId'))"
									>
										<b-icon icon="file-earmark-pdf-fill" :font-scale="1.6" />
									</div>
									<b-img
										v-else
										v-bind="imgPropPictureId"
										rounded="circle"
										alt="ID picture - front"
										class="cursor-pointer"
										:src="getImage(profile.pictureId, 'pictureId')"
										@click="showImage(profile.pictureId)"
									/>
									<div v-if="projectFieldOption.mandatoryIdPictureFront && profile.pictureId.length === 0" class="d-flex align-items-center">
										<b-button
											v-b-tooltip.hover.bottom.html="FormMSG(4902, 'Picture front empty')"
											size="sm"
											class="btn bg-transparent border-0"
										>
											<component :is="getIconLucide(ICONS.ALERT_TRIANGLE.name)" color="#ffc107" :size="30" />
										</b-button>
									</div>
								</b-row>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useIdPictureBack" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="pictureIdVerso">
									{{ FormMSG(102, 'ID picture - Back') }}
									<span class="required">{{ projectFieldOption.mandatoryIdPictureBack ? ' *' : '' }}</span>
								</label>
								<b-row class="ml-0">
									<div
										v-if="checkFile(profile.pictureIdVerso)"
										class="d-flex justify-content-center align-items-center cursor-pointer"
										:class="{ 'is-invalid': projectFieldOption.mandatoryIdPictureBack && profile.pictureIdVerso.length <= 0 }"
										@click="onOpenUrl(getImage(profile.pictureIdVerso, 'pictureIdVerso'))"
									>
										<b-icon icon="file-earmark-pdf-fill" :font-scale="1.6" />
									</div>
									<b-img
										v-else
										v-bind="imgPropPictureIdVerso"
										rounded="circle"
										alt="ID picture - back"
										class="cursor-pointer"
										:src="getImage(profile.pictureIdVerso, 'pictureIdVerso')"
										@click="showImage(profile.pictureIdVerso)"
									/>
									<div
										v-if="projectFieldOption.mandatoryIdPictureBack && profile.pictureIdVerso.length === 0"
										class="d-flex align-items-center"
									>
										<b-button
											v-b-tooltip.hover.bottom.html="FormMSG(4903, 'Picture back empty')"
											size="sm"
											class="btn bg-transparent border-0"
										>
											<component :is="getIconLucide(ICONS.ALERT_TRIANGLE.name)" color="#ffc107" :size="30" />
										</b-button>
									</div>
								</b-row>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col v-if="projectFieldOption.useDriverLicense" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(36, 'Driver licence') }}
									<span class="required">{{ projectFieldOption.mandatoryDriverLicense ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.driverLicense"
									type="text"
									:placeholder="FormMSG(37, 'Enter your driver license')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryDriverLicense && profile.driverLicense.length <= 0 }"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useDriverLicenseNumber" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(1314, 'Driver licence Number') }}
									<span class="required">{{ projectFieldOption.mandatoryDriverLicenseNumber ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.driverLicenseNumber"
									type="text"
									:placeholder="FormMSG(1316, 'Enter your driver license number')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryDriverLicenseNumber && profile.driverLicenseNumber.length <= 0 }"
									@keydown.enter.prevent
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useDriverLicensePictureFront" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="idNumber">
									{{ FormMSG(103, 'Driver license picture - Front') }}
									<span class="required">{{ projectFieldOption.mandatoryDriverLicensePictureFront ? ' *' : '' }}</span>
								</label>
								<b-row class="ml-0">
									<div
										v-if="checkFile(profile.pictureDriverLicense)"
										class="d-flex justify-content-center align-items-center cursor-pointer"
										@click="onOpenUrl(getImage(profile.pictureDriverLicense, 'pictureDriverLicense'))"
									>
										<b-icon icon="file-earmark-pdf-fill" :font-scale="1.6" />
									</div>
									<b-img
										v-else
										v-bind="imgPropPictureDriverLicense"
										rounded
										alt="Driver license picture - Front"
										class="cursor-pointer"
										:src="getImage(profile.pictureDriverLicense, 'pictureDriverLicense')"
										@click="showImage(profile.pictureDriverLicense)"
									/>
									<div
										v-if="projectFieldOption.mandatoryDriverLicensePictureFront && profile.pictureDriverLicense.length === 0"
										class="d-flex align-items-center"
									>
										<b-button
											v-b-tooltip.hover.bottom.html="FormMSG(4905, 'Picture driver license front empty')"
											size="sm"
											class="btn bg-transparent border-0"
										>
											<component :is="getIconLucide(ICONS.ALERT_TRIANGLE.name)" color="#ffc107" :size="30" />
										</b-button>
									</div>
								</b-row>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useDriverLicensePictureBack" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="idNumber">
									{{ FormMSG(104, 'Driver license picture - Back') }}
									<span class="required">{{ projectFieldOption.mandatoryDriverLicensePictureBack ? ' *' : '' }}</span>
								</label>
								<b-row class="ml-0">
									<div
										v-if="checkFile(profile.pictureDriverLicenseVerso)"
										class="d-flex justify-content-center align-items-center cursor-pointer"
										:class="{
											'is-invalid': projectFieldOption.mandatoryDriverLicensePictureBack && profile.pictureDriverLicenseVerso.length <= 0
										}"
										@click="onOpenUrl(getImage(profile.pictureDriverLicenseVerso, 'pictureDriverLicenseVerso'))"
									>
										<b-icon icon="file-earmark-pdf-fill" :font-scale="1.6" />
									</div>
									<b-img
										v-else
										v-bind="imgPropPictureDriverLicenseVerso"
										rounded
										alt="Driver license picture - Front"
										class="cursor-pointer"
										:src="getImage(profile.pictureDriverLicenseVerso, 'pictureDriverLicenseVerso')"
										@click="showImage(profile.pictureDriverLicenseVerso)"
									/>
									<div
										v-if="projectFieldOption.mandatoryDriverLicensePictureBack && profile.pictureDriverLicenseVerso.length === 0"
										class="d-flex align-items-center"
									>
										<b-button
											v-b-tooltip.hover.bottom.html="FormMSG(4904, 'Picture driver license back empty')"
											size="sm"
											class="btn bg-transparent border-0"
										>
											<component :is="getIconLucide(ICONS.ALERT_TRIANGLE.name)" color="#ffc107" :size="30" />
										</b-button>
									</div>
								</b-row>
							</b-form-group>
						</b-col>
					</b-row>
				</div>
			</b-collapse>
		</div>
		<div v-if="isFinanceSectionVisible" class="card-collapsible mt-3">
			<div class="cursor-pointer header-card-collapsible d-flex flex-row align-items-center" @click="handleClickHeader('finance')">
				<div class="title w-90">
					<component :is="getLucideIcon('Wallet')" color="rgba(6, 38, 62, 0.84)" :size="22" />
					<span class="ml-3">{{ FormMSG(1244, 'Finance') }}</span>
				</div>
				<div class="d-flex justify-content-end w-10">
					<b-button v-if="financeMandatoryCount > 0" pill variant="warning" class="mr-2">
						{{ financeMandatoryCount + ' ' + FormMSG(2365, 'field(s) left') }}
					</b-button>
					<component :is="getIconLucide('ChevronDown')" v-if="!configAccordion['finance'].isVisible" color="#06263E" :size="22" />
					<component :is="getIconLucide('ChevronUp')" v-if="configAccordion['finance'].isVisible" color="#06263E" :size="22" />
				</div>
			</div>
			<b-collapse :visible="configAccordion['finance'].isVisible">
				<div v-if="isBankInformationVisible" class="sub-title">
					{{ FormMSG(9000, 'Bank information') }}
				</div>
				<div v-if="isBankInformationVisible" class="content-card-collapsible">
					<b-row>
						<b-col v-if="projectFieldOption.useIban" sm="12" md="12" :lg="isDeterProject ? '4' : '6'" :xl="isDeterProject ? '4' : '6'">
							<b-form-group :class="{ 'is-warning': userBankWarning.iban }">
								<label for="iban">
									{{ FormMSG(4900, 'IBAN') }} <span class="required">{{ projectFieldOption.mandatoryIban ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="iban"
									v-model="profile.iban"
									type="text"
									:placeholder="FormMSG(5000, 'Enter your bank account number')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryIban && profile.iban.length <= 0 }"
									@input="handleSupplierIbanChange($event, 'iban')"
								/>
								<div v-if="userBankWarning.iban" class="warning-feedback">
									{{ FormMSG(97986, "IBAN seems not valid, please make sure it's corrrect") }}
								</div>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useBic" sm="12" md="12" lg="6" xl="6">
							<b-form-group :class="{ 'is-warning': userBankWarning.bic }">
								<label for="bic">
									{{ FormMSG(5100, 'BIC') }} <span class="required">{{ projectFieldOption.mandatoryBic ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="bic"
									v-model="profile.bic"
									type="text"
									:placeholder="FormMSG(5200, 'Enter your bank BIC')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryBic && profile.bic.length <= 0 }"
									@input="handleSupplierBicChange($event, 'bic')"
								/>
								<div v-if="userBankWarning.bic" class="warning-feedback">
									{{ FormMSG(909097987, "BIC seems not valid, please make sure it's corrrect") }}
								</div>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col v-if="projectFieldOption.useBankAccountOwnerName" sm="12" md="12" lg="6" xl="6">
							<b-form-group>
								<label for="bic">
									{{ FormMSG(1245, 'Bank account owner name') }}
									<span class="required">{{ projectFieldOption.mandatoryBankAccountOwnerName ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="bic"
									v-model="profile.bankAccountOwnerName"
									type="text"
									:placeholder="FormMSG(1246, 'Enter your bank account owner name')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryBankAccountOwnerName && profile.bankAccountOwnerName.length <= 0 }"
									@input="handleUserEntryLevelChange"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useBankDetailDocument" sm="12" md="12" lg="6" xl="6">
							<b-form-group>
								<label for="bankDetailDocument">
									{{ FormMSG(1247, 'Bank detail document') }}
									<span class="required">{{ projectFieldOption.mandatoryBankDetailDocument ? ' *' : '' }}</span>
								</label>
								<b-row class="ml-0">
									<div
										v-if="checkFile(profile.bankDetailXid)"
										class="d-flex justify-content-center align-items-center cursor-pointer"
										:class="{ 'is-invalid': projectFieldOption.mandatoryBankDetailDocument && profile.bankDetailXid.length <= 0 }"
										@click="onOpenUrl(getImage(profile.bankDetailXid, 'bankDetailXid'))"
									>
										<b-icon icon="file-earmark-pdf-fill" :font-scale="1.6" />
									</div>
									<b-img
										v-else
										v-bind="imgPropSignatureId"
										rounded
										alt="Bank detail document"
										class="cursor-pointer"
										:src="getImage(profile.bankDetailXid, 'bankDetailXid')"
										:title="FormMSG(254, 'View Image')"
										@click="showImage(profile.bankDetailXid)"
									/>
									<div
										v-if="projectFieldOption.mandatoryBankDetailDocument && profile.bankDetailXid.length === 0"
										class="d-flex align-items-center"
									>
										<b-button
											v-b-tooltip.hover.bottom.html="FormMSG(4906, 'Bank detail document empty')"
											size="sm"
											class="btn bg-transparent border-0"
										>
											<component :is="getIconLucide(ICONS.ALERT_TRIANGLE.name)" color="#ffc107" :size="30" />
										</b-button>
									</div>
								</b-row>
							</b-form-group>
						</b-col>
					</b-row>
				</div>
				<!-- Second bank information -->
				<div v-if="configAccordion['finance'].isVisible" class="sub-title">
					{{ FormMSG(1945, 'Expense Reimbursement Bank Information') }}
				</div>
				<div class="content-card-collapsible">
					<b-row>
						<b-col
							v-if="projectFieldOption.useSecondIban"
							sm="12"
							md="12"
							:lg="projectFieldOption.useSecondBankAccountOwnerName ? 6 : 4"
							:xl="projectFieldOption.useSecondBankAccountOwnerName ? 6 : 4"
						>
							<b-form-group label-for="iban" :class="{ 'is-warning': userBankWarning.secondIban }">
								<template slot="label">
									<label>{{ FormMSG(4900, 'IBAN') }}</label>
									<span v-if="projectFieldOption.mandatorySecondIban" class="required"> *</span>
								</template>
								<b-form-input
									id="secondIban"
									v-model="profile.secondIban"
									type="text"
									:placeholder="FormMSG(5000, 'Enter your bank account number')"
									:class="{ 'is-invalid': projectFieldOption.mandatorySecondIban && profile.secondIban.length <= 0 }"
									@input="handleSupplierIbanChange($event, 'secondIban')"
									@keydown.enter.prevent
								/>
								<div v-if="userBankWarning.secondIban" class="warning-feedback">
									{{ FormMSG(97986, "IBAN seems not valid, please make sure it's corrrect") }}
								</div>
							</b-form-group>
						</b-col>
						<b-col
							v-if="projectFieldOption.useSecondBic"
							sm="12"
							md="12"
							:lg="projectFieldOption.useSecondBankAccountOwnerName ? 6 : 4"
							:xl="projectFieldOption.useSecondBankAccountOwnerName ? 6 : 4"
						>
							<b-form-group :class="{ 'is-warning': userBankWarning.secondBic }">
								<template slot="label">
									<label>{{ FormMSG(5100, 'BIC') }}</label>
									<span v-if="projectFieldOption.mandatorySecondBic" class="required"> *</span>
								</template>
								<b-form-input
									id="secondBic"
									v-model="profile.secondBic"
									type="text"
									:placeholder="FormMSG(5200, 'Enter your bank BIC')"
									:class="{ 'is-invalid': projectFieldOption.mandatorySecondBic && profile.secondBic.length <= 0 }"
									@input="handleSupplierBicChange($event, 'secondBic')"
									@keydown.enter.prevent
								/>
								<div v-if="userBankWarning.secondBic" class="warning-feedback">
									{{ FormMSG(909097987, "BIC seems not valid, please make sure it's corrrect") }}
								</div>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col v-if="projectFieldOption.useSecondBankAccountOwnerName" sm="12" md="12" lg="6" xl="6">
							<b-form-group>
								<template slot="label">
									<label>{{ FormMSG(1245, 'Bank account owner name') }}</label>
									<span v-if="projectFieldOption.mandatorySecondBankAccountOwnerName" class="required"> *</span>
								</template>
								<b-form-input
									id="bic"
									v-model="profile.secondBankAccountOwnerName"
									type="text"
									:placeholder="FormMSG(1246, 'Enter your bank account owner name')"
									:class="{
										'is-invalid': projectFieldOption.mandatorySecondBankAccountOwnerName && profile.secondBankAccountOwnerName.length <= 0
									}"
									@keydown.enter.prevent
									@input="handleUserEntryLevelChange"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useSecondBankDetailDocument" sm="12" md="12" lg="6" xl="6">
							<b-form-group>
								<template slot="label">
									<label>{{ FormMSG(1247, 'Bank detail document') }}</label>
									<span v-if="projectFieldOption.mandatorySecondBankDetailDocument" class="required"> *</span>
								</template>
								<b-row class="ml-0">
									<b-img
										v-model="profile.secondBankDetailXid"
										v-bind="imgPropSignatureId"
										rounded
										alt="Bank detail document"
										class="cursor-pointer"
										:src="getImage(profile.secondBankDetailXid, 'secondBankDetailXid')"
										:title="FormMSG(254, 'View Image')"
										@click="showImage(profile.secondBankDetailXid)"
									/>
									<div
										v-if="checkFile(profile.bankSecondDetailXid)"
										class="d-flex justify-content-center align-items-center cursor-pointer"
										:class="{
											'is-invalid': projectFieldOption.mandatorySecondBankDetailDocument && profile.bankSecondDetailXid.length <= 0
										}"
										@click="onOpenUrl(getImage(profile.secondBankDetailXid, 'secondBankDetailXid'))"
									>
										<b-icon icon="file-earmark-pdf-fill" :font-scale="1.6" />
									</div>
									<div
										v-if="projectFieldOption.mandatorySecondBankDetailDocument && profile.secondBankDetailXid.length === 0"
										class="d-flex align-items-center"
									>
										<b-button
											v-b-tooltip.hover.bottom.html="FormMSG(4906, 'Bank detail document empty')"
											size="sm"
											class="btn bg-transparent border-0"
										>
											<component :is="getIconLucide(ICONS.ALERT_TRIANGLE.name)" color="#ffc107" :size="30" />
										</b-button>
									</div>
								</b-row>
							</b-form-group>
						</b-col>
					</b-row>
				</div>
				<!-- Second bank information -->
				<div v-if="isBankInformationVisible && isTaxesVisible" class="divider" />
				<div v-if="isTaxesVisible" class="sub-title">
					{{ FormMSG(26100, 'Taxes') }}
				</div>
				<div v-if="isTaxesVisible" class="content-card-collapsible">
					<b-row>
						<b-col v-if="projectFieldOption.useTaxes" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(26101, 'Taxe') }} <span class="required">{{ projectFieldOption.mandatoryTaxes ? ' *' : '' }}</span>
								</label>
								<b-input-group>
									<!--<b-form-input v-model="profile.taxesPercentage" type="number" step="1" min="0" max="100" v-limit-100 />-->
									<b-form-input
										v-model="profile.taxesPercentage"
										type="number"
										step="1"
										min="0"
										max="100"
										:class="{ 'is-invalid': projectFieldOption.mandatoryTaxes && profile.taxesPercentage === null }"
									/>
									<b-input-group-append>
										<b-input-group-text style="background-color: #00a09c">
											<component :is="getIconLucide('Percent')" color="#ffffff" :size="16" :stroke-width="3.5" />
										</b-input-group-text>
									</b-input-group-append>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useTaxDeclarationCountry" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="taxCountry">
									{{ FormMSG(1248, 'Tax declaration country') }}
									<span class="required">{{ projectFieldOption.mandatoryTaxDeclarationCountry ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="taxCountry"
									v-model="profile.taxCountry"
									type="text"
									:placeholder="FormMSG(1249, 'Enter your tax declaration country')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryTaxDeclarationCountry && profile.taxCountry.length <= 0 }"
								/>
							</b-form-group>
						</b-col>
					</b-row>
				</div>
			</b-collapse>
		</div>
		<div v-if="isAdressSectionVisible" class="card-collapsible mt-3">
			<div class="cursor-pointer header-card-collapsible d-flex flex-row align-items-center" @click="handleClickHeader('address')">
				<div class="title w-90">
					<b-icon icon="geo-fill" style="color: rgba(6, 38, 62, 0.84)" /><span class="ml-3">{{ FormMSG(43, 'Address') }}</span>
				</div>
				<div class="d-flex justify-content-end w-10">
					<b-button v-if="addressMandatoryCount > 0" pill variant="warning" class="mr-2">
						{{ addressMandatoryCount + ' ' + FormMSG(2365, 'field(s) left') }}
					</b-button>
					<component :is="getIconLucide('ChevronDown')" v-if="!configAccordion['address'].isVisible" color="#06263E" :size="22" />
					<component :is="getIconLucide('ChevronUp')" v-if="configAccordion['address'].isVisible" color="#06263E" :size="22" />
				</div>
			</div>
			<b-collapse v-if="profile.address" :visible="configAccordion['address'].isVisible">
				<div class="sub-title">
					{{ FormMSG(1250, 'Legal address') }}
				</div>
				<div class="content-card-collapsible">
					<b-row>
						<b-col v-if="projectFieldOption.useCountry" sm="12" md="12" lg="6" xl="6">
							<b-form-group>
								<label for="country">
									{{ FormMSG(1061010, 'Country') }}
									<span class="required">{{ projectFieldOption.mandatoryCountry ? ' *' : '' }}</span>
								</label>
								<v-select
									v-model="countryKey"
									:clearable="false"
									:options="countries"
									label="text"
									:reduce="(option) => option.value"
									:class="{ 'is-invalid': projectFieldOption.mandatoryCountry && !countryKey }"
									@input="getCountry"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useInternetSearch" sm="12" md="12" lg="6" xl="6">
							<b-form-group>
								<google-auto-complete
									ref="google-search-address"
									:label="FormMSG(11402, 'Internet search')"
									:country="countryCode"
									:clear-input="clearLegalAddress"
									@placechanged="(item) => handleAutoComplete(item, 'legalAddress')"
								/>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col v-if="projectFieldOption.useStreet" sm="10" md="10" lg="6" xl="6">
							<b-form-group>
								<label for="address">
									{{ FormMSG(513100, 'Street') }}
									<span class="required">{{ projectFieldOption.mandatoryStreet ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="street"
									v-model="profile.address.street"
									type="text"
									:placeholder="FormMSG(1103, 'Enter your street')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryStreet && profile.address.street.length <= 0 }"
									@input="handleUserEntryLevelChange"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useNumber" sm="2" md="2" lg="3" xl="3">
							<b-form-group>
								<label for="number">
									{{ FormMSG(155101, 'Number') }}
									<span class="required">{{ projectFieldOption.mandatoryNumber ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="number"
									v-model="profile.address.number"
									type="text"
									:class="{ 'is-invalid': projectFieldOption.mandatoryNumber && profile.address.number.length <= 0 }"
									@input="handleUserEntryLevelChange"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useBox" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="box">
									{{ FormMSG(102123, 'Box') }}
									<span class="required">{{ projectFieldOption.mandatoryBox ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="box"
									v-model="profile.address.box"
									type="text"
									:class="{ 'is-invalid': projectFieldOption.mandatoryBox && profile.address.box.length <= 0 }"
									@input="handleUserEntryLevelChange"
								/>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col v-if="projectFieldOption.useZipCode" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="zip">
									{{ FormMSG(104120, 'Postal Code') }}
									<span class="required">{{ projectFieldOption.mandatoryZipCode ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="zip"
									v-model="profile.address.zip"
									type="text"
									:class="{ 'is-invalid': projectFieldOption.mandatoryZipCode && profile.address.zip.length <= 0 }"
									@input="handleUserEntryLevelChange"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useCity" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="city">
									{{ FormMSG(10103, 'City') }}
									<span class="required">{{ projectFieldOption.mandatoryCity ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="city"
									v-model="profile.address.city"
									type="text"
									:class="{ 'is-invalid': projectFieldOption.mandatoryCity && profile.address.city.length <= 0 }"
									@input="handleUserEntryLevelChange"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useStateRegion" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="state">
									{{ FormMSG(110205, 'State') }}
									<span class="required">{{ projectFieldOption.mandatoryStateRegion ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="state"
									v-model="profile.address.state"
									type="text"
									:class="{ 'is-invalid': projectFieldOption.mandatoryStateRegion && profile.address.state.length <= 0 }"
									@input="handleUserEntryLevelChange"
								/>
							</b-form-group>
						</b-col>
					</b-row>
				</div>
				<b-collapse v-model="isShowPostalAddress">
					<div class="sub-title">
						{{ FormMSG(1312, 'Postal address') }}
					</div>
					<div class="content-card-collapsible">
						<b-row>
							<b-col sm="12" md="12" lg="6" xl="6">
								<b-form-group>
									<label for="country">{{ FormMSG(1061010, 'Country') }} </label>
									<v-select
										v-model="countryKeyPostalAddress"
										:clearable="false"
										:options="countries"
										label="text"
										:reduce="(option) => option.value"
										@input="getCountryPostalAddress"
									/>
								</b-form-group>
							</b-col>
							<b-col v-if="projectFieldOption.useInternetSearch" sm="12" md="12" lg="6" xl="6">
								<b-form-group>
									<google-auto-complete
										ref="google-search-address"
										:label="FormMSG(11402, 'Internet search')"
										:country="countryCodePostalAddress"
										:clear-input="clearPostalAddress"
										@placechanged="(item) => handleAutoComplete(item, 'postalAddress')"
									/>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row>
							<b-col sm="10" md="10" lg="6" xl="6">
								<b-form-group>
									<label for="address">{{ FormMSG(513100, 'Street') }} </label>
									<b-form-input
										id="street"
										v-model="profile.postalAddress.street"
										type="text"
										:placeholder="FormMSG(1103, 'Enter your street')"
										@input="handleUserEntryLevelChange"
									/>
								</b-form-group>
							</b-col>
							<b-col sm="2" md="2" lg="3" xl="3">
								<b-form-group>
									<label for="number">{{ FormMSG(155101, 'Number') }} </label>
									<b-form-input id="number" v-model="profile.postalAddress.number" type="text" @input="handleUserEntryLevelChange" />
								</b-form-group>
							</b-col>
							<b-col sm="12" md="12" lg="3" xl="3">
								<b-form-group>
									<label for="box">{{ FormMSG(102123, 'Box') }} </label>
									<b-form-input id="box" v-model="profile.postalAddress.box" type="text" @input="handleUserEntryLevelChange" />
								</b-form-group>
							</b-col>
						</b-row>
						<b-row>
							<b-col sm="12" md="12" lg="3" xl="3">
								<b-form-group>
									<label for="zip">{{ FormMSG(104120, 'Postal Code') }} </label>
									<b-form-input id="zip" v-model="profile.postalAddress.zip" type="text" @input="handleUserEntryLevelChange" />
								</b-form-group>
							</b-col>
							<b-col sm="12" md="12" lg="3" xl="3">
								<b-form-group>
									<label for="city">{{ FormMSG(10103, 'City') }} </label>
									<b-form-input id="city" v-model="profile.postalAddress.city" type="text" @input="handleUserEntryLevelChange" />
								</b-form-group>
							</b-col>
							<b-col sm="12" md="12" lg="3" xl="3">
								<b-form-group>
									<label for="state">{{ FormMSG(110205, 'State') }} </label>
									<b-form-input id="state" v-model="profile.postalAddress.state" type="text" @input="handleUserEntryLevelChange" />
								</b-form-group>
							</b-col>
						</b-row>
					</div>
				</b-collapse>
				<b-row>
					<div style="margin-left: 28px">
						<b-button
							size="sm"
							:variant="isShowPostalAddress ? 'outline-danger' : 'outline-secondary'"
							class="d-flex flex-row justify-content-center gap-2 align-items-center w-auto h-auto"
							style="height: 40px; border-radius: 0.5rem; background-color: #fff; cursor: pointer"
							@click="isShowPostalAddress = !isShowPostalAddress"
						>
							<div class="d-flex flex-row align-items-center justify-content-center btn-address" style="color: #06263e">
								<span v-if="isShowPostalAddress">
									<component :is="getLucideIcon(ICONS.X_CLEAR.name)" :color="ICONS.X_CLEAR.color" :size="22" />
									{{ FormMSG(1313, 'Close') }}
								</span>
								<span v-else>
									<component :is="getLucideIcon('PlusCircle')" color="#47C7BF" :size="22" />
									{{ FormMSG(1251, 'Add postal address (if different)') }}
								</span>
							</div>
						</b-button>
					</div>
				</b-row>
			</b-collapse>
		</div>
		<!-- Health -->
		<div v-if="isHealthSectionVisible" class="card-collapsible mt-3">
			<div class="cursor-pointer header-card-collapsible d-flex flex-row align-items-center" @click="handleClickHeader('health')">
				<div class="title w-90">
					<component :is="getLucideIcon('HeartPulse')" color="rgba(6, 38, 62, 0.84)" :size="22" />
					<span class="ml-3">{{ FormMSG(1252, 'Health') }}</span>
				</div>
				<div class="d-flex justify-content-end w-10">
					<b-button v-if="healthMandatoryCount > 0" pill variant="warning" class="mr-2">
						{{ healthMandatoryCount + ' ' + FormMSG(2365, 'field(s) left') }}
					</b-button>
					<component :is="getIconLucide('ChevronDown')" v-if="!configAccordion['health'].isVisible" color="#06263E" :size="22" />
					<component :is="getIconLucide('ChevronUp')" v-if="configAccordion['health'].isVisible" color="#06263E" :size="22" />
				</div>
			</div>
			<b-collapse :visible="configAccordion['health'].isVisible">
				<div class="content-card-collapsible">
					<b-row>
						<b-col v-if="projectFieldOption.useSocialSecurityNumber" sm="12" md="12" lg="4" xl="4">
							<b-form-group>
								<label for="state">
									{{ FormMSG(257, 'Social Security Number') }}
									<span class="required">{{ projectFieldOption.mandatorySocialSecurityNumber || useDpae ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.socSecNumber"
									:class="{
										'is-warning': isSocSecNumberWarning,
										'is-invalid': projectFieldOption.mandatorySocialSecurityNumber && profile.socSecNumber.length <= 0
									}"
									:placeholder="FormMSG(154, 'Enter your Social Security Number')"
									maxlength="15"
									@change="handleSocSecNumberChange"
									@keydown.enter.prevent
								/>
								<div v-if="isSocSecNumberWarning" class="warning-feedback">
									{{ FormMSG(8979997, 'The social security number seems not valid') }}
								</div>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useSocialSecurityCard" sm="12" md="12" lg="4" xl="4">
							<b-form-group>
								<label for="socialSecurityCardXid">
									{{ FormMSG(1255, 'Social security card') }}
									<span class="required">{{ projectFieldOption.mandatorySocialSecurityCard ? ' *' : '' }}</span>
								</label>
								<b-row class="ml-0">
									<div
										v-if="checkFile(profile.socialSecurityCardXid)"
										class="d-flex justify-content-center align-items-center cursor-pointer"
										:class="{ 'is-invalid': projectFieldOption.mandatorySocialSecurityCard && profile.socialSecurityCardXid.length <= 0 }"
										@click="onOpenUrl(getImage(profile.socialSecurityCardXid, 'socialSecurityCardXid'))"
									>
										<b-icon icon="file-earmark-pdf-fill" font-scale="2" />
									</div>
									<b-img
										v-else
										v-bind="imgPropSignatureId"
										rounded
										alt="socialSecurityCardXid"
										class="cursor-pointer"
										:src="getImage(profile.socialSecurityCardXid, 'socialSecurityCardXid')"
										:title="FormMSG(254, 'View Image')"
										@click="showImage(profile.socialSecurityCardXid)"
									/>
									<button
										v-if="profile.socialSecurityCardXid && profile.socialSecurityCardXid.length > 0"
										class="btn-transparent pl-0 ml-2"
										@click.prevent.stop="deleteImg('socialSecurityCardXid')"
									>
										<component :is="getIconLucide('Trash2')" :size="24" :stroke-width="1.5" color="#ea4e2c" />
									</button>
									<div
										v-if="projectFieldOption.mandatorySocialSecurityCard && profile.socialSecurityCardXid.length === 0"
										class="d-flex align-items-center"
									>
										<b-button
											v-b-tooltip.hover.bottom.html="FormMSG(4908, 'Social security card empty')"
											size="sm"
											class="btn bg-transparent border-0"
										>
											<component :is="getIconLucide(ICONS.ALERT_TRIANGLE.name)" color="#ffc107" :size="30" />
										</b-button>
									</div>
								</b-row>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useInsuranceCertificate" sm="12" md="12" lg="4" xl="4">
							<b-form-group>
								<label for="inscuranceCertificate">
									{{ FormMSG(1256, 'Insurance certificate') }}
									<span class="required">{{ projectFieldOption.mandatoryInsuranceCertificate ? ' *' : '' }}</span>
								</label>
								<b-row class="ml-0">
									<div
										v-if="checkFile(profile.insuranceCertificateXid)"
										class="d-flex justify-content-center align-items-center cursor-pointer"
										@click="onOpenUrl(getImage(profile.insuranceCertificateXid, 'insuranceCertificateXid'))"
									>
										<b-icon icon="file-earmark-pdf-fill" font-scale="2" />
									</div>
									<b-img
										v-else
										v-bind="imgPropSignatureId"
										rounded
										alt="inscuranceCertificate"
										class="cursor-pointer"
										:src="getImage(profile.insuranceCertificateXid, 'insuranceCertificateXid')"
										:title="FormMSG(254, 'View Image')"
										@click="showImage(profile.insuranceCertificateXid)"
									/>
									<button
										v-if="profile.insuranceCertificateXid && profile.insuranceCertificateXid.length > 0"
										class="btn-transparent pl-0 ml-2"
										@click.prevent.stop="deleteImg('insuranceCertificateXid')"
									>
										<component :is="getIconLucide('Trash2')" :size="24" :stroke-width="1.5" color="#ea4e2c" />
									</button>
									<div
										v-if="projectFieldOption.mandatoryInsuranceCertificate && profile.insuranceCertificateXid.length === 0"
										class="d-flex align-items-center"
									>
										<b-button
											v-b-tooltip.hover.bottom.html="FormMSG(4907, 'Insurance certificate empty')"
											size="sm"
											class="btn bg-transparent border-0"
										>
											<component :is="getIconLucide(ICONS.ALERT_TRIANGLE.name)" color="#ffc107" :size="30" />
										</b-button>
									</div>
								</b-row>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col v-if="projectFieldOption.useSocialSecurityCenter" sm="12" md="12" lg="4" xl="4">
							<b-form-group>
								<label for="socialSecurityCenter">
									{{ FormMSG(1700, 'Social security center') }}
									<span class="required">{{ projectFieldOption.mandatorySocialSecurityCenter ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="socialSecurityCenter"
									v-model="profile.socialSecurityCenter"
									type="text"
									:placeholder="FormMSG(1258, 'Enter your social security center')"
									:class="{ 'is-invalid': projectFieldOption.mandatorySocialSecurityCenter && profile.socialSecurityCenter.length <= 0 }"
									@change="handleChangeUser(profile.socialSecurityCenter, 'socialSecurityCenter')"
									@keydown.enter.prevent
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useSocialSecurityCenterAddress" sm="12" md="12" lg="8" xl="8">
							<b-form-group>
								<label for="socialSecurityCenter">
									{{ FormMSG(1259, 'Social security center address') }}
									<span class="required">{{ projectFieldOption.mandatorySocialSecurityCenterAddress ? ' *' : '' }}</span>
								</label>
								<v-address
									:params="{ title: 'Social security center address' }"
									:address-id="profile.socialSecurityCenterAddressId"
									:class="{
										'is-invalid':
											projectFieldOption.mandatorySocialSecurityCenterAddress && profile.socialSecurityCenterAddressId.length <= 0
									}"
									@change="handleDynamicAddressChange"
									@delete="handleDynamicAddressDelete"
									@address-maplink-change="handleAddressMapLinkChange"
								/>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col v-if="projectFieldOption.useLastMedicalVisitDate" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(1260, 'Last medical visit date') }}
									<span class="required">{{ isMandatory('LastMedicalVisitDate') ? ' *' : '' }}</span>
								</label>
								<!-- <b-form-input
									@keydown.enter.prevent
									@input="(e) => updateDate(e, 'lastMedicalVisit')"
									type="date"
									:value="displayDateLastMedicalVisit"
									:placeholder="FormMSG(1295, 'DD/MM/YYYY')"
									:class="{
										'is-invalid': projectFieldOption.mandatoryLastMedicalVisitDate && profile.lastMedicalVisit === '0001-01-01T00:00:00Z'
									}"
								>
								</b-form-input> -->
								<v-date-picker
									v-model="profile.lastMedicalVisit"
									:locale="lang"
									:masks="masks"
									:attributes="attrs"
									@dayclick="(payload) => handleInputCalendar(payload, 'lastMedicalVisit')"
								>
									<template #default="{ inputValue, togglePopover }">
										<b-input-group>
											<b-form-input
												v-mask="'##/##/####'"
												:value="inputValue"
												:placeholder="FormMSG(8960, 'DD/MM/YYYY')"
												readonly
												:class="{
													'is-invalid': isMandatory('LastMedicalVisitDate') && !isDateValid('lastMedicalVisit')['lastMedicalVisit']
												}"
												@click="togglePopover()"
												@change="(value) => handleChangeDate(value, 'lastMedicalVisit')"
												@keydown.enter.prevent
											/>
											<b-input-group-append>
												<b-input-group-text
													:class="{
														'is-invalid':
															isMandatory('LastMedicalVisitDate') && !isDateValid('lastMedicalVisit')['lastMedicalVisit']
													}"
													class="cursor-pointer bg-color-white input-group-text-bg-white"
													@click="togglePopover()"
												>
													<component :is="getLucideIcon('Calendar')" color="rgba(6, 38, 62, .6)" :size="18" :stroke-width="2.25" />
												</b-input-group-text>
											</b-input-group-append>
										</b-input-group>
										<!-- <div
													v-if="isMandatory('LastMedicalVisitDate') && !isDateValid('lastMedicalVisit')['lastMedicalVisit']"
													class="invalid-feedback"
												>
													{{ FormMSG(898, 'Last medical visit date is required') }}
												</div> -->
									</template>
								</v-date-picker>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useMedicalVisitValidity" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(1262, 'Medical visit validity') }}
									<span class="required">{{ isMandatory('MedicalVisitValidity') ? ' *' : '' }}</span>
								</label>
								<!-- <b-form-input
									type="date"
									:value="displayDateMedicalVisitValidity"
									:placeholder="FormMSG(1295, 'DD/MM/YYYY')"
									@input="(e) => updateDate(e, 'medicalVisitValidity')"
									@keydown.enter.prevent
									:class="{
										'is-invalid':
											projectFieldOption.mandatoryMedicalVisitValidity && profile.medicalVisitValidity === '0001-01-01T00:00:00Z'
									}"
								></b-form-input> -->
								<v-date-picker
									v-model="profile.medicalVisitValidity"
									:locale="lang"
									:masks="masks"
									:attributes="attrs"
									@dayclick="(payload) => handleInputCalendar(payload, 'medicalVisitValidity')"
								>
									<template #default="{ inputValue, togglePopover }">
										<b-input-group>
											<b-form-input
												v-mask="'##/##/####'"
												:value="inputValue"
												:placeholder="FormMSG(8960, 'DD/MM/YYYY')"
												readonly
												:class="{
													'is-invalid':
														isMandatory('MedicalVisitValidity') && !isDateValid('medicalVisitValidity')['medicalVisitValidity']
												}"
												@click="togglePopover()"
												@change="(value) => handleChangeDate(value, 'medicalVisitValidity')"
												@keydown.enter.prevent
											/>
											<b-input-group-append>
												<b-input-group-text
													:class="{
														'is-invalid':
															isMandatory('MedicalVisitValidity') && !isDateValid('medicalVisitValidity')['medicalVisitValidity']
													}"
													class="cursor-pointer bg-color-white input-group-text-bg-white"
													@click="togglePopover()"
												>
													<component :is="getLucideIcon('Calendar')" color="rgba(6, 38, 62, .6)" :size="18" :stroke-width="2.25" />
												</b-input-group-text>
											</b-input-group-append>
										</b-input-group>
										<!-- <div
													v-if="isMandatory('MedicalVisitValidity') && !isDateValid('medicalVisitValidity')['medicalVisitValidity']"
													class="invalid-feedback"
												>
													{{ FormMSG(903, 'Medical visit validity is required') }}
												</div> -->
									</template>
								</v-date-picker>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useMedicalVisitDocument" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="medicalVisitDocument">
									{{ FormMSG(1264, 'Medical visit document') }}
									<span class="required">{{ projectFieldOption.mandatoryMedicalVisitDocument ? ' *' : '' }}</span>
								</label>
								<b-row class="ml-0">
									<div
										v-if="checkFile(profile.medicalVisitDocumentXid)"
										class="d-flex justify-content-center align-items-center cursor-pointer"
										@click="onOpenUrl(getImage(profile.medicalVisitDocumentXid, 'medicalVisitDocumentXid'))"
									>
										<b-icon icon="file-earmark-pdf-fill" font-scale="2" />
									</div>
									<b-img
										v-else
										v-model="profile.medicalVisitDocumentXid"
										v-bind="imgPropSignatureId"
										rounded
										alt="medicalVisitDocument"
										class="cursor-pointer"
										:src="getImage(profile.medicalVisitDocumentXid, 'medicalVisitDocumentXid')"
										:title="FormMSG(254, 'View Image')"
										@click="showImage(profile.medicalVisitDocumentXid)"
									/>
									<button
										v-if="profile.medicalVisitDocumentXid && profile.medicalVisitDocumentXid.length > 0"
										class="btn-transparent pl-0 ml-2"
										@click.prevent.stop="deleteImg('medicalVisitDocumentXid')"
									>
										<component :is="getIconLucide('Trash2')" :size="24" :stroke-width="1.5" color="#ea4e2c" />
									</button>
									&nbsp;
									<div
										v-if="
											(isDeterAction && profile.medicalVisitDocumentXid.length === 0) ||
											(projectFieldOption.mandatoryMedicalVisitDocument && profile.medicalVisitDocumentXid.length === 0)
										"
										class="d-flex align-items-center"
									>
										<b-button
											v-b-tooltip.hover.bottom.html="FormMSG(4909, 'Medical visit document empty')"
											size="sm"
											class="btn bg-transparent border-0"
										>
											<component :is="getIconLucide(ICONS.ALERT_TRIANGLE.name)" color="#ffc107" :size="30" />
										</b-button>
									</div>
								</b-row>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col v-if="projectFieldOption.useWorkerWithADisability" sm="12" md="12" lg="3" xl="3" class="d-flex justify-content-start">
							<b-form-group class="text-start">
								<label for="medicalVisitDocument">
									{{ FormMSG(1265, 'Worker with a disability') }}
									<span class="required">{{ projectFieldOption.mandatoryWorkerWithADisability ? ' *' : '' }}</span>
								</label>
								<b-form-checkbox
									v-model="profile.disabled"
									class="d-flex justify-content-start"
									size="lg"
									switch
									@change="(value) => handleChangeWorkDisability(value, 'disabled')"
								>
									<span class="text-redired">{{ profile.disabled ? FormMSG(1276, 'Yes') : FormMSG(1277, 'No') }}</span>
								</b-form-checkbox>
							</b-form-group>
						</b-col>
						<b-col v-if="profile.disabled && projectFieldOption.useDisabilityNotificationDate" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(1266, 'Disability notification date') }}
									<span class="required">{{ isMandatory('DisabilityNotificationDate') ? ' *' : '' }}</span>
								</label>
								<v-date-picker
									v-model="profile.disabilityNotification"
									:locale="lang"
									:masks="masks"
									:attributes="attrs"
									@dayclick="(payload) => handleInputCalendar(payload, 'disabilityNotification')"
								>
									<template #default="{ inputValue, togglePopover }">
										<b-input-group>
											<b-form-input
												v-mask="'##/##/####'"
												:value="inputValue"
												:placeholder="FormMSG(8960, 'DD/MM/YYYY')"
												readonly
												:class="{
													'is-invalid':
														isMandatory('DisabilityNotificationDate') &&
														!isDateValid('disabilityNotification')['disabilityNotification']
												}"
												@click="togglePopover()"
												@change="(value) => handleChangeDate(value, 'disabilityNotification')"
												@keydown.enter.prevent
											/>
											<b-input-group-append>
												<b-input-group-text
													:class="{
														'is-invalid':
															isMandatory('DisabilityNotificationDate') &&
															!isDateValid('disabilityNotification')['disabilityNotification']
													}"
													class="cursor-pointer bg-color-white input-group-text-bg-white"
													@click="togglePopover()"
												>
													<component :is="getLucideIcon('Calendar')" color="rgba(6, 38, 62, .6)" :size="18" :stroke-width="2.25" />
												</b-input-group-text>
											</b-input-group-append>
										</b-input-group>
										<!-- <div
														v-if="
															isMandatory('DisabilityNotificationDate') &&
														!isDateValid('disabilityNotification')['disabilityNotification']
												"
														class="invalid-feedback"
													>
														{{ FormMSG(900, 'Disability notification date is required') }}
													</div> -->
									</template>
								</v-date-picker>
							</b-form-group>
						</b-col>
						<b-col v-if="profile.disabled && projectFieldOption.useType" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="type">
									{{ FormMSG(1268, 'Type') }}
									<span class="required">{{ projectFieldOption.mandatoryType ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="type"
									v-model="profile.disabilityType"
									type="text"
									:placeholder="FormMSG(1269, 'Enter type')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryType && profile.disabilityType.length <= 0 }"
									@keydown.enter.prevent
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="profile.disabled && projectFieldOption.useStatus" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="status">
									{{ FormMSG(1270, 'Status') }}
									<span class="required">{{ projectFieldOption.mandatoryStatus ? ' *' : '' }}</span>
								</label>
								<b-form-input
									id="status"
									v-model="profile.disabilityStatus"
									type="text"
									:placeholder="FormMSG(1271, 'Enter status')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryStatus && profile.disabilityStatus.length <= 0 }"
									@keydown.enter.prevent
								/>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col v-if="profile.disabled && projectFieldOption.useInvalidity" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="status">
									{{ FormMSG(1272, 'Invalidity') }}
									<span class="required">{{ projectFieldOption.mandatoryInvalidity ? ' *' : '' }}</span>
								</label>
								<b-form-select
									v-model="profile.invalidity"
									:class="{ 'is-invalid': projectFieldOption.mandatoryInvalidity && profile.invalidity.length <= 0 }"
								>
									<b-form-select-option v-for="(gender, index) in menuInvalidity" :key="index" :value="gender.value">
										{{ gender.text }}
									</b-form-select-option>
								</b-form-select>
							</b-form-group>
						</b-col>
						<b-col v-if="profile.disabled && projectFieldOption.useRqth" sm="12" md="12" lg="3" xl="3" class="d-flex align-items-center mt-2">
							<b-form-checkbox v-model="profile.rqth" size="lg" :value="true" class="d-flex align-items-center">
								<div class="mt-1">
									{{ FormMSG(1273, 'RQTH') }} <span class="required">{{ projectFieldOption.mandatoryRqth ? ' *' : '' }}</span>
								</div>
							</b-form-checkbox>
						</b-col>
						<b-col v-if="profile.disabled && projectFieldOption.useInvalidityPercentage" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="status">
									{{ FormMSG(1274, 'Invalidity percentage') }}
									<span class="required">{{ projectFieldOption.mandatoryInvalidityPercentage ? ' *' : '' }}</span>
								</label>
								<b-input-group>
									<b-form-input
										v-model="profile.invalidityPourcentage"
										type="number"
										step="1"
										min="0"
										max="100"
										:class="{ 'is-invalid': projectFieldOption.mandatoryInvalidityPercentage && profile.invalidityPourcentage.length <= 0 }"
										@keydown.enter.prevent
									/>
									<b-input-group-append>
										<b-input-group-text style="background-color: #00a09c">
											<component :is="getIconLucide('Percent')" color="#ffffff" :size="16" :stroke-width="3.5" />
										</b-input-group-text>
									</b-input-group-append>
								</b-input-group>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col v-if="projectFieldOption.useHaveAllergies" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>{{ FormMSG(25, 'Have Allergies?') }} </label>
								<b-form-checkbox v-model="haveAllergies" size="lg" switch @change="handleChangeHaveAllergies" />
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useAllergiesDetails" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(277, 'Allergies details') }}
									<span class="required">{{ projectFieldOption.mandatoryAllergiesDetails && haveAllergies ? ' *' : '' }}</span>
								</label>
								<b-form-textarea
									v-model="profile.allergies"
									type="textarea"
									rows="2"
									:placeholder="FormMSG(279, 'Enter allergies details...')"
									autocomplete="off"
									:disabled="haveAllergies === false"
									:class="{ 'is-invalid': projectFieldOption.mandatoryAllergiesDetails && haveAllergies && profile.allergies.length <= 0 }"
								/>
							</b-form-group>
						</b-col>
					</b-row>
				</div>
			</b-collapse>
		</div>
		<!-- Family-->
		<div v-if="isFamilySectionVisible" class="card-collapsible mt-3">
			<div class="cursor-pointer header-card-collapsible d-flex flex-row align-items-center" @click="handleClickHeader('family')">
				<div class="title w-90">
					<b-icon icon="people-fill" style="color: rgba(6, 38, 62, 0.84)" /><span class="ml-3">{{ FormMSG(52, 'Family') }}</span>
				</div>
				<div class="d-flex justify-content-end w-10">
					<b-button v-if="familyMandatoryCount > 0" pill variant="warning" class="mr-2">
						{{ familyMandatoryCount + ' ' + FormMSG(2365, 'field(s) left') }}
					</b-button>
					<component :is="getIconLucide('ChevronDown')" v-if="!configAccordion['family'].isVisible" color="#06263E" :size="22" />
					<component :is="getIconLucide('ChevronUp')" v-if="configAccordion['family'].isVisible" color="#06263E" :size="22" />
				</div>
			</div>
			<b-collapse :visible="configAccordion['family'].isVisible">
				<div v-if="isFamilyCompositionVisible" class="sub-title">
					{{ FormMSG(53, 'Family composition') }}
				</div>
				<div v-if="isFamilyCompositionVisible" class="content-card-collapsible">
					<b-row>
						<b-col v-if="projectFieldOption.useCivilStatus" sm="12" md="12" lg="4" xl="4">
							<b-form-group>
								<label for="optionsForCivilStatus">
									{{ FormMSG(54, 'Civil status') }}
									<span class="required">{{ projectFieldOption.mandatoryCivilStatus ? ' *' : '' }}</span>
								</label>
								<b-form-select
									id="optionsForCivilStatus"
									v-model="profile.civilStatus"
									:options="optionsForCivilStatus"
									:class="{ 'is-invalid': projectFieldOption.mandatoryCivilStatus && profile.civilStatus === 0 }"
									@change="(value) => handleChangeWorkDisability(value, 'civilStatus')"
								/>
							</b-form-group>
						</b-col>
						<b-col
							v-if="(profile.civilStatus === 3 || profile.civilStatus === 8) && projectFieldOption.useSpouseFirstName"
							sm="12"
							md="12"
							lg="4"
							xl="4"
						>
							<b-form-group>
								<label>
									{{ FormMSG(55, 'Spouse first name') }}
									<span class="required">{{ projectFieldOption.mandatorySpouseFirstName ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.spouseFirstName"
									type="text"
									:placeholder="FormMSG(56, 'Enter your Spouse first name ')"
									:class="{
										'is-invalid':
											projectFieldOption.mandatorySpouseFirstName && profile.civilStatus === 3 && profile.spouseFirstName.length <= 0
									}"
									@change="handleChangeUser(profile.spouseFirstName, 'spouseFirstName')"
								/>
							</b-form-group>
						</b-col>
						<b-col
							v-if="(profile.civilStatus === 3 || profile.civilStatus === 8) && projectFieldOption.useSpouseLastName"
							sm="12"
							md="12"
							lg="4"
							xl="4"
						>
							<b-form-group>
								<label>
									{{ FormMSG(57, 'Spouse name') }}
									<span class="required">{{ projectFieldOption.mandatorySpouseLastName ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.spouseName"
									type="text"
									:placeholder="FormMSG(58, 'Enter your Spouse name ')"
									:class="{
										'is-invalid': projectFieldOption.mandatorySpouseLastName && profile.civilStatus === 3 && profile.spouseName.length <= 0
									}"
									@change="handleChangeUser(profile.spouseName, 'spouseName')"
								/>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row v-if="(profile.civilStatus === 3 || profile.civilStatus === 8) && projectFieldOption.useSpouseBirthdate">
						<b-col sm="12" md="12" lg="4" xl="4">
							<b-form-group v-if="projectFieldOption.useSpouseBirthdate">
								<label>
									{{ FormMSG(59, 'Spouse birth date') }}
									<span class="required">{{ projectFieldOption.mandatorySpouseBirthdate ? ' *' : '' }}</span>
								</label>
								<!-- {{ profile.spouseBirthDate }}
								<b-form-input
									type="date"
									:value="displaySpouseBirthDate"
									:placeholder="FormMSG(60, 'Enter your Spouse birth date ')"
									@input="updateSpouseBirthDate"
									:class="{
										'is-invalid': isMandatory('SpouseBirthdate') && !isDateValid('spouseBirthDate')['spouseBirthDate']
									}"
								/> -->
								<v-date-picker
									v-model="profile.spouseBirthDate"
									:locale="lang"
									:masks="masks"
									:attributes="attrs"
									@dayclick="(payload) => handleInputCalendar(payload, 'spouseBirthDate')"
								>
									<template #default="{ inputValue, togglePopover }">
										<b-input-group>
											<b-form-input
												v-mask="'##/##/####'"
												:value="inputValue"
												:placeholder="FormMSG(8960, 'DD/MM/YYYY')"
												readonly
												:class="{
													'is-invalid': isMandatory('SpouseBirthdate') && !isDateValid('spouseBirthDate')['spouseBirthDate']
												}"
												@click="togglePopover()"
												@change="(value) => handleChangeDate(value, 'spouseBirthDate')"
												@keydown.enter.prevent
											/>
											<b-input-group-append>
												<b-input-group-text
													:class="{
														'is-invalid': isMandatory('SpouseBirthdate') && !isDateValid('spouseBirthDate')['spouseBirthDate']
													}"
													class="cursor-pointer bg-color-white input-group-text-bg-white"
													@click="togglePopover()"
												>
													<component :is="getLucideIcon('Calendar')" color="rgba(6, 38, 62, .6)" :size="18" :stroke-width="2.25" />
												</b-input-group-text>
											</b-input-group-append>
										</b-input-group>
									</template>
								</v-date-picker>
							</b-form-group>
						</b-col>
						<b-col
							v-if="(profile.civilStatus === 3 || profile.civilStatus === 8) && projectFieldOption.useSpouseHasSalary"
							sm="12"
							md="12"
							lg="4"
							xl="4"
						>
							<b-form-group class="text-left">
								<label>
									{{ FormMSG(61, 'Spouse has salary') }}
									<span class="required">{{ projectFieldOption.mandatorySpouseHasSalary ? ' *' : '' }}</span>
								</label>
								<b-form-checkbox
									v-model="profile.spouseHasSalary"
									size="lg"
									switch
									@change="handleChangeUser(profile.spouseHasSalary, 'spouseHasSalary')"
								/>
							</b-form-group>
						</b-col>
						<b-col
							v-if="(profile.civilStatus === 3 || profile.civilStatus === 8) && projectFieldOption.useSpouseProfession"
							sm="12"
							md="12"
							lg="4"
							xl="4"
						>
							<b-form-group>
								<label>
									{{ FormMSG(62, 'Spouse profession') }}
									<span class="required">{{ projectFieldOption.mandatorySpouseProfession ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.spouseProfession"
									type="text"
									:placeholder="FormMSG(63, 'Enter your Spouse profession ')"
									:class="{
										'is-invalid':
											projectFieldOption.mandatorySpouseProfession && profile.civilStatus === 3 && profile.spouseProfession.length <= 0
									}"
									@change="handleChangeUser(profile.spouseProfession, 'spouseProfession')"
								/>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col v-if="projectFieldOption.useNumberOfDependentChildren" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(64, 'Number of dependent child') }}
									<span class="required">{{ projectFieldOption.mandatoryNumberOfDependentChildren ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.numberOfDependentChild"
									type="number"
									:class="{
										'is-invalid': projectFieldOption.mandatoryNumberOfDependentChildren && profile.numberOfDependentChild === null
									}"
									@change="handleChangeUser(profile.numberOfDependentChild, 'numberOfDependentChild')"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useNumberOfDisabledChildren" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(65, 'Number of disabled child') }}
									<span class="required">{{ projectFieldOption.mandatoryNumberOfDisabledChildren ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.numberOfDisabledChild"
									type="number"
									:class="{
										'is-invalid': projectFieldOption.mandatoryNumberOfDisabledChildren && profile.numberOfDisabledChild === null
									}"
									@change="handleChangeUser(profile.numberOfDisabledChild, 'numberOfDisabledChild')"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useNumberOfDependentPerson" sm="12" md="12" lg="3" xl="3">
							<b-form-group v-if="projectFieldOption.useNumberOfDependentPerson">
								<label>
									{{ FormMSG(66, 'Number of dependent person') }}
									<span class="required">{{ projectFieldOption.mandatoryNumberOfDependentPerson ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.numberOfDependentPerson"
									type="number"
									:class="{
										'is-invalid': projectFieldOption.mandatoryNumberOfDependentPerson && profile.numberOfDependentPerson === null
									}"
									@change="handleChangeUser(profile.numberOfDependentPerson, 'numberOfDependentPerson')"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useNumberOfDisabledPerson" sm="12" md="12" lg="3" xl="3">
							<b-form-group v-if="projectFieldOption.useNumberOfDisabledPerson">
								<label>
									{{ FormMSG(67, 'Number of disabled person') }}
									<span class="required">{{ projectFieldOption.mandatoryNumberOfDisabledPerson ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.numberOfDisabledPerson"
									type="number"
									:class="{
										'is-invalid': projectFieldOption.mandatoryNumberOfDisabledPerson && profile.numberOfDisabledPerson === null
									}"
									@change="handleChangeUser(profile.numberOfDisabledPerson, 'numberOfDisabledPerson')"
								/>
							</b-form-group>
						</b-col>
					</b-row>
				</div>
				<div v-if="isFamilyCompositionVisible && isEmmergencyContactVisible" class="divider" />
				<div v-if="isEmmergencyContactVisible" class="sub-title">
					{{ FormMSG(68, 'Emergency contact') }}
				</div>
				<div v-if="isEmmergencyContactVisible" class="content-card-collapsible">
					<b-row>
						<b-col v-if="projectFieldOption.useContactName" sm="12" md="12" lg="6" xl="6">
							<b-form-group>
								<label>
									{{ FormMSG(69, 'Person to contact') }}
									<span class="required">{{ projectFieldOption.mandatoryContactName ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.personToContact"
									type="text"
									:placeholder="FormMSG(70, 'Enter person to contact')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryContactName && profile.personToContact.length <= 0 }"
									@change="handleChangeUser(profile.personToContact, 'personToContact')"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useContactPhoneNumber" sm="12" md="12" lg="6" xl="6">
							<b-form-group>
								<label>
									{{ FormMSG(71, 'Person to contact phone') }}
									<span class="required">{{ projectFieldOption.mandatoryContactPhoneNumber ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.personToContactPhone"
									type="text"
									:placeholder="FormMSG(72, 'Enter person to contact phone')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryContactPhoneNumber && profile.personToContactPhone.length <= 0 }"
									@change="handleChangeUser(profile.personToContactPhone, 'personToContactPhone')"
								/>
							</b-form-group>
						</b-col>
					</b-row>
				</div>
			</b-collapse>
		</div>
		<!-- Personal Vehicle -->
		<div v-if="profile.vehicule && isPersonnalVehicleSectionVisible" class="card-collapsible mt-3">
			<div class="cursor-pointer header-card-collapsible d-flex flex-row align-items-center" @click="handleClickHeader('personal-vehicle')">
				<div class="title w-90">
					<!-- <b-icon icon="car-front-fill" style="color: rgba(6, 38, 62, 0.84)" /> -->
					<!-- <i class="bi bi-car-front"></i> -->
					<span>
						<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1.15em" fill="rgba(6, 38, 62, 0.84)" viewBox="0 0 16 16">
							<path
								d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679c.033.161.049.325.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.807.807 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H6ZM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17 1.247 0 3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z"
							/>
						</svg>
					</span>
					<span class="ml-3">{{ FormMSG(1226, 'Personal vehicle') }}</span>
				</div>
				<div class="d-flex justify-content-end w-10">
					<b-button v-if="personalVehicleMandatoryCount > 0" pill variant="warning" class="mr-2">
						{{ personalVehicleMandatoryCount + ' ' + FormMSG(2365, 'field(s) left') }}
					</b-button>
					<component :is="getIconLucide('ChevronDown')" v-if="!configAccordion['personal-vehicle'].isVisible" color="#06263E" :size="22" />
					<component :is="getIconLucide('ChevronUp')" v-if="configAccordion['personal-vehicle'].isVisible" color="#06263E" :size="22" />
				</div>
			</div>
			<b-collapse :visible="configAccordion['personal-vehicle'].isVisible">
				<div class="content-card-collapsible">
					<vehicule-form
						:use-vehicle-name="projectFieldOption.useVehicleName"
						:use-vehicle-brand="projectFieldOption.useVehicleBrand"
						:use-vehicle-model="projectFieldOption.useVehicleModel"
						:use-vehicle-plate-number="projectFieldOption.useVehiclePlateNumber"
						:use-vehicle-transportation-mean="projectFieldOption.useVehicleTransportationMean"
						:use-vehicle-transportation-mean-detail="projectFieldOption.useVehicleTransportationMeanDetail"
						:use-vehicle-kg-co-two="projectFieldOption.useVehicleKgCoTwo"
						:use-power="projectFieldOption.usePower"
						:use-gray-card-front-picture="projectFieldOption.useGrayCardFrontPicture"
						:use-gray-card-back-picture="projectFieldOption.useGrayCardBackPicture"
						:vehicule-data="profile.vehicule"
						:mandatory-vehicle-name="projectFieldOption.mandatoryVehicleName"
						:mandatory-vehicle-brand="projectFieldOption.mandatoryVehicleBrand"
						:mandatory-vehicle-model="projectFieldOption.mandatoryVehicleModel"
						:mandatory-vehicle-plate-number="projectFieldOption.mandatoryVehiclePlateNumber"
						:mandatory-vehicle-transportation-mean="projectFieldOption.mandatoryVehicleTransportationMean"
						:mandatory-vehicle-kg-co-two="projectFieldOption.mandatoryVehicleKgCoTwo"
						:mandatory-power="projectFieldOption.mandatoryPower"
						:mandatory-gray-card-front-picture="projectFieldOption.mandatoryGrayCardFrontPicture"
						:mandatory-gray-card-back-picture="projectFieldOption.mandatoryGrayCardBackPicture"
						@vehicule-form:change="handleVehiculeFormChange"
					/>
				</div>
			</b-collapse>
		</div>
		<!-- Personal vehicle -->
		<div v-if="isPme && profile.vehicule && isPersonnalVehicleSectionVisible" class="card-collapsible mt-3">
			<div class="cursor-pointer header-card-collapsible d-flex flex-row align-items-center" @click="handleClickHeader('personal-vehicle')">
				<div class="title w-90">
					<!-- <b-icon icon="car-front-fill" style="color: rgba(6, 38, 62, 0.84)" /> -->
					<!-- <i class="bi bi-car-front"></i> -->
					<span>
						<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1.15em" fill="rgba(6, 38, 62, 0.84)" viewBox="0 0 16 16">
							<path
								d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679c.033.161.049.325.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.807.807 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H6ZM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17 1.247 0 3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z"
							/>
						</svg>
					</span>
					<span class="ml-3">{{ FormMSG(1226, 'Personal vehicle') }}</span>
				</div>
				<div class="d-flex justify-content-end w-10">
					<b-button v-if="personalVehicleMandatoryCount > 0" pill variant="warning" class="mr-2">
						{{ personalVehicleMandatoryCount + ' ' + FormMSG(2365, 'field(s) left') }}
					</b-button>
					<component :is="getIconLucide('ChevronDown')" v-if="!configAccordion['personal-vehicle'].isVisible" color="#06263E" :size="22" />
					<component :is="getIconLucide('ChevronUp')" v-if="configAccordion['personal-vehicle'].isVisible" color="#06263E" :size="22" />
				</div>
			</div>
			<b-collapse :visible="configAccordion['personal-vehicle'].isVisible">
				<div class="content-card-collapsible">
					<b-row>
						<b-col v-if="projectFieldOption.useVehicleName" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(1228, 'Name') }} <span class="required">{{ projectFieldOption.mandatoryVehicleName ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.vehicule.name"
									type="text"
									:placeholder="FormMSG(1229, 'Vehicle name ...')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryVehicleName && profile.vehicule.name.length <= 0 }"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useVehicleBrand" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(1230, 'Brand') }}
									<span class="required">{{ projectFieldOption.mandatoryVehicleBrand ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.vehicule.brand"
									type="text"
									:placeholder="FormMSG(1231, 'Vehicle brand ...')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryVehicleBrand && profile.vehicule.brand.length <= 0 }"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useVehicleModel" sm="12" md="12" lg="3" xl="3">
							<b-form-group :label="FormMSG(1232, 'Model')">
								<label>
									{{ FormMSG(1232, 'Model') }}
									<span class="required">{{ projectFieldOption.mandatoryVehicleModel ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.vehicule.model"
									type="text"
									:placeholder="FormMSG(1233, 'Vehicle model ...')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryVehicleModel && profile.vehicule.model.length <= 0 }"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useVehiclePlateNumber" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(1232, 'Model') }}
									<span class="required">{{ projectFieldOption.mandatoryVehiclePlateNumber ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.vehicule.numberPlate"
									type="text"
									:placeholder="FormMSG(1235, 'Your number plate ...')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryVehiclePlateNumber && profile.vehicule.numberPlate.length <= 0 }"
								/>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col v-if="projectFieldOption.useVehicleTransportationMeanDetail" sm="12" md="12" lg="4" xl="4">
							<b-form-group>
								<label>
									{{ FormMSG(1236, 'Type') }}
									<span class="required">{{ projectFieldOption.mandatoryVehicleTransportationMeanDetail ? ' *' : '' }}</span>
								</label>
								<b-form-select
									v-model="profile.vehicule.type"
									:options="vehicleTypes"
									:class="{ 'is-invalid': projectFieldOption.mandatoryVehicleType && profile.vehicule.type.length <= 0 }"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useVehicleTransportationMeanDetail" sm="12" md="12" lg="4" xl="4">
							<b-form-group>
								<label>
									{{ FormMSG(1237, 'Energy') }}
									<span class="required">{{ projectFieldOption.mandatoryVehicleTransportationMeanDetail ? ' *' : '' }}</span>
								</label>
								<b-form-select
									v-model="profile.vehicule.energy"
									:options="vehicleEnergies"
									:class="{ 'is-invalid': projectFieldOption.mandatoryVehicleEnergy && profile.vehicule.energy.length <= 0 }"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useVehicleKgCoTwo" sm="12" md="12" lg="4" xl="4">
							<b-form-group>
								<label>
									{{ FormMSG(1238, 'Kg CO2 per') }} {{ distanceUnit }}
									<span class="required">{{ projectFieldOption.mandatoryVehicleKgCoTwo ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.vehicule.kgCoTwoPerKm"
									type="number"
									step="0.01"
									min="0"
									placeholder="0"
									:class="{ 'is-invalid': projectFieldOption.mandatoryVehicleKgCoTwoPerKm && profile.vehicule.kgCoTwoPerKm.length <= 0 }"
								/>
							</b-form-group>
						</b-col>
					</b-row>
				</div>
			</b-collapse>
		</div>
		<!-- Other-->
		<div v-if="isOtherSectionVisible" class="card-collapsible mt-3">
			<div class="cursor-pointer header-card-collapsible d-flex flex-row align-items-center" @click="handleClickHeader('other')">
				<div class="title w-90">
					<b-icon icon="list" style="color: rgba(6, 38, 62, 0.84)" /><span class="ml-3">{{ FormMSG(73, 'Other') }}</span>
				</div>
				<div class="d-flex justify-content-end w-10">
					<b-button v-if="otherMandatoryCount > 0" pill variant="warning" class="mr-2">
						{{ otherMandatoryCount + ' ' + FormMSG(2365, 'field(s) left') }}
					</b-button>
					<component :is="getIconLucide('ChevronDown')" v-if="!configAccordion['other'].isVisible" color="#06263E" :size="22" />
					<component :is="getIconLucide('ChevronUp')" v-if="configAccordion['other'].isVisible" color="#06263E" :size="22" />
				</div>
			</div>
			<b-collapse :visible="configAccordion['other'].isVisible">
				<div v-if="isPrivacyOptionsVisible" class="sub-title">
					{{ FormMSG(10147, 'Privacy options') }}
				</div>
				<div v-if="isPrivacyOptionsVisible" class="content-card-collapsible">
					<b-row>
						<b-col v-if="projectFieldOption.showMyEmailInCrewList" sm="12" md="12" lg="3" xl="3">
							<b-form-checkbox v-model="profile.showMyEmailInCrew" size="lg" class="pj-cb pb-1">
								{{ FormMSG(11486, 'Show my email in crew list') }}
							</b-form-checkbox>
						</b-col>
						<b-col v-if="projectFieldOption.showMyPhoneInCrewList" sm="12" md="12" lg="3" xl="3">
							<b-form-checkbox v-model="profile.showMyPhoneInCrew" size="lg" class="pj-cb pb-1">
								{{ FormMSG(118569, 'Show my phone in crew list') }}
							</b-form-checkbox>
						</b-col>
					</b-row>
				</div>
				<div v-if="isPrivacyOptionsVisible" class="divider" />
				<div v-if="isLoyaltyCardsVisible" class="sub-title">
					{{ FormMSG(1280, 'Loyalty cards') }}
				</div>
				<div v-if="isLoyaltyCardsVisible" class="content-card-collapsible">
					<b-row>
						<b-col v-if="projectFieldOption.useSncfLoyaltyCard" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(1281, 'SNCF loyalty card') }}
									<span class="text-fin">{{ FormMSG(1282, '(Type + number)') }}</span>
									<span class="required">{{ projectFieldOption.mandatorySncfLoyaltyCard ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.trainLoyaltyCard"
									type="text"
									:placeholder="FormMSG(1283, 'Enter your sncf loyalty card')"
									:class="{ 'is-invalid': projectFieldOption.mandatorySncfLoyaltyCard && profile.trainLoyaltyCard.length <= 0 }"
									@change="handleChangeUser(profile.trainLoyaltyCard, 'trainLoyaltyCard')"
									@keydown.enter.prevent
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useSncfDiscountCard" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(1284, 'SNCF discount card') }}
									<span class="text-fin">{{ FormMSG(1282, '(Type + number)') }}</span>
									<span class="required">{{ projectFieldOption.mandatorySncfDiscountCard ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.trainDiscountCard"
									type="text"
									:placeholder="FormMSG(1285, 'Enter your sncf discount card')"
									:class="{ 'is-invalid': projectFieldOption.mandatorySncfDiscountCard && profile.trainDiscountCard.length <= 0 }"
									@change="handleChangeUser(profile.trainDiscountCard, 'trainDiscountCard')"
									@keydown.enter.prevent
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useFlyingBlueCard" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(1286, 'Flying blue card') }}
									<span class="text-fin">{{ FormMSG(1287, '(Number)') }}</span>
									<span class="required">{{ projectFieldOption.mandatoryFlyingBlueCard ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.flyingLoyaltyCard"
									type="text"
									:placeholder="FormMSG(1288, 'Enter your flying blue card')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryFlyingBlueCard && profile.flyingLoyaltyCard.length <= 0 }"
									@change="handleChangeUser(profile.flyingLoyaltyCard, 'flyingLoyaltyCard')"
									@keydown.enter.prevent
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useOtherAirlineCard" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(1289, 'Other airline card') }}
									<span class="text-fin">{{ FormMSG(1287, '(Number)') }}</span>
									<span class="required">{{ projectFieldOption.mandatoryOtherAirlineCard ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.otherAirlineCard"
									type="text"
									:placeholder="FormMSG(1288, 'Enter your other airline card')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryOtherAirlineCard && profile.otherAirlineCard.length <= 0 }"
									@change="handleChangeUser(profile.otherAirlineCard, 'otherAirlineCard')"
									@keydown.enter.prevent
								/>
							</b-form-group>
						</b-col>
					</b-row>
				</div>
				<div v-if="isLoyaltyCardsVisible" class="divider" />
				<div v-if="isForeignVisible" class="sub-title">
					{{ FormMSG(1290, 'Foreign worker') }}<span class="text-fin">{{ FormMSG(1291, "(to fill only if you're a foraign worker)") }}</span>
				</div>
				<div v-if="isForeignVisible" class="content-card-collapsible">
					<b-row>
						<b-col v-if="projectFieldOption.useResidencePermitNumber" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(1292, 'Residence permit number') }}
									<span class="required">{{ projectFieldOption.mandatoryResidencePermitNumber ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.residencePermitNumber"
									type="text"
									:placeholder="FormMSG(1293, 'Enter your residence permit number')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryResidencePermitNumber && profile.residencePermitNumber.length <= 0 }"
									@change="handleChangeUser(profile.residencePermitNumber, 'residencePermitNumber')"
									@keydown.enter.prevent
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useResidenceValidityEnd" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(1294, 'Residence permit validity end') }}
									<span class="required">{{ isMandatory('ResidenceValidityEnd') ? ' *' : '' }}</span>
								</label>
								<!-- <b-form-input
									type="date"
									:value="displayDateResidencePermitEndValidity"
									:placeholder="FormMSG(1295, 'DD/MM/YYYY')"
									@input="(e) => updateDate(e, 'residencePermitEndValidity')"
									@keydown.enter.prevent
									:class="{
										'is-invalid':
											projectFieldOption.mandatoryResidenceValidityEnd && profile.residencePermitEndValidity === '0001-01-01T00:00:00Z'
									}"
								/> -->
								<v-date-picker
									v-model="profile.residencePermitEndValidity"
									:locale="lang"
									:masks="masks"
									:attributes="attrs"
									@dayclick="(payload) => handleInputCalendar(payload, 'residencePermitEndValidity')"
								>
									<template #default="{ inputValue, togglePopover }">
										<b-input-group>
											<b-form-input
												v-mask="'##/##/####'"
												:value="inputValue"
												:placeholder="FormMSG(8960, 'DD/MM/YYYY')"
												readonly
												:class="{
													'is-invalid':
														isMandatory('ResidenceValidityEnd') &&
														!isDateValid('residencePermitEndValidity')['residencePermitEndValidity']
												}"
												@click="togglePopover()"
												@change="(value) => handleChangeDate(value, 'residencePermitEndValidity')"
												@keydown.enter.prevent
											/>
											<b-input-group-append>
												<b-input-group-text
													:class="{
														'is-invalid':
															isMandatory('ResidenceValidityEnd') &&
															!isDateValid('residencePermitEndValidity')['residencePermitEndValidity']
													}"
													class="cursor-pointer bg-color-white input-group-text-bg-white"
													@click="togglePopover()"
												>
													<component :is="getLucideIcon('Calendar')" color="rgba(6, 38, 62, .6)" :size="18" :stroke-width="2.25" />
												</b-input-group-text>
											</b-input-group-append>
										</b-input-group>
									</template>
								</v-date-picker>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useResidencePermit" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="residentPermitXid">
									{{ FormMSG(1296, 'Resident permit') }}
									<span class="required">{{ projectFieldOption.mandatoryResidencePermit ? ' *' : '' }}</span>
								</label>
								<b-row class="ml-0">
									<div
										v-if="checkFile(profile.residentPermitXid)"
										class="d-flex justify-content-center align-items-center cursor-pointer"
										:class="{ 'is-invalid': projectFieldOption.mandatoryResidencePermit && profile.residentPermitXid.length <= 0 }"
										@click="onOpenUrl(getImage(profile.residentPermitXid, 'residentPermitXid'))"
									>
										<b-icon icon="file-earmark-pdf-fill" font-scale="2" />
									</div>
									<b-img
										v-else
										v-bind="imgPropSignatureId"
										rounded
										alt="residentPermitXid"
										class="cursor-pointer"
										:src="getImage(profile.residentPermitXid, 'residentPermitXid')"
										:title="FormMSG(254, 'View Image')"
										@click="showImage(profile.residentPermitXid)"
									/>
									<button
										v-if="profile.residentPermitXid && profile.residentPermitXid.length > 0"
										class="btn-transparent pl-0 ml-2"
										@click.prevent.stop="deleteImg('residentPermitXid')"
									>
										<component :is="getIconLucide('Trash2')" :size="24" :stroke-width="1.5" color="#ea4e2c" />
									</button>
									<div
										v-if="projectFieldOption.mandatoryResidencePermit && profile.residentPermitXid.length === 0"
										class="d-flex align-items-center"
									>
										<b-button
											v-b-tooltip.hover.bottom.html="FormMSG(4010, 'Resident permit empty')"
											size="sm"
											class="btn bg-transparent border-0"
										>
											<component :is="getIconLucide(ICONS.ALERT_TRIANGLE.name)" color="#ffc107" :size="30" />
										</b-button>
									</div>
								</b-row>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useWorkCard" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label for="workCardXid">
									{{ FormMSG(1297, 'Work card') }}
									<span class="required">{{ projectFieldOption.mandatoryWorkCard ? ' *' : '' }}</span>
								</label>
								<b-row class="ml-0">
									<div
										v-if="checkFile(profile.workCardXid)"
										class="d-flex justify-content-center align-items-center cursor-pointer"
										:class="{ 'is-invalid': projectFieldOption.mandatoryWorkCard && profile.workCardXid.length <= 0 }"
										@click="onOpenUrl(getImage(profile.workCardXid, 'workCardXid'))"
									>
										<b-icon icon="file-earmark-pdf-fill" font-scale="2" />
									</div>
									<b-img
										v-else
										v-bind="imgPropSignatureId"
										rounded
										alt="workCardXid"
										class="cursor-pointer"
										:src="getImage(profile.workCardXid, 'workCardXid')"
										:title="FormMSG(254, 'View Image')"
										@click="showImage(profile.workCardXid)"
									/>
									<button
										v-if="profile.workCardXid && profile.workCardXid.length > 0"
										class="btn-transparent pl-0 ml-2"
										@click.prevent.stop="deleteImg('workCardXid')"
									>
										<component :is="getIconLucide('Trash2')" :size="24" :stroke-width="1.5" color="#ea4e2c" />
									</button>
									<div v-if="projectFieldOption.mandatoryWorkCard && profile.workCardXid.length === 0" class="d-flex align-items-center">
										<b-button
											v-b-tooltip.hover.bottom.html="FormMSG(4011, 'Work card empty')"
											size="sm"
											class="btn bg-transparent border-0"
										>
											<component :is="getIconLucide(ICONS.ALERT_TRIANGLE.name)" color="#ffc107" :size="30" />
										</b-button>
									</div>
								</b-row>
							</b-form-group>
						</b-col>
					</b-row>
				</div>
				<div v-if="isForeignVisible" class="divider" />
				<div v-if="isMiscellanousVisible" class="sub-title">
					{{ FormMSG(24, 'Miscellanous') }}
				</div>
				<div v-if="isMiscellanousVisible" class="content-card-collapsible">
					<b-row>
						<b-col v-if="projectFieldOption.usePseudonym" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(1298, 'Pseudonym') }}
									<span class="required">{{ projectFieldOption.mandatoryPseudonym ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.pseudonym"
									type="text"
									:placeholder="FormMSG(1299, 'Enter your pseudonym')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryPseudonym && profile.pseudonym.length <= 0 }"
									@change="handleChangeUser(profile.pseudonym, 'pseudonym')"
									@keydown.enter.prevent
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useGenericMentionProfessionalAssociation" sm="12" md="12" lg="4" xl="4">
							<b-form-group>
								<label>
									{{ FormMSG(1300, 'Generic mention professional association') }}
									<span class="required">{{ projectFieldOption.mandatoryGenericMentionProfessionalAssociation ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.professionalAssociation"
									type="text"
									:placeholder="FormMSG(1301, 'Enter your generic mention ...')"
									:class="{
										'is-invalid':
											projectFieldOption.mandatoryGenericMentionProfessionalAssociation && profile.professionalAssociation.length <= 0
									}"
									@change="handleChangeUser(profile.professionalAssociation, 'professionalAssociation')"
									@keydown.enter.prevent
								/>
							</b-form-group>
						</b-col>
					</b-row>
				</div>
				<div v-if="isMiscellanousVisible" class="divider" />
				<div v-if="isRetirementVisible" class="sub-title">{{ FormMSG(1705, 'Retirement') }}</div>
				<div v-if="isRetirementVisible" class="content-card-collapsible">
					<b-row>
						<b-col v-if="projectFieldOption.useRetired" sm="12" md="12" lg="3" xl="3" class="d-flex justify-content-start">
							<b-form-group class="text-center">
								<label>{{ FormMSG(1275, 'Retired ?') }}</label>
								<b-form-checkbox
									v-model="profile.retired"
									class="d-flex justify-content-start"
									size="lg"
									:value="true"
									switch
									@change="handleChangeRetired"
								>
									<span class="text-redired">{{ profile.retired ? FormMSG(1276, 'Yes') : FormMSG(1277, 'No') }}</span>
								</b-form-checkbox>
							</b-form-group>
						</b-col>
						<b-col v-if="profile.retired && projectFieldOption.useRetired" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>{{ FormMSG(1278, 'Retirement date') }}</label>
								<v-date-picker
									v-model="profile.retirementDate"
									:locale="lang"
									:masks="masks"
									:attributes="attrs"
									@dayclick="(payload) => handleInputCalendar(payload, 'retirementDate')"
								>
									<template #default="{ inputValue, togglePopover }">
										<b-input-group>
											<b-form-input
												v-mask="'##/##/####'"
												:value="inputValue"
												:placeholder="FormMSG(8960, 'DD/MM/YYYY')"
												readonly
												:class="{
													'is-invalid': !isDateValid('retirementDate')['retirementDate']
												}"
												@click="togglePopover()"
												@change="(value) => handleChangeDate(value, 'retirementDate')"
												@keydown.enter.prevent
											/>
											<b-input-group-append>
												<b-input-group-text
													:class="{
														'is-invalid': !isDateValid('retirementDate')['retirementDate']
													}"
													class="cursor-pointer bg-color-white input-group-text-bg-white"
													@click="togglePopover()"
												>
													<component :is="getLucideIcon('Calendar')" color="rgba(6, 38, 62, .6)" :size="18" :stroke-width="2.25" />
												</b-input-group-text>
											</b-input-group-append>
										</b-input-group>
										<!-- <div v-if="!isDateValid('retirementDate')['retirementDate']" class="invalid-feedback">
														{{ FormMSG(902, 'Retirement date is required') }}
													</div> -->
									</template>
								</v-date-picker>
							</b-form-group>
						</b-col>
					</b-row>
				</div>
				<div v-if="isRetirementVisible" class="divider" />
				<div v-if="isStudyVisible" class="sub-title">{{ FormMSG(1706, 'Study') }}</div>
				<div v-if="isStudyVisible" class="content-card-collapsible">
					<b-row>
						<b-col v-if="projectFieldOption.useStudyLevel" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(26002, 'Study level') }}
									<span class="required">{{ projectFieldOption.mandatoryStudyLevel ? ' *' : '' }}</span>
								</label>
								<b-form-select
									v-model="profile.studyLevel"
									:options="studyLeveOptions"
									:class="{ 'is-invalid': projectFieldOption.mandatoryStudyLevel && profile.studyLevel === 0 }"
									@change="handleChangeUser(profile.studyLevel, 'studyLevel')"
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useStudyLevel" sm="12" md="12" lg="3" xl="3">
							<b-form-group v-if="profile.studyLevel === OTHER_STUDY">
								<template slot="label">
									<label>{{ FormMSG(8961, 'Other study level') }}</label>
									<span v-if="projectFieldOption.mandatoryStudyLevel" class="required"> *</span>
								</template>
								<b-form-input
									v-model="profile.otherStudyLevel"
									:placeholder="FormMSG(8961, 'Other study level')"
									@change="handleChangeUser(profile.otherStudyLevel, 'otherStudyLevel')"
								/>
							</b-form-group>
						</b-col>
					</b-row>
				</div>
				<div v-if="isStudyVisible" class="divider" />
				<div v-if="isClothesVisible" class="sub-title">{{ FormMSG(1707, 'Clothes') }}</div>
				<div v-if="isClothesVisible" class="content-card-collapsible">
					<b-row>
						<b-col v-if="projectFieldOption.useSize" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(20603, 'Size') }}
									<span class="required">{{ projectFieldOption.mandatorySize ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.size"
									type="text"
									:placeholder="FormMSG(26007, 'Enter your size ...')"
									:class="{ 'is-invalid': projectFieldOption.mandatorySize && profile.size.length <= 0 }"
									@change="handleChangeUser(profile.size, 'size')"
									@keydown.enter.prevent
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.usePantSize" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(26400, 'Pant size') }}
									<span class="required">{{ projectFieldOption.mandatoryPantSize ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.pantSize"
									type="text"
									:placeholder="FormMSG(20608, 'Enter your pant size ...')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryPantSize && profile.pantSize.length <= 0 }"
									@change="handleChangeUser(profile.pantSize, 'pantSize')"
									@keydown.enter.prevent
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useJacketSize" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(26500, 'Jacket size') }}
									<span class="required">{{ projectFieldOption.mandatoryJacketSize ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.jacketSize"
									type="text"
									:placeholder="FormMSG(260090, 'Enter your jacket size ...')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryJacketSize && profile.jacketSize.length <= 0 }"
									@change="handleChangeUser(profile.jacketSize, 'jacketSize')"
									@keydown.enter.prevent
								/>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col v-if="projectFieldOption.useShoeSize" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(20007, 'Shoe size') }}
									<span class="required">{{ projectFieldOption.mandatoryShoeSize ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.shoeSize"
									type="text"
									:placeholder="FormMSG(208000, 'Enter your shoe size ...')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryShoeSize && profile.shoeSize.length <= 0 }"
									@change="handleChangeUser(profile.shoeSize, 'shoeSize')"
									@keydown.enter.prevent
								/>
							</b-form-group>
						</b-col>
						<b-col v-if="projectFieldOption.useTshirtSize" sm="12" md="12" lg="3" xl="3">
							<b-form-group>
								<label>
									{{ FormMSG(2101019, 'Teeshirt size') }}
									<span class="required">{{ projectFieldOption.mandatoryTshirtSize ? ' *' : '' }}</span>
								</label>
								<b-form-input
									v-model="profile.tShirtSize"
									type="text"
									:placeholder="FormMSG(301100, 'Enter your teeshirt size ...')"
									:class="{ 'is-invalid': projectFieldOption.mandatoryTshirtSize && profile.tShirtSize.length <= 0 }"
									@change="handleChangeUser(profile.tShirtSize, 'tShirtSize')"
									@keydown.enter.prevent
								/>
							</b-form-group>
						</b-col>
					</b-row>
				</div>
				<div class="divider" />
				<div class="sub-title">{{ FormMSG(26501, 'Custom fields') }}</div>
				<div class="content-card-collapsible">
					<b-row class="pb-2">
						<!-- <pre>{{ customFields }}</pre> -->
						<!-- <pre>{{ customFieldModels }}</pre> -->
						<b-col
							v-for="(customField, index) in customFields"
							:key="index"
							:xl="sizeFlagInput(customFields.length)"
							:lg="sizeFlagInput(customFields.length)"
							class="d-flex mb-2 w-100"
						>
							<custom-field-template
								v-model="customField[customFieldModels[index]]"
								:field="customField"
								:name-model="customFieldModels[index]"
								:name-group="customField.nameGroup"
								:index="index"
								class="w-100"
								@custom-field-template:payload="onFieldTemplateChanged"
							/>
						</b-col>
					</b-row>
				</div>
				<div class="card-collapsible pb-1">
					<div class="d-flex flex-row align-items-center">
						<b-button
							size="md"
							variant="outline-primary"
							class="w-270-px d-flex justify-content-center align-items-center"
							block
							@click="manageUserCustomFields"
						>
							<component :is="getLucideIcon('PlusCircle')" :size="20" :stroke-width="2.5" />
							<div class="px-2" style="margin-bottom: 0px">
								{{ FormMSG(9001, 'Add/Edit Custom Fields') }}
							</div>
						</b-button>
					</div>
				</div>
			</b-collapse>
		</div>
		<!-- Password-->
		<div v-if="isFilmSingleUserFree || isFilmSingleUser" class="card-collapsible mt-3">
			<div class="cursor-pointer header-card-collapsible d-flex flex-row align-items-center" @click="handleClickHeader('password')">
				<div class="title w-90">
					<b-icon icon="key-fill" style="color: rgba(6, 38, 62, 0.84)" /><span class="ml-3">{{ FormMSG(87, 'Password') }}</span>
				</div>
				<div class="d-flex justify-content-end w-10">
					<component :is="getIconLucide('ChevronDown')" v-if="!configAccordion['password'].isVisible" color="#06263E" :size="22" />
					<component :is="getIconLucide('ChevronUp')" v-if="configAccordion['password'].isVisible" color="#06263E" :size="22" />
				</div>
			</div>
			<b-collapse :visible="configAccordion['password'].isVisible">
				<div class="content-card-collapsible">
					<p class="text-muted">
						* {{ FormMSG(88, "Make sure it's at least 15 characters OR at least 8 characters including a number and a lowercase letter.") }}
					</p>
					<b-button variant="outline-primary" :disabled="statusSendCodeValidation.global" @click="handleChangePassword">
						<span v-if="!statusSendCodeValidation.progress && !statusSendCodeValidation.success">
							{{ FormMSG(89, 'Change Password') }}
						</span>
						<span v-if="statusSendCodeValidation.progress && !statusSendCodeValidation.success">
							<b-spinner label="Loading..." small /> {{ FormMSG(90, 'Send code validation') }}
						</span>
						<span v-if="!statusSendCodeValidation.progress && statusSendCodeValidation.success">
							{{ FormMSG(91, 'Code validation sended') }}
						</span>
					</b-button>
				</div>
			</b-collapse>
		</div>
		<!-- TEAM SESSION -->
		<div v-if="isDeterProject === true" class="card-collapsible mt-3">
			<div class="cursor-pointer header-card-collapsible d-flex flex-row align-items-center" @click="handleClickHeader('deter')">
				<div class="title w-90">
					<component :is="getLucideIcon('UserCog')" :size="20" /><span class="ml-3">{{ FormMSG(131, 'Team session') }}</span>
				</div>
				<div class="d-flex justify-content-end w-10">
					<component :is="getIconLucide('ChevronDown')" v-if="!configAccordion['deter'].isVisible" color="#06263E" :size="22" />
					<component :is="getIconLucide('ChevronUp')" v-if="configAccordion['deter'].isVisible" color="#06263E" :size="22" />
				</div>
			</div>
			<b-collapse :visible="configAccordion['deter'].isVisible">
				<div class="content-card-collapsible">
					<b-table-simple id="deterSessionTeamTable">
						<b-thead head-variant="dark">
							<b-tr>
								<b-th />
								<b-th>{{ FormMSG(465, 'Team A') }}</b-th>
								<b-th>{{ FormMSG(466, 'Team B') }}</b-th>
							</b-tr>
						</b-thead>
						<b-tbody>
							<b-tr>
								<b-th>
									{{ FormMSG(457, 'Session 1') }}
								</b-th>
								<b-td>
									<b-form-checkbox v-model="profile.session1A" size="lg" :value="true" :unchecked-value="false" />
								</b-td>
								<b-td>
									<b-form-checkbox v-model="profile.session1B" size="lg" :value="true" :unchecked-value="false" />
								</b-td>
							</b-tr>
							<b-tr>
								<b-th>
									{{ FormMSG(458, 'Session 2') }}
								</b-th>
								<b-td>
									<b-form-checkbox v-model="profile.session2A" size="lg" :value="true" :unchecked-value="false" />
								</b-td>
								<b-td>
									<b-form-checkbox v-model="profile.session2B" size="lg" :value="true" :unchecked-value="false" />
								</b-td>
							</b-tr>
							<b-tr>
								<b-th>
									{{ FormMSG(459, 'Session 3') }}
								</b-th>
								<b-td>
									<b-form-checkbox v-model="profile.session3A" size="lg" :value="true" :unchecked-value="false" />
								</b-td>
								<b-td>
									<b-form-checkbox v-model="profile.session3B" size="lg" :value="true" :unchecked-value="false" />
								</b-td>
							</b-tr>
							<b-tr>
								<b-th>
									{{ FormMSG(460, 'Session 4') }}
								</b-th>
								<b-td>
									<b-form-checkbox v-model="profile.session4A" size="lg" :value="true" :unchecked-value="false" />
								</b-td>
								<b-td>
									<b-form-checkbox v-model="profile.session4B" size="lg" :value="true" :unchecked-value="false" />
								</b-td>
							</b-tr>
							<b-tr>
								<b-th>
									{{ FormMSG(461, 'Session 5') }}
								</b-th>
								<b-td>
									<b-form-checkbox v-model="profile.session5A" size="lg" :value="true" :unchecked-value="false" />
								</b-td>
								<b-td>
									<b-form-checkbox v-model="profile.session5B" size="lg" :value="true" :unchecked-value="false" />
								</b-td>
							</b-tr>
							<b-tr>
								<b-th>
									{{ FormMSG(462, 'Session 6') }}
								</b-th>
								<b-td>
									<b-form-checkbox v-model="profile.session6A" size="lg" :value="true" :unchecked-value="false" />
								</b-td>
								<b-td>
									<b-form-checkbox v-model="profile.session6B" size="lg" :value="true" :unchecked-value="false" />
								</b-td>
							</b-tr>
							<b-tr>
								<b-th>
									{{ FormMSG(463, 'Session 7') }}
								</b-th>
								<b-td>
									<b-form-checkbox v-model="profile.session7A" size="lg" :value="true" :unchecked-value="false" />
								</b-td>
								<b-td>
									<b-form-checkbox v-model="profile.session7B" size="lg" :value="true" :unchecked-value="false" />
								</b-td>
							</b-tr>
							<b-tr>
								<b-th>
									{{ FormMSG(464, 'Session 8') }}
								</b-th>
								<b-td>
									<b-form-checkbox v-model="profile.session8A" size="lg" :value="true" :unchecked-value="false" />
								</b-td>
								<b-td>
									<b-form-checkbox v-model="profile.session8B" size="lg" :value="true" :unchecked-value="false" />
								</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
				</div>
			</b-collapse>
		</div>
		<!-- AUTHORIZATION -->
		<div class="card-collapsible mt-3">
			<div
				class="header-card-collapsible inside d-flex flex-row align-items-center bgc-grey-light cursor-pointer"
				@click="handleClickHeader('authorisation')"
			>
				<div class="title w-90">
					<b-icon icon="shield-lock-fill" style="color: rgba(6, 38, 62, 0.84)" /><span class="ml-3">{{ FormMSG(133, 'Authorisation') }}</span>
				</div>
				<div class="cursor-pointer d-flex justify-content-end w-10">
					<component :is="getLucideIcon('ChevronDown')" v-if="!configAccordion['authorisation'].isVisible" color="#06263E" :size="22" />
					<component :is="getLucideIcon('ChevronUp')" v-if="configAccordion['authorisation'].isVisible" color="#06263E" :size="22" />
				</div>
			</div>
		</div>
		<b-collapse :visible="configAccordion['authorisation'].isVisible">
			<div class="content-card-collapsible">
				<div>
					<div>
						<b-row>
							<b-col sm="12" md="12">
								<fieldset class="card-inside">
									<legend class="card-inside">
										{{ FormMSG(301, 'Application rights') }}
									</legend>
									<b-row style="padding-left: 30px">
										<b-col md="4" class="mb-3">
											<b-form-checkbox
												v-model="roleUserData.canManageCrewList"
												size="lg"
												:value="true"
												class="pj-cb pb-1"
												:unchecked-value="false"
												@change="handleAccessLevel('canManageCrewList', $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(2970, 'Manage crew list') }}
											</b-form-checkbox>
										</b-col>
									</b-row>
									<b-row style="padding-left: 30px">
										<b-col v-if="useDoc" md="4" class="mb-3">
											<b-form-checkbox
												v-model="roleUserData.canManageDocuments"
												size="lg"
												:value="true"
												class="pj-cb pb-1"
												:unchecked-value="false"
												@change="handleAccessLevel('canManageDocuments', $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(2971, 'Manage documents') }}
											</b-form-checkbox>
										</b-col>
										<b-col v-if="useDoc" md="4" class="mb-3">
											<b-form-checkbox
												v-model="roleUserData.canManageDocumentPackage"
												size="lg"
												:value="true"
												:unchecked-value="false"
												class="pj-cb pb-1"
												@change="handleAccessLevel('canManageDocumentPackage', $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(2440, 'Manage document package') }}
											</b-form-checkbox>
										</b-col>
										<b-col v-if="useCallSheet" md="4" class="mb-3">
											<b-form-checkbox
												v-model="roleUserData.canManageCallSheets"
												size="lg"
												class="pj-cb pb-1"
												@change="handleAccessLevel('canManageCallSheets', $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(2450, 'Manage call sheets') }}
											</b-form-checkbox>
										</b-col>
									</b-row>
									<b-row style="padding-left: 30px">
										<b-col v-if="useAcc" md="4" class="mb-3">
											<b-form-checkbox
												v-model="roleUserData.canManageAccommodations"
												size="lg"
												:value="true"
												class="pj-cb pb-1"
												:unchecked-value="false"
												@change="handleAccessLevel('canManageAccommodations', $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(2973, 'Manage accomodations') }}
											</b-form-checkbox>
										</b-col>
										<b-col v-if="useLoc" md="4" class="mb-3">
											<b-form-checkbox
												v-model="roleUserData.canManageLocations"
												size="lg"
												:value="true"
												:unchecked-value="false"
												class="pj-cb pb-1"
												@change="handleAccessLevel('canManageLocations', $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(2449, 'Manage locations') }}
											</b-form-checkbox>
										</b-col>
										<b-col v-if="useTrans" md="4" class="mb-3">
											<b-form-checkbox
												v-model="roleUserData.canManageTransport"
												size="lg"
												:value="true"
												:unchecked-value="false"
												class="pj-cb pb-1"
												@change="handleAccessLevel('canManageTransport', $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(20449, 'Manage transport') }}
											</b-form-checkbox>
										</b-col>
									</b-row>
									<b-row style="padding-left: 30px">
										<b-col v-if="useImportExport" md="4" class="mb-3">
											<b-form-checkbox
												v-model="roleUserData.canExportImport"
												size="lg"
												class="pj-cb pb-1"
												@change="handleAccessLevel('canExportImport', $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(2455, 'Can import/export') }}
											</b-form-checkbox>
										</b-col>
										<!-- <b-col md="4" v-if="useBudget" class="mb-3">
											<b-form-checkbox
												size="lg"
												class="pj-cb pb-1"
												v-model="roleUserData.canViewDepartmentBudget"
												@change="handleAccessLevel('canViewDepartmentBudget', $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(2690, 'View department budget') }}
											</b-form-checkbox>
										</b-col> -->
										<b-col v-if="useBudget" md="4" class="mb-3">
											<b-form-checkbox
												v-model="roleUserData.canViewGlobalBudget"
												size="lg"
												:value="true"
												:unchecked-value="false"
												class="pj-cb pb-1"
												@change="handleAccessLevel('canViewGlobalBudget', $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(24430, 'View global budget') }}
											</b-form-checkbox>
										</b-col>
									</b-row>
									<b-row style="padding-left: 30px">
										<b-col v-if="useGreenTable" md="4" class="mb-3">
											<b-form-checkbox
												v-model="roleUserData.canViewGreenTable"
												size="lg"
												class="pj-cb pb-1"
												@change="handleAccessLevel('canViewGreenTable', $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(245640, 'View Green Table') }}
											</b-form-checkbox>
										</b-col>
										<b-col v-if="useReporting" md="4" class="mb-3">
											<b-form-checkbox
												v-model="roleUserData.canAccessGreenReporting"
												size="lg"
												class="pj-cb pb-1"
												@change="handleAccessLevel(canAccessGreenReporting, $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(24560, 'View Green reporting screens') }}
											</b-form-checkbox>
										</b-col>
										<b-col v-if="useCarbonRemoval" md="4" class="mb-3">
											<b-form-checkbox
												v-model="roleUserData.canManageCarbonRemoval"
												size="lg"
												:value="true"
												:unchecked-value="false"
												class="pj-cb pb-1"
												@change="handleAccessLevel('canManageCarbonRemoval', $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(24480, 'Manage carbon removal') }}
											</b-form-checkbox>
										</b-col>
									</b-row>
									<b-row style="padding-left: 30px">
										<b-col v-if="useWaste" md="4" class="mb-3">
											<b-form-checkbox
												v-model="roleUserData.canViewWasteScreens"
												size="lg"
												class="pj-cb pb-1"
												@change="handleAccessLevel('canViewWasteScreens', $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(244005, 'View Waste screens') }}
											</b-form-checkbox>
										</b-col>
										<b-col v-if="useTipOfDay" md="4" class="mb-3">
											<b-form-checkbox
												v-model="roleUserData.canManageTipOfTheDay"
												size="lg"
												class="pj-cb pb-1"
												@change="handleAccessLevel('canManageTipOfTheDay', $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(24405, 'Manage tip of the day') }}
											</b-form-checkbox>
										</b-col>
									</b-row>
									<b-row style="padding-left: 30px">
										<b-col md="4">
											<b-form-checkbox
												v-model="roleUserData.canAccessConfig"
												size="lg"
												class="pj-cb pb-1 mb-3"
												@change="handleAccessLevel(canAccessConfig, $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(246, 'Can access config') }}
											</b-form-checkbox>
										</b-col>
									</b-row>
									<b-row style="padding-left: 30px">
										<b-col md="4" class="mb-3">
											<b-form-checkbox
												v-if="!hideProjectSalaryInfo"
												v-model="roleUserData.hideSalaryInfo"
												size="lg"
												class="pj-cb pb-1 mb-3"
												@change="handleAccessLevel(hideSalaryInfo, $event, roleUserData, screenAccess)"
											>
												{{ FormMSG(247, 'Hide Salary Information') }}
											</b-form-checkbox>
											<b-form-checkbox v-else size="lg" :value="false" class="pj-cb pb-1 mb-3" disabled>
												{{ FormMSG(247, 'Hide Salary Information') }}
											</b-form-checkbox>
										</b-col>
									</b-row>
								</fieldset>
								<fieldset v-if="needValidation" class="card-inside">
									<legend class="card-inside">
										{{ FormMSG(302, 'Validation rights') }}
									</legend>
									<div class="lh-22">
										<h6>
											<b>{{ FormMSG(303, 'Validation level for PO, Expenses and Timehseets') }}</b>
										</h6>
										<b-form-select
											id="valLevel"
											v-model="roleUserData.validationLevel"
											:options="optionsForValidationLevel"
											size="md"
											@change="manageValidationChange(roleUserData)"
										/>
									</div>
								</fieldset>
								<fieldset v-if="useDoc" class="card-inside">
									<legend class="card-inside">
										{{ FormMSG(305, 'Onboarding validation role') }}
									</legend>
									<div class="lh-22">
										<b-row>
											<b-col md="4">
												<b-form-checkbox
													v-model="roleUserData.gateKeeper"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleAccessLevel(gateKeeper, $event, roleUserData, isRole)"
												>
													{{ FormMSG(266, 'Gate Keeper') }}
												</b-form-checkbox>
											</b-col>
											<b-col md="4">
												<b-form-checkbox
													v-model="roleUserData.productionAccountant"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleAccessLevel(productionAccountant, $event, roleUserData, isRole)"
												>
													{{ FormMSG(261, 'Production Account') }}
												</b-form-checkbox>
											</b-col>
											<b-col md="4">
												<b-form-checkbox
													v-model="roleUserData.upm"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleAccessLevel(upm, $event, roleUserData, isRole)"
												>
													{{ FormMSG(262, 'UPM') }}
												</b-form-checkbox>
											</b-col>
											<b-col md="4">
												<b-form-checkbox
													v-model="roleUserData.lineProducer"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleAccessLevel(lineProducer, $event, roleUserData, isRole)"
												>
													{{ FormMSG(263, 'Line Producer') }}
												</b-form-checkbox>
											</b-col>
											<b-col md="4">
												<b-form-checkbox
													v-model="roleUserData.studio"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleAccessLevel(studio, $event, roleUserData, isRole)"
												>
													{{ FormMSG(265, 'Studio') }}
												</b-form-checkbox>
											</b-col>
											<b-col md="4">
												<b-form-checkbox
													v-model="roleUserData.canValidateI9"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleAccessLevel(canValidateI9, $event, roleUserData, screenAccess)"
												>
													{{ FormMSG(270, 'Verify I-9') }}
												</b-form-checkbox>
											</b-col>
										</b-row>
									</div>
								</fieldset>
								<fieldset v-if="usePoAndExp" class="card-inside">
									<legend class="card-inside">
										{{ FormMSG(355, 'Editing authorization') }}
									</legend>
									<div class="lh-22">
										<b-row>
											<b-col v-if="useExp" md="4">
												<b-form-checkbox
													v-model="roleUserData.canEditExpense"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleAccessLevel(canEditExpense, $event, roleUserData, screenAccess)"
												>
													{{ FormMSG(282, 'Can edit Expenses/Invoices') }}
												</b-form-checkbox>
											</b-col>
											<b-col v-if="usePo" md="4">
												<b-form-checkbox
													v-model="roleUserData.canEditPo"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleAccessLevel(canEditPo, $event, roleUserData, screenAccess)"
												>
													{{ FormMSG(255, 'Can edit PO') }}
												</b-form-checkbox>
											</b-col>
											<!-- <b-col v-if="usePo" md="3">
												<b-form-checkbox
													v-model="roleUserData.canEditPo"
													@change="handleAccessLevel(canEditPo, $event, roleUserData, screenAccess)"
													size="lg"
													class="pj-cb mb-3 pb-1"
												>
													{{ FormMSG(280, 'Can edit Invoices') }}
												</b-form-checkbox>
											</b-col> -->
											<b-col md="4">
												<!-- User access to delete PO/Expense in the budget GL. -->
												<b-form-checkbox
													v-model="roleUserData.canDeleteAfterValidation"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleAccessLevel(canDeleteAfterValidation, $event, roleUserData, screenAccess)"
												>
													{{ FormMSG(281, 'Can delete Expenses/PO/Invoices') }}
												</b-form-checkbox>
											</b-col>
											<b-col v-if="useExpenseInvoiceProject" md="4">
												<b-form-checkbox
													v-model="roleUserData.useExpenseInvoice"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleAccessLevel('useExpenseInvoice', $event, roleUserData, screenAccess)"
												>
													{{ FormMSG(4911, 'Can create invoice') }}
												</b-form-checkbox>
											</b-col>
											<b-col v-if="useFinance || useTimesheet || useExp || usePo" md="4">
												<b-form-checkbox
													v-model="roleUserData.canMarkEntryAsProcessed"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleAccessLevel('canMarkEntryAsProcessed', $event, roleUserData, screenAccess)"
												>
													{{ FormMSG(4910, 'Can Mark Entry As Proccessed') }}
												</b-form-checkbox>
											</b-col>
										</b-row>
									</div>
								</fieldset>
								<fieldset class="card-inside">
									<legend class="card-inside">
										{{ FormMSG(360, 'Accounting/Budget situation') }}
									</legend>
									<div class="lh-22">
										<b-row>
											<b-col md="4">
												<b-form-checkbox
													v-model="roleUserData.canLockBudget"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleAccessLevel(canLockBudget, $event, roleUserData, screenAccess)"
												>
													{{ FormMSG(361, 'Can lock/unlock initial budget') }}
												</b-form-checkbox>
											</b-col>
											<b-col md="4">
												<b-form-checkbox
													v-model="roleUserData.canModifyEstimatedFinalCost"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleAccessLevel(canModifyEstimatedFinalCost, $event, roleUserData, screenAccess)"
												>
													{{ FormMSG(362, 'Can modify EFC') }}
												</b-form-checkbox>
											</b-col>

											<b-col v-if="usePoAndExp" md="4">
												<!-- User access to delete PO/Expense in the budget GL. -->
												<b-form-checkbox
													v-model="roleUserData.canEditAndAddCode"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleAccessLevel(canEditAndAddCode, $event, roleUserData, screenAccess)"
												>
													{{ FormMSG(363, 'Can edit/add codes') }}
												</b-form-checkbox>
											</b-col>
										</b-row>
									</div>
								</fieldset>
								<fieldset v-if="showEntryForCrew" class="card-inside">
									<legend class="card-inside">
										{{ FormMSG(356, 'Entry for someone else') }}
									</legend>
									<div class="lh-22">
										<b-row>
											<b-col v-if="showEntryForCrewTimesheet" md="4">
												<b-form-checkbox
													v-model="userEntryLevel.timeSheets"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleUserEntryLevelChange"
												>
													{{ FormMSG(251, 'Timesheets') }}
												</b-form-checkbox>
											</b-col>
											<b-col v-if="showEntryForCrewExpenses" md="4">
												<b-form-checkbox
													v-model="userEntryLevel.expenses"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleUserEntryLevelChange"
												>
													{{ FormMSG(252, 'Expenses') }}
												</b-form-checkbox>
											</b-col>
											<b-col v-if="showEntryForCrewPo" md="4">
												<b-form-checkbox
													v-model="userEntryLevel.po"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleUserEntryLevelChange"
												>
													{{ FormMSG(253, 'PO') }}
												</b-form-checkbox>
											</b-col>
											<b-col v-if="showEntryForCrewInvoices" md="4">
												<b-form-checkbox
													v-model="userEntryLevel.invoice"
													size="lg"
													class="pj-cb mb-3 pb-1"
													@change="handleUserEntryLevelChange"
												>
													{{ FormMSG(283, 'Invoices') }}
												</b-form-checkbox>
											</b-col>
										</b-row>
										<h6 v-show="userEntryLevel.po || userEntryLevel.expenses || userEntryLevel.timeSheets || userEntryLevel.invoice">
											<b>
												{{ FormMSG(357, 'Department selection') }}
											</b>
										</h6>
										<v-select
											v-show="userEntryLevel.po || userEntryLevel.expenses || userEntryLevel.timeSheets || userEntryLevel.invoice"
											v-model="selectedDepartment"
											class="style-chooser"
											multiple
											placeholder="Select a department"
											label="text"
											:options="allDepartements"
											@input="checkDepartment"
										>
											<template #option="option">
												<b-form-checkbox v-model="option.selected" disabled size="lg" class="pj-cb mb-3 pb-1">
													{{ option.text }}
												</b-form-checkbox>
											</template>
										</v-select>
									</div>
								</fieldset>
							</b-col>
						</b-row>
					</div>
				</div>
			</div>
		</b-collapse>
		<NewCapture
			:key="refreshTokenCaptureItem"
			v-model="capturePict"
			parent-type="user"
			:parent-id="profile.id"
			auto-crop-capture
			cam-mode-first
			only-one-crop-mode
			@change="handleImgsTaked"
		/>
		<b-modal
			ref="my-modal"
			v-model="cropPict"
			header-class="header-class-modal-doc-package"
			title="Crop Picture"
			size="cropSize"
			ok-variant="success"
			ok-title="Confirm Save"
			cancel-title="Cancel"
			@ok="endCrop"
			@cancel="endCropCancel"
		>
			<CropPicture ref="myCropPicture" />
		</b-modal>
		<change-mail-modal
			:open="showChangeMailModal"
			:profile="profile"
			@modal:close="showChangeMailModal = false"
			@change-mail-modal:save="handleMailModalSave"
		/>
		<change-phone-modal
			:open="showChangePhoneModal"
			:profile="profile"
			@modal:close="showChangePhoneModal = false"
			@change-phone-modal:save="handlePhoneModalSave"
		/>
		<validation-code-modal
			:open="showValidationCodeModal"
			:email-for-validation="profile.email"
			@validation-code-modal:save="handleValidationCodeModalSave"
			@modal:close="handleValidationCodeModalClose"
		/>
		<b-modal
			v-model="openPictureModal"
			header-class="header-class-modal-doc-package"
			:title="FormMSG(105, 'Picture')"
			class="modal-success"
			ok-variant="success"
			ok-only
			@ok="openPictureModal = false"
		>
			<div>
				<b-img :src="imgToShow" fluid-grow />
			</div>
		</b-modal>
		<custom-field-modal
			ref="userCustomField"
			v-model="isUserCustomFieldModalOpen"
			:parent-type="defaultUserCustomFieldParentType"
			@custom-field-main-modal:closed="onUserCustomFieldMainModalClosed"
			@custom-field-main-modal:reload="onUserCustomFieldMainModalReloaded"
		/>
	</div>
</template>
<script>
import _ from 'lodash';
import languageMessages from '@/mixins/languageMessages';
// import gql from 'graphql-tag';
import { isNil, noTilde, getObjectFromValue } from '~utils';
import * as icons from 'lucide-vue';
import { isValidIBANNumber, isBic } from '@/shared/iban-validator';
import { store } from '@/store';
import NewCapture from '@/components/CaptureModule/Main';
import CropPicture from '@/components/CropPicture';
import MainAddressLocation from '@/components/LocationService/MainAddressLocation';
import CapturePicture from '@/components/CapturePicture';
// import { profile, updateUserProjectReference } from "@/cruds/users.crud";
import moment from 'moment';
import ShareInformation from '@/components/InfoSheet/ShareInformation';
import isSingleProjectMixin from '@/mixins/isSingleProject.mixin';
import dpaeMixin from '@/mixins/dpae.mixin';
import GlobalMixin from '@/mixins/global.mixin';
import verte from 'verte';
import 'verte/dist/verte.css';
import ChangeMailModal from '@/components/MyProfileMobile/ChangeMailModal';
import ChangePhoneModal from '@/components/MyProfileMobile/ChangePhoneModal';
import ValidationCodeModal from '@/components/MyProfileMobile/ValidationCodeModal';
import MobileProfilePicCaptureBtn from '@/components/CaptureModule/MobileProfilePicCaptureBtn';
import { reScalingImgWithCanvas } from '@/components/Packages/Captures/capture.utils';
// import { isSecuritySocialNumberValid } from '@/shared/validators/security-solcial.validator';
import {
	addUpdAccessUsers,
	addUpdAccessBudget,
	addUpdAccessMyBudget,
	addUpdProdFromProject,
	addUpdAdminToProject,
	validate,
	GetEncodingValidation
} from '@/cruds/users.crud';
import { getDepartments } from '@/cruds/department.crud';
import { ACCESS_LEVEL } from '@/utils/utils';
import DeterMixin from '@/mixins/deter.mixin';
import { convertIsoToKey } from '@/shared/helpers';
import GoogleAutoComplete from '@/components/GoogleAutoComplete';
import { updatePictureProfile, updatePhoneProfile, updateEmailProfile, updatePictureVehicule } from '@/cruds/profile.crud';
import { getProjectFieldOption } from '@/cruds/project.crud';
import InputMask from 'primevue/inputmask';
import VehiculeForm from '@/modules/transports/components/VehiculeForm.vue';
import CustomFieldModal from '@/components/CustomField/MainModal';
import { CUSTOM_FIELD_PARENT_TYPE, CUSTOM_FIELD_TYPE, OTHER_STUDY, STUDY_LEVEL_MENU } from '@/shared/constants';
import { getCustomFields } from '@/cruds/custom-field.crud';
import CustomFieldTemplate from '@/components/CustomField/CustomFieldTemplate';
import { generateSecureId } from '@/shared/utils';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
//import VehiculeForm from '@/modules/transports/components/VehiculeForm.vue';
import { mapGetters, mapActions } from 'vuex';

const axios = require('axios').create();

// const mutation_UpdMyProfilePicture = gql`
// 	mutation ($picture: String!) {
// 		UpdMyProfile(newProfile: { picture: $picture })
// 	}
// `;

export default {
	name: 'MemoProfile',
	components: {
		CropPicture,
		CapturePicture,
		GoogleAutoComplete,
		NewCapture,
		ShareInformation,
		verte,
		ChangeMailModal,
		ChangePhoneModal,
		ValidationCodeModal,
		MobileProfilePicCaptureBtn,
		InputMask,
		'v-address': MainAddressLocation,
		VehiculeForm,
		CustomFieldModal,
		CustomFieldTemplate,
		VehiculeForm,
		'v-date-picker': DatePicker
	},
	mixins: [languageMessages, isSingleProjectMixin, GlobalMixin, DeterMixin, dpaeMixin],
	props: {
		selectedUserData: {
			type: Object,
			required: true,
			default: () => {}
		},
		data: {
			type: Object,
			required: true,
			default: () => {}
		},
		fillClassContainer: {
			type: String,
			required: false,
			default: 'container-layout' // default empty, or 'container-layout'
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false
		},
		handleAccessLevel: {
			type: Function,
			required: false,
			default: () => {}
		},
		customFieldValues: {
			type: Array,
			required: false,
			default: () => []
		}
	},
	data() {
		const {
			isAdmin,
			isVip,
			isProd,
			canAssign,
			canAccessUsers,
			canAccessBudget,
			canAccessMyBudget,
			canAccessGreenReporting,
			canAccessConfig,
			hideSalaryInfo,
			canAccessOnboarding,
			canAccessCrewList,
			canValidateI9,
			gateKeeper,
			productionAccountant,
			upm,
			lineProducer,
			studio,
			useExpenseInvoice,
			canMarkEntryAsProcessed,
			canEditExpense,
			canEditPo,
			canDeleteAfterValidation,
			canLockBudget,
			canModifyEstimatedFinalCost,
			canEditAndAddCode,
			screenAccess,
			isRole,
			delValidationRole,
			addUpdValidationRole
		} = ACCESS_LEVEL;
		return {
			OTHER_STUDY,
			profileFieldsSetToNull: [
				'taxesPercentage',
				'civilStatus',
				'studyLevel',
				'numberOfDependentChild',
				'numberOfDisabledChild',
				'numberOfDependentPerson',
				'numberOfDisabledPerson'
			],
			masks: {
				input: 'DD/MM/YYYY'
			},
			attrs: [
				{
					highlight: {
						fillMode: 'light'
					},
					dates: new Date()
				}
			],
			projectFieldOption: {
				projectId: false,
				usePersonalNumber: false,
				mandatoryPersonalNumber: false,
				useEmail: false,
				mandatoryEmail: false,
				usePhone: false,
				mandatoryPhone: false,
				useFirstName: false,
				mandatoryFirstName: false,
				useLastName: false,
				mandatoryLastName: false,
				useNationality: false,
				mandatoryNationality: false,
				useLanguage: false,
				mandatoryLanguage: false,
				useBirthdate: false,
				mandatoryBirthdate: false,
				usePlaceOfBirth: false,
				mandatoryPlaceOfBirth: false,
				useCityOfBirthZip: false,
				mandatoryCityOfBirthZip: false,
				useGender: false,
				mandatoryGender: false,
				useProfilePicture: false,
				mandatoryProfilePicture: false,
				useSocialSecurityNumber: false,
				mandatorySocialSecurityNumber: false,
				useNationalRegistrationNumber: false,
				mandatoryNationalRegistrationNumber: false,
				useCompanyNumber: false,
				mandatoryCompanyNumber: false,
				useIdName: false,
				mandatoryIdName: false,
				useIdNumber: false,
				mandatoryIdNumber: false,
				useIdPictureFront: false,
				mandatoryIdPictureFront: false,
				useIdPictureBack: false,
				mandatoryIdPictureBack: false,
				useDriverLicenseNumber: false,
				mandatoryDriverLicenseNumber: false,
				useDriverLicensePictureFront: false,
				mandatoryDriverLicensePictureFront: false,
				useDriverLicensePictureBack: false,
				mandatoryDriverLicensePictureBack: false,
				useSignaturePicture: false,
				mandatorySignaturePicture: false,
				useIban: false,
				mandatoryIban: false,
				useBic: false,
				mandatoryBic: false,
				useCountry: false,
				mandatoryCountry: false,
				useInternetResearch: false,
				mandatoryInternetResearch: false,
				useStreet: false,
				mandatoryStreet: false,
				useNumber: false,
				mandatoryNumber: false,
				useBox: false,
				mandatoryBox: false,
				useZipCode: false,
				mandatoryZipCode: false,
				useCity: false,
				mandatoryCity: false,
				useStateRegion: false,
				mandatoryStateRegion: false,
				useCivilStatus: false,
				mandatoryCivilStatus: false,
				useSpouseFirstName: false,
				mandatorySpouseFirstName: false,
				useSpouseLastName: false,
				mandatorySpouseLastName: false,
				useSpouseBirthdate: false,
				mandatorySpouseBirthdate: false,
				useSpouseHasSalary: false,
				mandatorySpouseHasSalary: false,
				useSpouseProfession: false,
				mandatorySpouseProfession: false,
				useNumberOfDependentChildren: false,
				mandatoryNumberOfDependentChildren: false,
				useNumberOfDisabledChildren: false,
				mandatoryNumberOfDisabledChildren: false,
				useNumberOfDependentPerson: false,
				mandatoryNumberOfDependentPerson: false,
				useNumberOfDisabledPerson: false,
				mandatoryNumberOfDisabledPerson: false,
				useContactName: false,
				mandatoryContactName: false,
				useContactPhoneNumber: false,
				mandatoryContactPhoneNumber: false,
				useTaxes: false,
				mandatoryTaxes: false,
				useTaxDeclarationCountry: false,
				mandatoryTaxDeclarationCountry: false,
				showMyEmailInCrewList: false,
				showMyPhoneInCrewList: false,
				useWorkerWithADisability: false,
				mandatoryWorkerWithADisability: false,
				useHaveAllergies: false,
				mandatoryHaveAllergies: false,
				useAllergiesDetails: false,
				mandatoryAllergiesDetails: false,
				useColor: false,
				mandatoryColor: false,
				useStudyLevel: false,
				mandatoryStudyLevel: false,
				useSize: false,
				mandatorySize: false,
				usePantSize: false,
				mandatoryPantSize: false,
				useJacketSize: false,
				mandatoryJacketSize: false,
				useShoeSize: false,
				mandatoryShoeSize: false,
				useTshirtSize: false,
				mandatoryTshirtSize: false,
				useMaidenName: false,
				mandatoryMaidenName: false,
				useTitle: false,
				mandatoryTitle: false,
				useCountryOfBirth: false,
				mandatoryCountryOfBirth: false,
				useCongesSpectacleId: false,
				mandatoryCongesSpectacleId: false,
				useDriverLicense: false,
				mandatoryDriverLicense: false,
				usedBankAccountOwnerName: false,
				mandatoryBankAccountOwnerName: false,
				usedBankDetailDocument: false,
				mandatoryBankDetailDocument: false,
				useSocialSecurityCard: false,
				mandatorySocialSecurityCard: false,
				useInsuranceCertificate: false,
				mandatoryInsuranceCertificate: false,
				useSocialSecurityCenter: false,
				mandatorySocialSecurityCenter: false,
				useSocialSecurityCenterAddress: false,
				mandatorySocialSecurityCenterAddress: false,
				useLastMedicalVisitDate: false,
				mandatoryLastMedicalVisitDate: false,
				useMedicalVisitValidity: false,
				mandatoryMedicalVisitValidity: false,
				useMedicalVisitDocument: false,
				mandatoryMedicalVisitDocument: false,
				useDisabilityNotificationDate: false,
				mandatoryDisabilityNotificationDate: false,
				useType: false,
				mandatoryType: false,
				useStatus: false,
				mandatoryStatus: false,
				useInvalidity: false,
				mandatoryInvalidity: false,
				useRqth: false,
				mandatoryRqth: false,
				useInvalidityPercentage: false,
				mandatoryInvalidityPercentage: false,
				useVehicleName: false,
				mandatoryVehicleName: false,
				useVehicleBrand: false,
				mandatoryVehicleBrand: false,
				useVehicleModel: false,
				mandatoryVehicleModel: false,
				useVehiclePlateNumber: false,
				mandatoryVehiclePlateNumber: false,
				useVehicleTransportationMean: false,
				mandatoryVehicleTransportationMean: false,
				useVehicleTransportationMeanDetail: false,
				mandatoryVehicleTransportationMeanDetail: false,
				useVehicleKgCoTwo: false,
				usePower: false,
				mandatoryPower: false,
				useGrayCardFrontPicture: false,
				mandatoryGrayCardFrontPicture: false,
				useGrayCardBackPicture: false,
				mandatoryGrayCardBackPicture: false,
				mandatoryVehicleKgCoTwo: false,
				useSncfLoyaltyCard: false,
				mandatorySncfLoyaltyCard: false,
				useSncfDiscountCard: false,
				mandatorySncfDiscountCard: false,
				useFlyingBlueCard: false,
				mandatoryFlyingBlueCard: false,
				useOtherAirlineCard: false,
				mandatoryOtherAirlineCard: false,
				useResidencePermitNumber: false,
				mandatoryResidencePermitNumber: false,
				useResidenceValidityEnd: false,
				mandatoryResidenceValidityEnd: false,
				useResidencePermit: false,
				mandatoryResidencePermit: false,
				useWorkCard: false,
				mandatoryWorkCard: false,
				usePseudonym: false,
				mandatoryPseudonym: false,
				useGenericMentionProfessionalAssociation: false,
				mandatoryGenericMentionProfessionalAssociation: false,
				useRetired: false,
				mandatoryRetired: false
			},
			userBankWarning: {
				iban: false,
				bic: false,
				secondIban: false,
				secondBic: false
			},
			isSocSecNumberWarning: false,
			profile: {
				taxesPercentage: 0
			},
			allDeps: {
				value: -1,
				message: 'All Departments'
			},
			projectID: 0,
			capturePict: false,
			cropPict: false,
			allDepartements: [],
			selectedDepartment: [],
			pdfFile: '',
			refreshTokenCaptureItem: 0,
			haveAllergies: false,
			haveDependents: false,
			countryKey: 16965, // Belgium's countryKey
			countryKeyPostalAddress: 16965,
			countryCode: 'BE',
			countryCodePostalAddress: 'BE',
			haveChild: false,
			isShowPostalAddress: false,
			showChangeMailModal: false,
			showChangePhoneModal: false,
			showValidationCodeModal: false,
			codeValidation: 0,
			statusSendCodeValidation: {
				global: false,
				progress: false,
				success: false
			},
			isMyProfileLoading: false,
			showInfoCapture: false,
			configAccordion: {
				'personnal-data': {
					isVisible: true
				},
				identification: {
					isVisible: false
				},
				finance: {
					isVisible: false
				},
				health: {
					isVisible: false
				},
				address: {
					isVisible: false
				},
				family: {
					isVisible: false
				},
				other: {
					isVisible: false
				},
				password: {
					isVisible: false
				},
				deter: {
					isVisible: false
				},
				authorisation: {
					isVisible: false
				},
				'personal-vehicle': {
					isVisible: false
				}
			},
			imgPropPictureId: { blank: true, blankColor: '#d5d6d7', width: 32, height: 32, class: 'm1' },
			imgPropPictureIdVerso: { blank: true, blankColor: '#d5d6d7', width: 32, height: 32, class: 'm1' },
			imgPropPictureDriverLicense: { blank: true, blankColor: '#d5d6d7', width: 32, height: 32, class: 'm1' },
			imgPropPictureDriverLicenseVerso: { blank: true, blankColor: '#d5d6d7', width: 32, height: 32, class: 'm1' },
			imgPropSignatureId: { blank: true, blankColor: '#d5d6d7', width: 32, height: 32, class: 'm1' },
			openPictureModal: false,
			imgToShow: '',
			isAdmin,
			isVip,
			isProd,
			canAssign,
			canAccessUsers,
			canAccessBudget,
			canAccessMyBudget,
			canAccessGreenReporting,
			canAccessConfig,
			hideSalaryInfo,
			canAccessOnboarding,
			canAccessCrewList,
			canValidateI9,
			gateKeeper,
			productionAccountant,
			upm,
			lineProducer,
			studio,
			useExpenseInvoice,
			canMarkEntryAsProcessed,
			canEditExpense,
			canLockBudget,
			canModifyEstimatedFinalCost,
			canEditAndAddCode,
			canEditPo,
			canDeleteAfterValidation,
			screenAccess,
			isRole,
			delValidationRole,
			addUpdValidationRole,
			userEntryLevel: {},
			isUserCustomFieldModalOpen: false,
			CUSTOM_FIELD_PARENT_TYPE,
			defaultUserCustomFieldParentType: CUSTOM_FIELD_PARENT_TYPE.user,
			customFields: [],
			customFieldModels: [],
			customFieldValueInputs: [],
			// for cleaning internet address search inputs
			clearLegalAddress: false,
			clearPostalAddress: false
		};
	},
	computed: {
		...mapGetters({
			getMyProfile: 'profile/getMyProfile'
		}),
		studyLeveOptions() {
			return [{ value: 0, text: this.FormMSG(896, 'Please select ...'), disabled: true }, ...this.FormMenu(STUDY_LEVEL_MENU)];
		},
		allMandatoryIsFilled() {
			if (
				this.personalDataMandatoryCount > 0 ||
				this.identificationMandatoryCount > 0 ||
				this.financeMandatoryCount > 0 ||
				this.addressMandatoryCount > 0 ||
				this.healthMandatoryCount > 0 ||
				this.otherMandatoryCount > 0 ||
				this.personalVehicleMandatoryCount > 0
			) {
				return false;
			} else {
				return true;
			}
		},
		personalDataMandatoryCount() {
			let emptyFieldCount = 0;
			if (this.projectFieldOption.mandatoryEmail && this.profile.email.length <= 0) {
				emptyFieldCount++;
			}
			if (this.projectFieldOption.mandatoryPhone && this.profile.phone.length <= 0) {
				emptyFieldCount++;
			}
			if (this.projectFieldOption.mandatoryFirstName && this.profile.firstName.length <= 0) {
				emptyFieldCount++;
			}
			if (this.projectFieldOption.mandatoryLastName && this.profile.name.length <= 0) {
				emptyFieldCount++;
			}
			if (this.projectFieldOption.mandatoryNationality && this.profile.nationality.length <= 0) {
				emptyFieldCount++;
			}
			if (this.projectFieldOption.mandatoryLanguage && this.profile.language.length <= 0) {
				emptyFieldCount++;
			}
			if ((this.projectFieldOption.mandatoryBirthdate || this.useDpae) && this.isDateValid('birthDate').birthDate === false) {
				emptyFieldCount++;
			}
			if ((this.projectFieldOption.mandatoryPlaceOfBirth || this.useDpae) && this.profile.placeOfBirth.length <= 0) {
				emptyFieldCount++;
			}
			if (this.projectFieldOption.mandatoryCityOfBirthZip && this.profile.placeOfBirthZip.length <= 0) {
				emptyFieldCount++;
			}
			if ((this.projectFieldOption.mandatoryGender || this.useDpae) && this.profile.gender === 0) {
				emptyFieldCount++;
			}
			if (this.projectFieldOption.mandatoryProfilePicture && this.profile.picture.length <= 0) {
				emptyFieldCount++;
			}
			if (this.projectFieldOption.mandatoryMaidenName && this.profile.maidenName.length <= 0) {
				emptyFieldCount++;
			}
			if (this.projectFieldOption.mandatoryTitle && this.profile.title === 0) {
				emptyFieldCount++;
			}
			if (this.projectFieldOption.mandatoryCountryOfBirth && this.profile.birthCountry.length <= 0) {
				emptyFieldCount++;
			}
			return emptyFieldCount;
		},
		identificationMandatoryCount() {
			let identCount = 0;
			if (this.projectFieldOption.mandatoryNationalRegistrationNumber && this.profile.nationalRegistryNumber.length <= 0) {
				identCount++;
			}
			if (this.projectFieldOption.mandatoryCongesSpectacleId && this.profile.congesSpectacle.length <= 0) {
				identCount++;
			}
			if (this.projectFieldOption.mandatoryCompanyNumber && this.profile.companyNumber.length <= 0) {
				identCount++;
			}
			if (this.projectFieldOption.mandatoryIdName && this.profile.idName.length <= 0) {
				identCount++;
			}
			if (this.projectFieldOption.mandatoryIdNumber && this.profile.idNumber.length <= 0) {
				identCount++;
			}
			if (this.projectFieldOption.mandatoryIdPictureFront && this.profile.pictureId.length <= 0) {
				identCount++;
			}
			if (this.projectFieldOption.mandatoryIdPictureBack && this.profile.pictureIdVerso.length <= 0) {
				identCount++;
			}
			if (this.projectFieldOption.mandatoryDriverLicenseNumber && this.profile.driverLicenseNumber.length <= 0) {
				identCount++;
			}
			if (this.projectFieldOption.mandatoryDriverLicensePictureFront && this.profile.pictureDriverLicense.length <= 0) {
				identCount++;
			}
			if (this.projectFieldOption.mandatoryDriverLicensePictureBack && this.profile.pictureDriverLicenseVerso.length <= 0) {
				identCount++;
			}
			if (this.projectFieldOption.mandatorySignaturePicture && this.profile.signatureId.length <= 0) {
				identCount++;
			}
			if (this.projectFieldOption.mandatoryDriverLicense && this.profile.driverLicense.length <= 0) {
				identCount++;
			}
			return identCount;
		},
		financeMandatoryCount() {
			let financeCount = 0;
			if (this.projectFieldOption.mandatoryIban && this.profile.iban.length <= 0) {
				financeCount++;
			}
			if (this.projectFieldOption.mandatoryBic && this.profile.bic.length <= 0) {
				financeCount++;
			}
			if (this.projectFieldOption.mandatoryTaxes && this.profile.taxesPercentage === null) {
				financeCount++;
			}
			if (this.projectFieldOption.mandatoryTaxDeclarationCountry && this.profile.taxCountry.length <= 0) {
				financeCount++;
			}
			if (this.projectFieldOption.mandatoryBankAccountOwnerName && this.profile.bankAccountOwnerName.length <= 0) {
				financeCount++;
			}
			if (this.projectFieldOption.mandatoryBankDetailDocument && this.profile.bankDetailXid.length <= 0) {
				financeCount++;
			}
			if (this.projectFieldOption.mandatorySecondIban && this.profile.secondIban.length <= 0) {
				financeCount++;
			}
			if (this.projectFieldOption.mandatorySecondBic && this.profile.secondBic.length <= 0) {
				financeCount++;
			}
			if (this.projectFieldOption.mandatorySecondBankAccountOwnerName && this.profile.secondBankAccountOwnerName.length <= 0) {
				financeCount++;
			}
			if (this.projectFieldOption.mandatorySecondBankDetailDocument && this.profile.secondBankDetailXid.length <= 0) {
				financeCount++;
			}
			return financeCount;
		},
		addressMandatoryCount() {
			let addressCount = 0;
			if (this.projectFieldOption.mandatoryCountry && this.countryKey.length <= 0) {
				addressCount++;
			}
			if (this.projectFieldOption.mandatoryStreet && this.profile.address.street.length <= 0) {
				addressCount++;
			}
			if (this.projectFieldOption.mandatoryNumber && this.profile.address.number.length <= 0) {
				addressCount++;
			}
			if (this.projectFieldOption.mandatoryBox && this.profile.address.box.length <= 0) {
				addressCount++;
			}
			if (this.projectFieldOption.mandatoryZipCode && this.profile.address.zip.length <= 0) {
				addressCount++;
			}
			if (this.projectFieldOption.mandatoryCity && this.profile.address.city.length <= 0) {
				addressCount++;
			}
			if (this.projectFieldOption.mandatoryStateRegion && this.profile.address.state.length <= 0) {
				addressCount++;
			}
			return addressCount;
		},
		healthMandatoryCount() {
			let healthCount = 0;
			if (this.projectFieldOption.mandatorySocialSecurityNumber && this.profile.socSecNumber.length <= 0) {
				healthCount++;
			}
			if (this.projectFieldOption.mandatorySocialSecurityCard && this.profile.socialSecurityCardXid.length <= 0) {
				healthCount++;
			}
			if (this.projectFieldOption.mandatoryInsuranceCertificate && this.profile.insuranceCertificateXid.length <= 0) {
				healthCount++;
			}
			if (this.projectFieldOption.mandatorySocialSecurityCenter && this.profile.socialSecurityCenter.length <= 0) {
				healthCount++;
			}
			if (this.projectFieldOption.mandatorySocialSecurityCenterAddress && this.profile.socialSecurityCenterAddressId <= 0) {
				healthCount++;
			}
			if (this.projectFieldOption.mandatoryLastMedicalVisitDate && this.isDateValid('lastMedicalVisit').lastMedicalVisit === false) {
				healthCount++;
			}
			if (this.projectFieldOption.mandatoryMedicalVisitValidity && this.isDateValid('medicalVisitValidity').medicalVisitValidity === false) {
				healthCount++;
			}
			if (this.projectFieldOption.mandatoryMedicalVisitDocument && this.profile.medicalVisitDocumentXid.length <= 0) {
				healthCount++;
			}
			return healthCount + this.healthSubSectionMandatoryCount;
		},
		healthSubSectionMandatoryCount() {
			let healthCount = 0;
			if (this.profile.disabled === true) {
				if (
					this.projectFieldOption.mandatoryDisabilityNotificationDate &&
					this.isDateValid('disabilityNotification').disabilityNotification === false
				) {
					healthCount++;
				}
				if (this.projectFieldOption.mandatoryType && this.profile.disabilityType.length <= 0) {
					healthCount++;
				}
				if (this.projectFieldOption.mandatoryStatus && this.profile.disabilityStatus.length <= 0) {
					healthCount++;
				}
				if (this.projectFieldOption.mandatoryInvalidity && this.profile.invalidity.length <= 0) {
					healthCount++;
				}
				if (this.projectFieldOption.mandatoryRqth && this.profile.rqth.length <= 0) {
					healthCount++;
				}
				if (this.projectFieldOption.mandatoryInvalidityPercentage && this.profile.invalidityPourcentage.length <= 0) {
					healthCount++;
				}
				if (this.haveAllergies === true) {
					if (this.projectFieldOption.mandatoryAllergiesDetails && this.profile.allergies.length <= 0) {
						healthCount++;
					}
				}
			}
			return healthCount;
		},
		familyMandatoryCount() {
			let familyCount = 0;
			if (this.projectFieldOption.mandatoryCivilStatus && this.profile.civilStatus.length <= 0) {
				familyCount++;
			}
			if (this.projectFieldOption.mandatorySpouseFirstName && this.profile.civilStatus === 3 && this.profile.spouseFirstName.length <= 0) {
				familyCount++;
			}
			if (this.projectFieldOption.mandatorySpouseLastName && this.profile.civilStatus === 3 && this.profile.spouseName.length <= 0) {
				familyCount++;
			}
			if (this.projectFieldOption.mandatorySpouseBirthdate && this.profile.civilStatus === 3 && this.profile.spouseBirthDate === '0001-01-01T00:00:00Z') {
				familyCount++;
			}
			if (this.projectFieldOption.mandatorySpouseProfession && this.profile.civilStatus === 3 && this.profile.spouseProfession.length <= 0) {
				familyCount++;
			}
			if (this.projectFieldOption.mandatoryContactName && this.profile.personToContact.length <= 0) {
				familyCount++;
			}
			if (this.projectFieldOption.mandatoryContactPhoneNumber && this.profile.personToContactPhone.length <= 0) {
				familyCount++;
			}
			if (this.projectFieldOption.mandatoryNumberOfDependentChildren && this.profile.numberOfDependentChild === null) {
				familyCount++;
			}
			if (this.projectFieldOption.mandatoryNumberOfDisabledChildren && this.profile.numberOfDisabledChild === null) {
				familyCount++;
			}
			if (this.projectFieldOption.mandatoryNumberOfDependentPerson && this.profile.numberOfDependentPerson === null) {
				familyCount++;
			}
			if (this.projectFieldOption.mandatoryNumberOfDisabledPerson && this.profile.numberOfDisabledPerson === null) {
				familyCount++;
			}
			return familyCount;
		},
		personalVehicleMandatoryCount() {
			let vehicleCount = 0;
			if (this.projectFieldOption.mandatoryVehicleName && this.profile.vehicule.name.length <= 0) {
				vehicleCount++;
			}
			if (this.projectFieldOption.mandatoryVehicleBrand && this.profile.vehicule.brand.length <= 0) {
				vehicleCount++;
			}
			if (this.projectFieldOption.mandatoryVehicleModel && this.profile.vehicule.model.length <= 0) {
				vehicleCount++;
			}
			if (this.projectFieldOption.mandatoryVehiclePlateNumber && this.profile.vehicule.numberPlate.length <= 0) {
				vehicleCount++;
			}
			if (this.projectFieldOption.mandatoryVehicleTransportationMean && this.profile.vehicule.subType.length <= 0) {
				vehicleCount++;
			}
			if (this.projectFieldOption.mandatoryVehicleTransportationMeanDetail && this.profile.vehicule.additionalSubType.length <= 0) {
				vehicleCount++;
			}
			if (this.projectFieldOption.mandatoryVehicleKgCoTwo && this.profile.vehicule.kgCoTwoPerKm.length <= 0) {
				vehicleCount++;
			}
			if (this.projectFieldOption.mandatoryPower && this.profile.vehicule.taxHorsepower.length <= 0) {
				vehicleCount++;
			}
			if (this.projectFieldOption.mandatoryGrayCardFrontPicture && this.profile.vehicule.grayCardXid.length <= 0) {
				vehicleCount++;
			}
			if (this.projectFieldOption.mandatoryGrayCardBackPicture && this.profile.vehicule.grayCardVersoXid.length <= 0) {
				vehicleCount++;
			}
			return vehicleCount;
		},
		otherMandatoryCount() {
			let otherCount = 0;
			if (this.projectFieldOption.mandatorySize && this.profile.size.length <= 0) {
				otherCount++;
			}
			if (this.projectFieldOption.mandatoryStudyLevel && this.profile.studyLevel <= 0) {
				otherCount++;
			}
			if (this.projectFieldOption.mandatoryPantSize && this.profile.pantSize.length <= 0) {
				otherCount++;
			}
			if (this.projectFieldOption.mandatoryJacketSize && this.profile.jacketSize.length <= 0) {
				otherCount++;
			}
			if (this.projectFieldOption.mandatoryShoeSize && this.profile.shoeSize.length <= 0) {
				otherCount++;
			}
			if (this.projectFieldOption.mandatoryTshirtSize && this.profile.tShirtSize.length <= 0) {
				otherCount++;
			}
			if (this.projectFieldOption.mandatorySncfLoyaltyCard && this.profile.trainLoyaltyCard.length <= 0) {
				otherCount++;
			}
			if (this.projectFieldOption.mandatorySncfDiscountCard && this.profile.trainDiscountCard.length <= 0) {
				otherCount++;
			}
			if (this.projectFieldOption.mandatoryFlyingBlueCard && this.profile.flyingLoyaltyCard.length <= 0) {
				otherCount++;
			}
			if (this.projectFieldOption.mandatoryOtherAirlineCard && this.profile.otherAirlineCard.length <= 0) {
				otherCount++;
			}
			if (this.projectFieldOption.mandatoryResidencePermitNumber && this.profile.residencePermitNumber.length <= 0) {
				otherCount++;
			}
			if (
				this.projectFieldOption.mandatoryResidenceValidityEnd &&
				!_.isNil(this.profile.residencePermitEndValidity) &&
				this.profile.residencePermitEndValidity.length <= 0
			) {
				otherCount++;
			}
			if (this.projectFieldOption.mandatoryResidencePermit && this.profile.residentPermitXid.length <= 0) {
				otherCount++;
			}
			if (this.projectFieldOption.mandatoryWorkCard && this.profile.workCardXid.length <= 0) {
				otherCount++;
			}
			if (this.projectFieldOption.mandatoryPseudonym && this.profile.pseudonym.length <= 0) {
				otherCount++;
			}
			if (this.projectFieldOption.mandatoryGenericMentionProfessionalAssociation && this.profile.professionalAssociation.length <= 0) {
				otherCount++;
			}
			return otherCount;
		},
		isDeterAction() {
			if (+this.profile.bankDetailXid.length !== 0 && +this.profile.medicalVisitDocumentXid.length === 0) {
				this.messageContext = this.FormMSG(1711, 'visit medical document');
				this.incompleteProlile = true;
				return true;
			}
			if (+this.profile.bankDetailXid.length === 0 && +this.profile.medicalVisitDocumentXid.length !== 0) {
				this.messageContext = this.FormMSG(1712, 'bank detail document');
				this.incompleteProlile = true;
				return true;
			}
			if (+this.profile.bankDetailXid.length === 0 && +this.profile.medicalVisitDocumentXid.length === 0) {
				this.messageContext = this.FormMSG(1713, 'visit medical document and bank detail document');
				this.incompleteProlile = true;
				return true;
			} else {
				this.messageContext = '';
				this.incompleteProlile = false;
				return false;
			}
		},
		useCallSheet() {
			return store.getCurrentProjectConfig().useCallSheet;
		},
		useFinance() {
			return store.getCurrentProjectConfig().useFinance;
		},
		useExp() {
			return store.getCurrentProjectConfig().useExpense;
		},
		usePo() {
			return store.getCurrentProjectConfig().usePurchaseOrder;
		},
		useTimesheet() {
			return store.getCurrentProjectConfig().useTimesheet;
		},
		useExpenseInvoiceProject() {
			return store.getCurrentProjectConfig().useExpenseInvoice;
		},
		usePoAndExp() {
			return store.getCurrentProjectConfig().useExpense || store.getCurrentProjectConfig().usePurchaseOrder;
		},
		hideProjectSalaryInfo() {
			return store.getCurrentProjectConfig().hideSalaryInfo;
		},
		needValidation() {
			return (
				store.getCurrentProjectConfig().useExpense || store.getCurrentProjectConfig().usePurchaseOrder || store.getCurrentProjectConfig().useTimesheet
			);
		},
		useCarbonTemplate() {
			return store.getCurrentProjectConfig().useCarbonTemplate;
		},
		useGreenTable() {
			return store.getCurrentProjectConfig().useGreenTable;
		},
		useReporting() {
			return store.getCurrentProjectConfig().useReporting;
		},
		useCarbonRemoval() {
			return store.getCurrentProjectConfig().useCarbonRemoval;
		},
		useWaste() {
			return store.getCurrentProjectConfig().useWaste;
		},
		useTipOfDay() {
			return store.getCurrentProjectConfig().useTipOfDay;
		},
		useBudget() {
			return store.getCurrentProjectConfig().useBudget;
		},
		useImportExport() {
			return store.getCurrentProjectConfig().useImport || store.getCurrentProjectConfig().useExport;
		},
		useTrans() {
			return store.getCurrentProjectConfig().useTransport;
		},
		useLoc() {
			return store.getCurrentProjectConfig().useLocations;
		},
		useAcc() {
			return store.getCurrentProjectConfig().useAccommodation;
		},
		useDoc() {
			return store.getCurrentProjectConfig().useDocument;
		},
		menuTitle() {
			let titles = this.FormMenu(1338);
			return titles;
		},
		countryCodes() {
			return this.FormMenu(9);
		},
		distanceUnit() {
			return store.state.myProfile.distanceUnit;
		},
		menuInvalidity() {
			let invalidity = this.FormMenu(1339);
			return invalidity;
		},
		displayDateLastMedicalVisit() {
			const splitDate = this.profile.lastMedicalVisit ? this.profile.lastMedicalVisit.substring(0, 10) : '';
			if (splitDate !== '0001-01-01') {
				return moment(splitDate).format('YYYY-MM-DD');
			}
			return '';
		},
		displayDateMedicalVisitValidity() {
			const splitDate = this.profile.medicalVisitValidity ? this.profile.medicalVisitValidity.substring(0, 10) : '';
			if (splitDate !== '0001-01-01') {
				return moment(splitDate).format('YYYY-MM-DD');
			}
			return '';
		},
		displayDateDisabilityNotification() {
			const splitDate = this.profile.disabilityNotification ? this.profile.disabilityNotification.substring(0, 10) : '';
			if (splitDate !== '0001-01-01') {
				return moment(splitDate).format('YYYY-MM-DD');
			}
			return '';
		},
		displayDateRetirementDate() {
			const splitDate = this.profile.retirementDate ? this.profile.retirementDate.substring(0, 10) : '';
			if (splitDate !== '0001-01-01') {
				return moment(splitDate).format('YYYY-MM-DD');
			}
			return '';
		},
		displayDateResidencePermitEndValidity() {
			const splitDate = this.profile.residencePermitEndValidity ? this.profile.residencePermitEndValidity.substring(0, 10) : '';
			if (splitDate !== '0001-01-01') {
				return moment(splitDate).format('YYYY-MM-DD');
			}
			return '';
		},
		countries() {
			let countries = this.FormMenu(8);

			countries.sort((a, b) => {
				if (noTilde(a.text).toLowerCase() < noTilde(b.text).toLowerCase()) {
					return -1;
				}
				if (noTilde(a.text).toLowerCase() > noTilde(b.text).toLowerCase()) {
					return 1;
				}

				return 0;
			});

			countries = [
				{
					value: 0,
					text: this.FormMSG(187, 'Select a country...')
				},
				...countries
			];

			return countries;
		},
		showEntryForCrew() {
			return store.getCurrentProjectConfig().useEntryForCrew;
		},
		showEntryForCrewTimesheet() {
			return store.getCurrentProjectConfig().useEntryForCrewTimesheet;
		},
		showEntryForCrewExpenses() {
			return store.getCurrentProjectConfig().useEntryForCrewExpenses;
		},
		showEntryForCrewInvoices() {
			return store.getCurrentProjectConfig().useEntryForCrewInvoice;
		},
		showEntryForCrewPo() {
			return store.getCurrentProjectConfig().useEntryForCrewPo;
		},
		optionsForValidationLevel() {
			return this.FormMenu(1113);
		},
		displayBirthDate() {
			const splitBirthDate = this.profile.birthDate ? this.profile.birthDate.toString().substring(0, 10) : '';
			if (splitBirthDate !== '0001-01-01') {
				return splitBirthDate;
			}

			return '';
		},
		displaySpouseBirthDate() {
			const splitBirthDate = this.profile.spouseBirthDate ? this.profile.spouseBirthDate.substring(0, 10) : '';
			if (splitBirthDate !== '0001-01-01') {
				return splitBirthDate;
			}

			return '';
		},
		menuGenders() {
			const res = this.FormMenu(1002);
			return [
				{
					value: null,
					text: this.FormMSG(92, 'Please select an option'),
					disabled: true
				},
				...res
			];
		},
		optionsForCivilStatus() {
			let menu = this.FormMenu(1001);

			menu = menu.filter((item) => item.value !== 0);

			menu.unshift({ value: null, text: this.FormMSG(92, 'Please select an option'), disabled: true });

			return menu;
		},
		optionsForLanguages() {
			let menus = this.FormMenu(1);

			menus.sort((a, b) => {
				if (noTilde(a.text.trim()).toLowerCase() < noTilde(b.text.trim()).toLowerCase()) {
					return -1;
				}
				if (noTilde(a.text.trim()).toLowerCase() > noTilde(b.text.trim()).toLowerCase()) {
					return 1;
				}

				return 0;
			});

			return menus;
		},
		imageName() {
			if (this.profile.picture && this.profile.picture.length > 0) {
				return process.env.VUE_APP_GQL + '/images/' + this.profile.picture;
			} else {
				return 'img/brand/avatar.jpg';
			}
		},
		useTask() {
			return store.getCurrentProjectConfig().useTask;
		},
		isProdStore() {
			return store.isProd();
		},
		isFilmSingleUserFree() {
			return store.isFilmSingleUserFree();
		},
		isFilmSingleUser() {
			return store.isFilmSingleUser();
		},
		isPme() {
			return store.isPme();
		},
		vehicleTypes() {
			let types = this.FormMenu(10003);

			types.sort((a, b) => {
				if (noTilde(a.text).toLowerCase() < noTilde(b.text).toLowerCase()) {
					return -1;
				}
				if (noTilde(a.text).toLowerCase() > noTilde(b.text).toLowerCase()) {
					return 1;
				}

				return 0;
			});

			return types;
		},
		vehicleEnergies() {
			let energies = this.FormMenu(10004);

			energies.sort((a, b) => {
				if (noTilde(a.text).toLowerCase() < noTilde(b.text).toLowerCase()) {
					return -1;
				}
				if (noTilde(a.text).toLowerCase() > noTilde(b.text).toLowerCase()) {
					return 1;
				}

				return 0;
			});

			return energies;
		},
		isIdentificationSectionVisible() {
			return (
				this.projectFieldOption.useNationalRegistrationNumber ||
				this.projectFieldOption.useCompanyNumber ||
				this.projectFieldOption.useCongesSpectacleId ||
				this.projectFieldOption.useSignaturePicture ||
				this.projectFieldOption.useIdName ||
				this.projectFieldOption.useIdNumber ||
				this.projectFieldOption.useIdPictureFront ||
				this.projectFieldOption.useIdPictureBack ||
				this.projectFieldOption.useDriverLicense ||
				this.projectFieldOption.useDriverLicenseNumber ||
				this.projectFieldOption.useDriverLicensePictureBack ||
				this.projectFieldOption.useDriverLicensePictureFront
			);
		},
		isBankInformationVisible() {
			return (
				this.projectFieldOption.useIban ||
				this.projectFieldOption.useBic ||
				this.projectFieldOption.useBankAccountOwnerName ||
				this.projectFieldOption.useBankDetailDocument
			);
		},
		isTaxesVisible() {
			return this.projectFieldOption.useTaxes || this.projectFieldOption.useTaxDeclarationCountry;
		},
		isFinanceSectionVisible() {
			return this.isBankInformationVisible || this.isTaxesVisible;
		},
		isAdressSectionVisible() {
			return (
				this.projectFieldOption.useCountry ||
				this.projectFieldOption.useInternetSearch ||
				this.projectFieldOption.useStreet ||
				this.projectFieldOption.useNumber ||
				this.projectFieldOption.useBox ||
				this.projectFieldOption.useZipCode ||
				this.projectFieldOption.useCity ||
				this.projectFieldOption.useStateRegion
			);
		},
		isHealthSectionVisible() {
			return (
				this.projectFieldOption.useSocialSecurityNumber ||
				this.projectFieldOption.useSocialSecurityCard ||
				this.projectFieldOption.useSocialSecurityCenter ||
				this.projectFieldOption.useSocialSecurityCenterAddress ||
				this.projectFieldOption.useInsuranceCertificate ||
				this.projectFieldOption.useLastMedicalVisitDate ||
				this.projectFieldOption.useMedicalVisitValidity ||
				this.projectFieldOption.useMedicalVisitDocument ||
				this.projectFieldOption.useWorkerWithADisability ||
				this.projectFieldOption.useHaveAllergies ||
				this.projectFieldOption.useAllergiesDetails ||
				this.projectFieldOption.useDisabilityNotificationDate ||
				this.projectFieldOption.useType ||
				this.projectFieldOption.useStatus ||
				this.projectFieldOption.useInvalidity ||
				this.projectFieldOption.useRqth ||
				this.projectFieldOption.useInvalidityPercentage
			);
		},
		isFamilyCompositionVisible() {
			return (
				this.projectFieldOption.useCivilStatus ||
				this.projectFieldOption.useSpouseFirstName ||
				this.projectFieldOption.useSpouseLastName ||
				this.projectFieldOption.useSpouseBirthdate ||
				this.projectFieldOption.useSpouseHasSalary ||
				this.projectFieldOption.useSpouseProfession ||
				this.projectFieldOption.useNumberOfDependentChildren ||
				this.projectFieldOption.useNumberOfDisabledChildren ||
				this.projectFieldOption.useNumberOfDependentPerson ||
				this.projectFieldOption.useNumberOfDisabledPerson ||
				this.projectFieldOption.useAllergiesDetails
			);
		},
		isEmmergencyContactVisible() {
			return this.projectFieldOption.useContactName || this.projectFieldOption.useContactPhoneNumber;
		},
		isFamilySectionVisible() {
			return this.isFamilyCompositionVisible || this.isEmmergencyContactVisible;
		},
		isPersonnalVehicleSectionVisible() {
			return (
				this.projectFieldOption.useVehicleName ||
				this.projectFieldOption.useVehicleModel ||
				this.projectFieldOption.useVehicleBrand ||
				this.projectFieldOption.useVehiclePlateNumber ||
				this.projectFieldOption.useVehicleTransportationMean ||
				this.projectFieldOption.useVehicleTransportationMeanDetail ||
				this.projectFieldOption.usePower ||
				this.projectFieldOption.useGrayCardFrontPicture ||
				this.projectFieldOption.useGrayCardBackPicture
			);
		},
		isPrivacyOptionsVisible() {
			return this.projectFieldOption.showMyEmailInCrewList || this.projectFieldOption.showMyPhoneInCrewList;
		},
		isLoyaltyCardsVisible() {
			return (
				this.projectFieldOption.useSncfLoyaltyCard ||
				this.projectFieldOption.useSncfDiscountCard ||
				this.projectFieldOption.useFlyingBlueCard ||
				this.projectFieldOption.useOtherAirlineCard
			);
		},
		isForeignVisible() {
			return (
				this.projectFieldOption.useResidencePermit ||
				this.projectFieldOption.useResidencePermitNumber ||
				this.projectFieldOption.useResidenceValidityEnd ||
				this.projectFieldOption.useWorkCard
			);
		},
		isMiscellanousVisible() {
			return this.projectFieldOption.usePseudonym || this.projectFieldOption.useGenericMentionProfessionalAssociation;
		},
		isRetirementVisible() {
			return this.projectFieldOption.useRetired;
		},
		isStudyVisible() {
			return this.projectFieldOption.useStudyLevel;
		},
		isClothesVisible() {
			return (
				this.projectFieldOption.useSize ||
				this.projectFieldOption.usePantSize ||
				this.projectFieldOption.useShoeSize ||
				this.projectFieldOption.useJacketSize ||
				this.projectFieldOption.useTshirtSize
			);
		},
		isOtherSectionVisible() {
			return (
				this.isPrivacyOptionsVisible ||
				this.isLoyaltyCardsVisible ||
				this.isForeignVisible ||
				this.isRetirementVisible ||
				this.isStudyVisible ||
				this.isMiscellanousVisible ||
				this.isClothesVisible
			);
		}
	},
	watch: {
		data: {
			handler(profile) {
				if (!isNil(profile)) {
					this.profile = this.formatInvalidDate(profile);

					// this.profile = profile;
					// console.log({ profile: this.profile });
					// this.profile = {
					// 	...this.profile,
					// 	vehicle: {
					// 		name: '',
					// 		brand: '',
					// 		model: '',
					// 		numberPlate: '',
					// 		type: null,
					// 		energy: null,
					// 		kgCoTwo: ''
					// 	}
					// };
				}
			},
			immediate: true,
			deep: true
		},
		'profile.picture'(picture) {
			this.$store.dispatch('setAuthUser', { picture });
		},
		selectedUserData: {
			handler(value) {
				if (!isNil(value)) {
					this.roleUserData = value;
					this.roleUserData.isAdmin = this.roleUserData.canAccessMyBudget;
					if (this.roleUserData.canAccessUsers && this.roleUserData.canAccessBudget && this.roleUserData.canAccessOnboarding) {
						this.roleUserData.isProd = true;
					}
				}
			},
			immediate: true,
			deep: true
		}
	},
	created() {
		this.getDepartment();
		this.projectID = parseInt(store.projectID(), 10);
		this.GetEncodingValidation();
		this.initCountry();
		// console.log('profile', this.profile);
	},
	async mounted() {
		await this.reloadData();
		this.customFields = await this.customFieldList();
		this.$nextTick(() => {
			this.haveAllergies = this.profile.allergies !== '';
			this.haveDependents = parseInt(this.profile.numberOfDependentPerson) > 0 || parseInt(this.profile.numberOfDisabledPerson) > 0;
			this.haveChild = parseInt(this.profile.numberOfDependentChild) > 0 || parseInt(this.profile.numberOfDisabledChild) > 0;
		});
	},
	methods: {
		...mapActions({
			setMyProfile: 'profile/setMyProfile',
			getNotifications: 'header/getNotifications'
		}),
		async handleVehiculeFormChange(payload, isImage) {
			this.profile.vehicule = {
				...this.profile.vehicule,
				...payload
			};

			if (isImage === true) {
				try {
					await updatePictureVehicule({ vehicule: payload });
					await this.setMyProfile({ ...this.getMyProfile, vehicule: payload });
					this.successModal = true;
				} catch (error) {
					this.erreur = error;
				} finally {
					this.isLoading = false;
				}
			}
		},
		handleChangeWorkDisability(value, field) {
			this.profile[field] = value;
			//this.$emit('put-user', { field, value });
		},
		handleChangeRetired(value) {
			if (!value) {
				this.profile['retirementDate'] = null;
			}
			this.handleChangeUser(value, 'retired');
		},
		handleChangeUser(value, field) {
			this.profile[field] = value;
			this.$emit('put-user', { field, value });
		},
		handleChangeDate(value, field) {
			const isValidDate = (dateString) => {
				const date = new Date(dateString);
				return !isNaN(date.getTime());
			};
			const dateValid = isValidDate(value);
			if (dateValid) {
				const payload = { id: new Date(value) };
				this.profile[field] = payload.id;
				//this.$emit('set-user-item', { payload, field });
			} else {
				this.profile[field] = null;
				const payload = null;
				//this.$emit('set-user-item', { payload, field });
			}
			this.handleUserEntryLevelChange();
		},
		handleInputCalendar(payload, field) {
			const activeDateNow = moment(this.profile[field]).format('YYYY-MM-DD');
			const id = payload.id;
			if (activeDateNow === id) {
				this.profile[field] = new Date(payload.id);
			} else {
				this.profile[field] = null;
			}
			//this.$emit('set-user-item', { payload, field });
			this.handleUserEntryLevelChange();
		},
		isDateValid(field) {
			const obj = {};
			const invalidDate = '0001-01-01T00:00:00Z';
			const invalidSubstring = 'T00:00:00Z';
			const value = this.profile[field];

			if (_.isNil(value) || value === invalidDate || value === invalidSubstring || value.length <= 0) {
				obj[field] = false;
			} else {
				obj[field] = true;
			}

			return obj;
		},
		isMandatory(field) {
			return this.projectFieldOption[`mandatory${field}`];
		},
		checkFile(file) {
			if (file !== undefined) {
				let extension = file.toString().match(/.pdf/gi);
				if (extension !== null && extension.join`` === '.pdf') {
					return true;
				}
				return false;
			}
			return false;
		},
		/**
		 * @param  {!String} iban
		 */
		handleSupplierIbanChange(payload, fieldName) {
			this.userBankWarning[fieldName] = !isValidIBANNumber(payload);
			this.handleUserEntryLevelChange();
		},
		/**
		 * @param  {!String} bic
		 */
		handleSupplierBicChange(payload, fieldName) {
			this.userBankWarning[fieldName] = !isBic(payload);
			this.handleUserEntryLevelChange();
		},
		handleUserEntryLevelChange() {
			let payload = {
				po: this.userEntryLevel.po,
				timeSheets: this.userEntryLevel.timeSheets,
				expenses: this.userEntryLevel.expenses,
				invoice: this.userEntryLevel.invoice,
				department: [],
				userId: this.profile.id,
				projectId: this.projectID
			};
			this.selectedDepartment.forEach((dep) => {
				if (dep) payload.department.push(dep.value);
			});
			this.$emit('change', payload);
		},
		async GetEncodingValidation() {
			await GetEncodingValidation(this.projectID, this.profile.id).then((result) => {
				if (result) {
					this.userEntryLevel = Object.assign({}, result);
					this.checkDepartment(result.department, true);
				}
			});
		},
		handleDynamicAddressChange(payload) {
			this.profile.socialSecurityCenterAddressId = +payload.id;
		},
		handleDynamicAddressDelete() {
			this.profile.socialSecurityCenterAddressId = 0;
		},
		handleAddressMapLinkChange(payload) {
			console.log({ mapAddress: payload });
		},
		onOpenUrl(url) {
			return window.open(url);
		},
		checkFile(file) {
			if (file !== undefined) {
				let extension = file.toString().match(/.pdf/gi);
				if (extension !== null && extension.join`` === '.pdf') {
					return true;
				}
				return false;
			}
			return false;
		},
		checkDepartment(value, created) {
			this.allDepartements.forEach((item) => {
				item.selected = false;
			});
			value.forEach((item1) => {
				if (item1.value === -1) {
					this.selectedDepartment = [this.allDepartements[0]];
					this.allDepartements.forEach((item) => {
						item.selected = true;
					});
				} else {
					const found = this.allDepartements.find((item2) => item1.value === item2.value);
					if (found) {
						found.selected = true;
						if (created) {
							this.selectedDepartment.push(found);
						}
					}
				}
			});
			this.handleUserEntryLevelChange();
		},
		mapDepartments(deps) {
			deps = deps.filter((d) => d.value !== 0);
			const departments = deps.map((d) => ({
				value: d.value,
				text: d.message,
				selected: false
			}));
			return departments;
		},
		async getDepartment() {
			this.allDepartements = [];
			let Deps = [];
			Deps.push(Object.assign({}, this.allDeps));
			Deps[0].message = this.FormMSG(201, 'All departments');
			await getDepartments(false, false).then((result) => {
				Deps = [...Deps, ...result];
				this.allDepartements = this.mapDepartments(Deps);
			});
		},
		handleSocSecNumberChange(value) {
			// if (isNil(value) || value.trim().length === 0) return;
			// this.isSocSecNumberWarning = !isSecuritySocialNumberValid(value);
			this.isSocSecNumberWarning = _.isNil(value);
			this.handleChangeUser(value, 'socSecNumber');
		},
		handleAutoComplete(addressData, field) {
			if (field === 'legalAddress') {
				this.profile.address = {
					...this.profile.address,
					street: addressData.route || addressData.place.name,
					city: addressData.locality,
					number: addressData.street_number,
					state: addressData.administrative_area_level_1,
					zip: addressData.postal_code,
					country: addressData.country,
					countryCode: addressData.country_code,
					countryKey: convertIsoToKey(addressData.country_code),
					lat: addressData.latitude,
					lng: addressData.longitude
				};
			}
			if (field === 'postalAddress') {
				this.profile.postalAddress = {
					...this.profile.postalAddress,
					street: addressData.route || addressData.place.name,
					city: addressData.locality,
					number: addressData.street_number,
					state: addressData.administrative_area_level_1,
					zip: addressData.postal_code,
					country: addressData.country,
					countryCode: addressData.country_code,
					countryKey: convertIsoToKey(addressData.country_code),
					lat: addressData.latitude,
					lng: addressData.longitude
				};
			}
		},
		getCountry() {
			const country = getObjectFromValue(this.countryCodes, 'value', this.countryKey);
			const newCountryKey = country ? convertIsoToKey(country.text) : '';
			this.countryCode = country ? country.text.toLowerCase() : '';
			this.profile.address = this.reinitializeAddressData(country, newCountryKey, this.countries);
			if (this.$refs['google-search-address']) {
				this.clearLegalAddress = true;
				this.$nextTick(() => {
					this.clearLegalAddress = false;
				});
			}
		},
		getCountryPostalAddress() {
			const country = getObjectFromValue(this.countryCodes, 'value', this.countryKeyPostalAddress);
			const newCountryKey = country ? convertIsoToKey(country.text) : '';
			this.countryCodePostalAddress = country ? country.text.toLowerCase() : '';
			this.profile.postalAddress = this.reinitializeAddressData(country, newCountryKey, this.countries);
			if (this.$refs['google-search-address']) {
				this.clearPostalAddress = true;
				this.$nextTick(() => {
					this.clearPostalAddress = false;
				});
			}
		},
		updateDate($event, field) {
			if (this.profile[field].startsWith('T')) {
				this.profile[field] = $event + this.profile[field];
			} else {
				this.profile[field] = $event + this.profile[field].substring(10);
			}
		},
		initCountry() {
			let project = null;

			if (isNil(store.state) || isNil(store.getCurrentProjectConfig())) {
				project = store.getCurrentProjectConfig();
			}

			if (!isNil(this.profile) && !isNil(this.profile.address) && this.profile.address.countryKey > 0) {
				this.countryKey = this.profile.address.countryKey;
				this.countryCode = this.profile.address.countryCode;
			} else if (!isNil(project) && !isNil(project.legalEntity) && !isNil(project.legalEntity.address) && project.legalEntity.address.countryKey > 0) {
				this.countryKey = project.legalEntity.address.countryKey;
				this.countryCode = project.legalEntity.address.countryCode;
			}
			if (!isNil(this.profile.postalAddress) && this.profile.postalAddress.countryKey > 0) {
				this.countryKeyPostalAddress = this.profile.postalAddress.countryKey;
				this.countryCodePostalAddress = this.profile.postalAddress.countryCode;
			}
			if (this.profile.postalAddressID !== 0) {
				this.isShowPostalAddress = true;
			} else {
				this.isShowPostalAddress = false;
			}
		},
		async addOrUpdateValidation(userId, departmentNumber, levelTs, levelPo, levelExp, levelInvoice) {
			const replace = true;
			const projectId = parseInt(store.projectID(), 10);
			await validate({
				userId,
				departmentNumber,
				levelTs,
				levelPo,
				levelExp,
				levelInvoice,
				projectId,
				replace
			})
				.then((result) => {
					//console.log("saved:", result)
					this.createToastForSuccess();
				})
				.catch((error) => {
					this.erreur = error;
				});
			if (this.getMyProfile && +this.getMyProfile.id === +userId) await this.getNotifications(); // refresh header Notification bell.
		},
		manageValidationChange(item) {
			// console.log('in manageValidationChange, item:', item);
			this.addOrUpdateValidation(
				parseInt(item.id),
				parseInt(item.department),
				parseInt(item.validationLevel),
				parseInt(item.validationLevel),
				parseInt(item.validationLevel),
				parseInt(item.validationLevel)
			);
		},
		async manageCanAccessMyBudgetChange(value, item, showToast = true) {
			try {
				await addUpdAccessMyBudget({
					userId: item.id,
					canAccessMyBudget: value
				});

				item.canAccessMyBudget = value;
				if (showToast) {
					this.createToastForSuccess();
				}
			} catch (error) {
				this.erreur = error;
			}
		},
		async manageCanAccessBudgetChange(value, item, showToast = true) {
			try {
				await addUpdAccessBudget({
					userId: item.id,
					canAccessBudget: value
				});

				item.canAccessBudget = value;
				if (showToast) {
					this.createToastForSuccess();
				}
			} catch (error) {
				this.erreur = error;
			}
		},
		async manageCanAccessUsersChange(value, item, showToast = true) {
			try {
				await addUpdAccessUsers({
					userId: item.id,
					canAccessUsers: value
				});

				item.canAccessUsers = value;
				if (showToast) {
					this.createToastForSuccess();
				}
			} catch (error) {
				this.erreur = error;
			}
		},
		createToastForSuccess() {
			this.createToastForMobile('Success', this.FormMSG(267, 'Update permissions successfully'), '', 'success');
		},
		async manageProdChange(value, item) {
			try {
				await addUpdProdFromProject({
					userId: item.id,
					isProd: value
				});

				item.canAccessUsers = value;
				await this.manageCanAccessUsersChange(value, item, false);

				item.canAccessBudget = value;
				await this.manageCanAccessBudgetChange(value, item, false);

				item.isProd = value;
				this.createToastForSuccess();
			} catch (error) {
				this.erreur = error;
			}
		},
		async manageAdminChange(value, item) {
			try {
				await addUpdAdminToProject({
					userId: item.id,
					isAdmin: value
				});
				item.canAccessMyBudget = value;
				await this.manageCanAccessMyBudgetChange(value, item, false);

				item.isAdmin = value;
				this.createToastForSuccess();
			} catch (error) {
				this.erreur = error;
			}
		},
		// async initProfile() {
		//     this.profile = await profile();
		// },
		handleValidationCodeModalSave() {
			this.$router.push('/password');
		},
		async handleChangePassword() {
			this.statusSendCodeValidation.global = true;
			this.statusSendCodeValidation.progress = true;

			setTimeout(() => {
				this.statusSendCodeValidation.progress = false;
				this.statusSendCodeValidation.success = true;
				this.showValidationCodeModal = true;
			}, 100);
		},
		handleValidationCodeModalClose() {
			this.showValidationCodeModal = false;
			this.codeValidation = '';
			this.statusSendCodeValidation.global = false;
			this.statusSendCodeValidation.progress = false;
			this.statusSendCodeValidation.success = false;
		},
		async handlePhoneModalSave(payload) {
			const newPhone = payload.newPhoneE164;

			try {
				await updatePhoneProfile(newPhone);
				await this.setMyProfile({ ...this.getMyProfile, phone: newPhone });
				store.state.profile.phone = newPhone;
				this.profile.phone = newPhone;
				if (this.$screen.width <= 567) {
					this.menuActiveForMobile = '';
					this.createToastForMobile(this.FormMSG(93, 'Profile updated successfully'), '', '');
				} else {
					this.createToastForMobile(this.FormMSG(95, 'Success'), this.FormMSG(94, 'Profile updated successfully'), '', 'success');
				}
			} catch (e) {
				this.erreur = e;
			}

			// const mutation = gql`
			// 	mutation UPD_MY_PROFILE($phone: String) {
			// 		UpdMyProfile(newProfile: { phone: $phone })
			// 	}
			// `;
			// this.$apollo
			// 	.mutate({
			// 		mutation,
			// 		variables: {
			// 			phone: newPhone
			// 		}
			// 	})
			// 	.then((result) => {
			// 		store.state.profile.phone = newPhone;
			// 		this.profile.phone = newPhone;
			// 		if (this.$screen.width <= 567) {
			// 			this.menuActiveForMobile = '';
			// 			this.createToastForMobile(this.FormMSG(93, 'Profile updated successfully'), '', '');
			// 		} else {
			// 			this.$toast({
			// 				message: this.FormMSG(94, 'Profile updated successfully'),
			// 				title: this.FormMSG(95, 'Success'),
			// 				variant: 'success'
			// 			});
			// 		}
			// 	})
			// 	.catch((e) => {
			// 		this.erreur = e;
			// 	});
		},
		async handleMailModalSave(payload) {
			const newEmail = payload.newEmail;

			try {
				await updateEmailProfile(newEmail);
				await this.setMyProfile({ ...this.getMyProfile, email: newEmail });
				store.state.profile.email = newEmail;
				this.profile.email = newEmail;
				if (this.$screen.width <= 567) {
					this.menuActiveForMobile = '';
				}
				this.createToastForMobile(this.FormMSG(96, 'Profile updated successfully'), '', '');
			} catch (e) {
				this.erreur = e;
			}

			// const mutation = gql`
			// 	mutation UPD_MY_PROFILE($email: String) {
			// 		UpdMyProfile(newProfile: { email: $email })
			// 	}
			// `;
			// this.$apollo
			// 	.mutate({
			// 		mutation,
			// 		variables: {
			// 			email: newEmail
			// 		}
			// 	})
			// 	.then((result) => {
			// 		store.state.profile.email = newEmail;
			// 		this.profile.email = newEmail;
			// 		if (this.$screen.width <= 567) {
			// 			this.menuActiveForMobile = '';
			// 			this.createToastForMobile(this.FormMSG(96, 'Profile updated successfully'), '', '');
			// 		} else {
			// 			this.$toast({
			// 				message: this.FormMSG(97, 'Profile updated successfully'),
			// 				title: this.FormMSG(98, 'Success'),
			// 				variant: 'success'
			// 			});
			// 		}
			// 	})
			// 	.catch((e) => {
			// 		this.erreur = e;
			// 	});
		},
		incrementValue(data) {
			let value = parseInt(this.profile[data]);
			this.profile[data] = value + 1;
		},
		decrementValue(data) {
			let value = parseInt(this.profile[data]);
			if (value > 0) {
				this.profile[data] = value - 1;
			}
		},
		handleChangeHaveAllergies(payload) {
			if (!payload) {
				this.profile.allergies = '';
			}
		},
		handleChangeHaveDependents(payload) {
			if (!payload) {
				this.profile.numberOfDependentPerson = 0;
				this.profile.numberOfDisabledPerson = 0;
			}
		},
		handleChangeHaveChild(payload) {
			if (!payload) {
				this.profile.numberOfDependentChild = 0;
				this.profile.numberOfDisabledChild = 0;
			}
		},
		getIconLucide(name) {
			return icons[name];
		},
		handleMenuMobileClick(payload) {
			this.menuActiveForMobile = payload;
		},
		updateBirthDate: function ($event) {
			if (this.profile.birthDate.startsWith('T')) {
				this.profile.birthDate = $event + this.profile.birthDate;
			} else {
				this.profile.birthDate = $event + this.profile.birthDate.substring(10);
			}
		},
		updateSpouseBirthDate($event) {
			this.profile.spouseBirthDate = $event;
			if (this.profile.spouseBirthDate.startsWith('T')) {
				this.profile.spouseBirthDate = $event + this.profile.spouseBirthDate;
			} else {
				this.profile.spouseBirthDate = $event + this.profile.spouseBirthDate.substring(10);
			}
		},
		enableSaveButton() {
			this.disableSaveButton = false;
		},
		startCapture: function () {
			// initialise global store variable and open dialog to capture and crop
			//console.log("instartcapture");
			store.state.capturedImage = '';
			store.state.imageCropped = '';
			this.disableSaveButton = true;
			this.capturePict = true;
		},
		cancelCapture() {
			store.state.capturedImage = '';
			// stop camera
			this.$refs.CaptCompo.onStop();
			this.capturePict = false;
		},
		endCapture: function (item) {
			// stop camera
			this.$refs.CaptCompo.onStop();
			// copy store image name into profile data
			this.capturePict = false;
			// start cropping if image was captured
			if (store.state.capturedImage.length > 0) {
				// an image was captured
				// console.log("in End capture");
				store.state.imageToCrop = store.state.capturedImage;
				this.$refs.myCropPicture.bind(); // force the component to link the new image to the display
				this.cropPict = true;
			}
		},
		endCrop: function (item) {
			// save image to server
			//console.log("this.$refs.myCropPicture.cropped:",this.$refs.myCropPicture.cropped);
			if (store.state.imageCropped.length > 0) {
				this.saveImage(store.state.imageCropped);
			}
			this.cropPict = false;
		},
		endCropCancel: function (item) {
			store.state.imageCropped = '';
			this.cropPict = false;
		},
		b64toFile(b64Data, filename, contentType) {
			var sliceSize = 512;
			var byteCharacters = atob(b64Data);
			var byteArrays = [];
			for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
				var slice = byteCharacters.slice(offset, offset + sliceSize);
				var byteNumbers = new Array(slice.length);

				for (var i = 0; i < slice.length; i++) {
					byteNumbers[i] = slice.charCodeAt(i);
				}
				var byteArray = new Uint8Array(byteNumbers);
				byteArrays.push(byteArray);
			}
			var file = new File(byteArrays, filename, {
				type: contentType
			});
			return file;
		},
		async saveImage(imgData) {
			this.isLoading = true;
			var retStr = '';
			// remove header data:image...
			// var base64Data = imgData.replace(/^data:image\/jpeg;base64,/, '');
			// // create in memory file
			// var fil = this.b64toFile(base64Data, 'test.jpg', 'jpg');
			const fil = await reScalingImgWithCanvas(imgData);
			let formData = new FormData(); // instantiate it
			// suppose you have your file ready
			formData.set('uploadimage', fil);
			var config = {
				headers: {
					Authorization: `Bearer ${store.state.token}`,
					'content-type': 'multipart/form-data'
				}
			};
			var urlStr = process.env.VUE_APP_GQL + '/upload';
			axios
				.post(urlStr, formData, config)
				.then((response) => {
					retStr = response.data;
					this.profile.picture = retStr;
					store.state.imageCropped = '';
					this.updateUserPictureName();
					this.isLoading = false;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => (this.isLoading = false));
			return retStr;
		},
		removeImage() {
			this.isLoading = true;
			//console.log("inremoveimage:",this.pdfFile.name);
			var retStr = '';
			let formData = new FormData(); // instantiate it
			formData.append('fileName', this.pdfFile.name);
			var config = {
				headers: {
					Authorization: `Bearer ${store.state.token}`,
					'content-type': 'multipart/form-data'
				}
			};
			var urlStr = process.env.VUE_APP_GQL + '/removedocument';
			axios
				.post(urlStr, formData, config)
				.then((response) => {
					retStr = response.data;
					this.isLoading = false;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => (this.isLoading = false));
			return retStr;
		},
		async updateUserPictureName() {
			this.errors = [];
			this.isLoading = true;

			try {
				await updatePictureProfile(this.profile.picture);
				await this.setMyProfile({ ...this.getMyProfile, picture: this.profile.picture });
				this.successModal = true;
			} catch (error) {
				this.erreur = error;
			} finally {
				this.isLoading = false;
			}
		},
		async submitFile() {
			// console.log("submit file:", this.pdfFile);
			let formData = new FormData();
			formData.append('uploadimage', this.pdfFile);
			formData.append('fileName', this.pdfFile.name);
			formData.append('fileType', this.pdfFile.type);

			const urlStr = process.env.VUE_APP_GQL + '/upload';

			await axios
				.post(urlStr, formData, {
					headers: {
						Authorization: `Bearer ${store.state.token}`,
						'Content-Type': 'multipart/form-data'
					}
				})
				.then((result) => {
					//console.log("success result:", result);
				})
				.catch(function () {
					console.log('FAILURE!!');
				});
		},
		/**
		 * @param {Array} imgs
		 */
		handleImgsTaked(imgs) {
			const retStr = imgs[0];
			this.profile.picture = retStr;
			store.state.imageCropped = '';
			this.updateUserPictureName();
			this.isLoading = false;
			this.refreshTokenCaptureItem = this.refreshTokenCaptureItem + 1;
		},
		handleClickHeader(key) {
			this.configAccordion[key].isVisible = !this.configAccordion[key].isVisible;
		},
		getImage(picture, fieldName = '') {
			if (!isNil(picture) && picture.length > 0) {
				if (fieldName === 'pictureId') {
					this.imgPropPictureId.blank = false;
				} else if (fieldName === 'pictureIdVerso') {
					this.imgPropPictureIdVerso.blank = false;
				} else if (fieldName === 'pictureDriverLicense') {
					this.imgPropPictureDriverLicense.blank = false;
				} else if (fieldName === 'pictureDriverLicenseVerso') {
					this.imgPropPictureDriverLicenseVerso.blank = false;
				} else if (fieldName === 'signatureId') {
					this.imgPropSignatureId.blank = false;
				}
			}
			return process.env.VUE_APP_GQL + '/images/' + picture;
		},
		showImage(picture) {
			if (isNil(picture) || (!isNil(picture) && picture.length === 0)) return;
			this.imgToShow = `${process.env.VUE_APP_GQL}/images/${picture}`;
			this.openPictureModal = true;
		},
		async handleChangedAppRight(payload, fieldName) {
			if (fieldName === 'isAdmin' || fieldName === 'canAccessMyBudget') {
				if (fieldName === 'isAdmin') {
					this.roleUserData.canAccessMyBudget = payload;
					await this.handleAccessLevel(this.canAccessMyBudget, payload, this.roleUserData, this.screenAccess);
				}
				if (fieldName === 'canAccessMyBudget') {
					this.roleUserData.isAdmin = payload;
					await this.handleAccessLevel(this.canAccessMyBudget, payload, this.roleUserData, this.screenAccess);
				}
			} else if (fieldName === 'isProd') {
				this.roleUserData.canAccessUsers = payload;
				await this.handleAccessLevel(this.canAccessUsers, payload, this.roleUserData, this.screenAccess);
				this.roleUserData.canAccessBudget = payload;
				await this.handleAccessLevel(this.canAccessBudget, payload, this.roleUserData, this.screenAccess);
				this.roleUserData.canAccessOnboarding = payload;
				await this.handleAccessLevel(this.canAccessOnboarding, payload, this.roleUserData, this.screenAccess);
			} else if (fieldName === 'canAccessUsers' || fieldName === 'canAccessBudget' || fieldName === 'canAccessOnboarding') {
				if (fieldName === 'canAccessUsers') {
					await this.handleAccessLevel(this.canAccessUsers, payload, this.roleUserData, this.screenAccess);
					if ((payload && !this.roleUserData.isProd) || (!payload && !this.roleUserData.canAccessBudget && !this.roleUserData.canAccessOnboarding)) {
						this.roleUserData.isProd = payload;
					}
				}
				if (fieldName === 'canAccessBudget') {
					await this.handleAccessLevel(this.canAccessBudget, payload, this.roleUserData, this.screenAccess);
					if ((payload && !this.roleUserData.isProd) || (!payload && !this.roleUserData.canAccessUsers && !this.roleUserData.canAccessOnboarding)) {
						this.roleUserData.isProd = payload;
					}
				}
				if (fieldName === 'canAccessOnboarding') {
					await this.handleAccessLevel(this.canAccessOnboarding, payload, this.roleUserData, this.screenAccess);
					if ((payload && !this.roleUserData.isProd) || (!payload && !this.roleUserData.canAccessUsers && !this.roleUserData.canAccessBudget)) {
						this.roleUserData.isProd = payload;
					}
				}
			}
		},
		async reloadData() {
			await getProjectFieldOption().then((res) => {
				if (res) {
					this.projectFieldOption = res;
					// console.log(res);
				}
			});
		},
		async customFieldList() {
			let items = await getCustomFields({ type: this.defaultUserCustomFieldParentType, userId: +this.profile.id });

			return items.map((item, index) => {
				const prefixModel = 'custom-field-model-',
					prefixNameGroup = 'custom-field-name-group-';
				const model = generateSecureId(prefixModel + item.id);
				const nameGroup = generateSecureId(prefixNameGroup + item.id);
				const customFieldValues = item.customFieldValues;

				let value = null,
					ids = null;

				switch (+item.type) {
					case CUSTOM_FIELD_TYPE.Checkbox:
						value = [];
						if (customFieldValues.length > 0) {
							ids = [];
							for (const customFieldValue of customFieldValues) {
								ids.push(+customFieldValue.customFieldMenuChoiceValue);
							}
							value = ids;
						}

						break;
					case CUSTOM_FIELD_TYPE.Date:
						// value = moment().format('YYYY-MM-DD');
						value = null;
						if (customFieldValues.length > 0) {
							value = moment(customFieldValues[0].value).format('YYYY-MM-DD');
						}

						break;
					case CUSTOM_FIELD_TYPE.Dropdown:
						value = null;
						if (customFieldValues.length > 0) {
							value = customFieldValues[0].customFieldMenuChoiceValue.toString();
						}

						break;
					case CUSTOM_FIELD_TYPE.Freetext:
						value = null;
						if (customFieldValues.length > 0) {
							value = customFieldValues[0].value;
						}

						break;
					case CUSTOM_FIELD_TYPE.Number:
						value = 0;
						if (customFieldValues.length > 0) {
							value = customFieldValues[0].value;
						}

						break;
					case CUSTOM_FIELD_TYPE.Percentage:
						value = 0;
						if (customFieldValues.length > 0) {
							value = customFieldValues[0].value;
						}

						break;
					case CUSTOM_FIELD_TYPE.Radiobutton:
						value = null;
						if (customFieldValues.length > 0) {
							value = +customFieldValues[0].customFieldMenuChoiceValue;
						}

						break;
				}

				this.customFieldModels[index] = model;

				item = {
					...item,
					[model]: value,
					nameGroup
				};

				return item;
			});
		},
		manageUserCustomFields() {
			this.isUserCustomFieldModalOpen = true;
		},
		formatInvalidDate(profile) {
			let obj = profile;
			for (let key in obj) {
				if (typeof obj[key] !== 'object' || !isNil(obj[key])) {
					const isCheckDate = obj[key].toString().includes('0001-01-01T00:00:00Z');
					const shouldSetToNullForMinusOne = this.profileFieldsSetToNull.includes(key) && obj[key] === -1;

					if (isCheckDate || shouldSetToNullForMinusOne) {
						obj[key] = null;
					} else {
						obj[key] = obj[key];
					}
				}
			}
			return obj;
		},
		onUserCustomFieldMainModalClosed() {
			this.isUserCustomFieldModalOpen = false;
		},
		sizeFlagInput(length) {
			let size = 3;

			// if (length >= 4) {
			// 	size = 3;
			// }

			return size;
		},
		async onUserCustomFieldMainModalReloaded() {
			this.customFields = await this.customFieldList();
		},
		onFieldTemplateChanged(payload) {
			// console.log({ userPayload: payload });
			const findIndex = this.customFieldValueInputs.findIndex((customFieldValue) => +customFieldValue.index === +payload.index);
			let value = null;

			if (payload.type === CUSTOM_FIELD_TYPE.Checkbox) {
				value = payload[this.customFieldModels[payload.index]].join(',');
			} else {
				value = payload[this.customFieldModels[payload.index]].toString();
			}

			const customFieldValue = {
				index: payload.index,
				userId: +this.profile.id,
				customFieldId: +payload.customFieldId,
				value
				// customFieldValueId: 0
			};

			if (findIndex === -1) {
				this.customFieldValueInputs.push(customFieldValue);
			} else {
				this.customFieldValueInputs[findIndex] = {
					...this.customFieldValueInputs[findIndex],
					...customFieldValue
				};
			}
			// console.log({ userCustomFieldValueInputs: this.customFieldValueInputs });
			this.$emit('memo-profile:user-custom-field-value', this.customFieldValueInputs);

			this.customFields = this.customFields.map((customField, index) => {
				if (+customField.id === +payload.id) {
					customField = {
						...payload
					};
				}

				return customField;
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.custom-control-input:disabled ~ .custom-control-label {
	color: rgba(6, 38, 62, 0.74) !important;
}
.profile-picture-preview {
	margin-top: 0.8rem;
	width: 175px;
	height: 175px;
	object-fit: cover;
	border-radius: 50%;
}
.required {
	color: red;
}
</style>
